// src/lang/zh_CN.js
export default {
  header: {
    // --- PC 端原有 Key (保持不变) ---
    home: '首页',
    productCenter: '产品中心',
    softwareProducts: '软件产品',
    hardwareProducts: '硬件产品',
    
    // 软件产品子菜单 (PC端完整版)
    weldingSoftware: '焊接软件',
    intelligentWeldingCloud: '智能焊接云系统(ICLOUDWELD)',
    pressureVesselSystem: '压力容器焊接管理系统(VMES)',
    steelStructureSystem: '钢结构焊接管理系统(SMES)',
    smartTrainingSystem: '智慧焊培管理系统(TMES)',
    pipingWeldingSystem: '管道焊接管理系统(PMES)',
    
    professionalSoftware: '专业软件',
    weldingProcessSystem: '焊接工艺管理系统(WPMS)',
    welderInfoSystem: '焊工信息管理系统(WIMS)',
    weldingMaterialSystem: '焊接资源管理系统(WRMS)',
    seamTrackingSystem: '智能焊缝跟踪系统(WTMS)',
    videoSystem: '智能焊接视讯系统 (WVMS)',
    robotSystem: '智能焊接机器人系统(ICLOUDROBOT)',
    
    mobileSoftware: '移动软件',
    palmGroupControl: '掌上群控(WELDKEY)',
    palmWelder: '掌上焊机(WELDPANEL)',
    palmOps: '掌上运维(WELDTOOL)',
    wechatMiniProgram: '奥太微群控小程序(WELDCHAT)',
    dataLibraryMiniProgram: '奥太资料库小程序(ATDL)',
    
    // 硬件产品子菜单 (PC端完整版)
    intelligentTerminal: '智能终端',
    dataCollector: '焊接数据采集仪ATQ-CJ500系列',
    smartTerminal: '智能焊接终端ATQ-IT070',
    cloudPreTerminal: '焊接云前置终端AD-1900',
    robotControlTerminal: '机器人焊接系统控制终端RWSC',
    handheldTerminal: '焊接云手持终端AD-70',
    handheldPad: '焊接云手持平板PAD-80',
    
    industrialGateway: '焊接工业互联网网关',
    commController4GExt: '通信控制器4G外置ATQ-RS422/4G',
    commController4GInt: '通信控制器4G内置ATQ-GW-DWL',
    commControllerWifiExt: '通信控制器WIFI外置ATQ-RS422/WF-II',
    commControllerWifiInt: '通信控制器WIFI内置ATQ-GW-WF801',
    commController5G: '通信控制器5G内置ATQ-RS422-5G',
    commControllerMulti: '通讯控制器多功能网关内置ATQ-RS422-4G-IV',
    
    robotGateway: '焊接机器人网关',
    robotCommATR485: '通信控制器ATR-485-Ⅱ',
    robotCommATRCAN: '通信控制器ATR-CAN-Ⅱ',
    robotCommATRCANOPEN: '通信控制器ATR-CANOPEN',
    robotCommATRDEV: '通信控制器ATR-DEV-Ⅳ',
    robotCommATREtherCAT: '通信控制器ATR-EtherCAT',
    robotCommATRPROFINET: '通信控制器ATR-PROFINET',
    robotGatewayDevice: '机器人网关ATR-GATEWAY',
    robotGatewayEIP: '机器人网关ATR-GW-EIP',
    
    otherDevices: '其他设备',
    handheldProcessTerminal: '焊接工艺手持终端ATQ-SR',
    gasFlowMeter: '气体流量计ATQ-GFS50',
    cardReader: '读卡器ATQ-NFC',
    
    solution: '解决方案',
    caseStudies: '应用案例',
    
    // 应用案例子菜单
    pressureVesselIndustry: '压力容器行业',
    shandongPressureClient: '山东某压力客户',
    liaoningDalianClient: '辽宁大连某客户',
    
    machineryIndustry: '机械制造行业',
    guangdongMachineryClient: '广东某机械外企',
    
    trainingIndustry: '焊培行业',
    shandongNuclearTraining: '山东某核电培训企业',
    guangxiWeldingSchool: '广西某焊机培训学校',
    
    coalMachineIndustry: '煤机行业',
    henanCoalClient: '河南某煤机企业',
    guizhouCoalClient: '贵州某煤机企业',
    
    steelStructureIndustry: '钢结构行业',
    jiangsuSteelClient: '江苏某钢结构企业',
    
    pipingIndustry: '管道行业',
    hebeiPipingClient: '河北某管道企业',
    sichuanPipingClient: '四川某管道企业',
    
    shipbuildingIndustry: '船舶行业',
    dalianShipClient: '大连某船舶企业',
    
    news: '新闻资讯',
    resourceCenter: '资源中心',
    downloads: '资料下载',
    industryStandards: '行业标准',
    welderTips: '焊工小知识',
    
    videoData: '视频资料',
    contactUs: '联系我们',
    
    // 右侧按钮提示
    officialWebsite: '企业官网',
    systemExperience: '系统体验',
    businessRegistration: '企业注册',
    aotaiCloudV1: '奥太云V1.0',
    aotaiCloudV2: '奥太云V2.0',
    loginV1: '登录V1.0',
    loginV2: '登录V2.0',
    login: '登陆',
    
    // 消息提示
    tempUnavailable: '暂时无法查看！',

    // --- 新增：移动端专用简略版 Key ---
    // 软件产品
    mb_weldingSoftware: '焊接软件',
    mb_intelligentWeldingCloud: '智能焊接云系统',
    mb_pressureVesselSystem: '压力容器焊接管理系统',
    mb_steelStructureSystem: '钢结构焊接管理系统',
    mb_smartTrainingSystem: '智慧焊培管理系统',
    mb_pipingWeldingSystem: '管道焊接管理系统',
    
    mb_professionalSoftware: '专业软件',
    mb_weldingProcessSystem: '焊接工艺管理系统',
    mb_welderInfoSystem: '焊工信息管理系统',
    mb_weldingMaterialSystem: '焊接资源管理系统',
    mb_seamTrackingSystem: '智能焊缝跟踪系统',
    mb_videoSystem: '智能焊接视讯系统',
    mb_robotSystem: '智能焊接机器人系统',
    
    mb_mobileSoftware: '移动软件',
    mb_palmGroupControl: '掌上群控',
    mb_palmWelder: '掌上焊机',
    mb_palmOps: '掌上运维',
    mb_wechatMiniProgram: '奥太微群控小程序',
    mb_dataLibraryMiniProgram: '奥太资料库小程序',

    // 硬件产品 (如果移动端也简化了硬件名称，可在此添加 mb_ 前缀的 Key，若硬件名称移动端与PC端一致则无需添加，直接复用原Key即可)
    // 此处假设硬件名称在移动端也去掉了部分冗余描述，若需简化请参照上方软件部分添加
    mb_intelligentTerminal: '智能终端',
    mb_dataCollector: '焊接数据采集仪ATQ-CJ500系列',
    mb_smartTerminal: '智能焊接终端ATQ-IT070',
    mb_cloudPreTerminal: '焊接云前置终端AD-1900',
    mb_robotControlTerminal: '机器人焊接系统控制终端RWSC',
    mb_handheldTerminal: '焊接云手持终端AD-70',
    
    mb_industrialGateway: '焊接工业互联网网关',
    mb_commController4GExt: '通信控制器ATQ-RS422/4G',
    mb_commController4GInt: '通信控制器ATQ-GW-DWL',
    mb_commControllerWifiExt: '通信控制器ATQ-RS422/WF-II',
    mb_commControllerWifiInt: '通信控制器ATQ-GW-WF801',
    mb_commController5G: '通信控制器ATQ-RS422-5G',
    mb_commControllerMulti: '多功能网关ATQ-RS422-4G-IV',
    
    mb_robotGateway: '焊接机器人网关',
    mb_robotCommATR485: '通信控制器ATR-485-Ⅱ',
    mb_robotCommATRCAN: '通信控制器ATR-CAN-Ⅱ',
    mb_robotCommATRCANOPEN: '通信控制器ATR-CANOPEN',
    mb_robotCommATRDEV: '通信控制器ATR-DEV-Ⅳ',
    mb_robotCommATREtherCAT: '通信控制器ATR-EtherCAT',
    mb_robotCommATRPROFINET: '通信控制器ATR-PROFINET',
    mb_robotGatewayDevice: '机器人网关ATR-GATEWAY',
    mb_robotGatewayEIP: '机器人网关ATR-GW-EIP',
    
    mb_otherDevices: '其他设备',
    mb_handheldProcessTerminal: '焊接工艺手持终端ATQ-SR',
    mb_gasFlowMeter: '气体流量计ATQ-GFS50',
    mb_cardReader: '读卡器ATQ-NFC',
    
    // 解决方案与资源中心 (通常标题较短，可直接复用，若需区分也可加 mb_)
    mb_solution: '解决方案',
    mb_caseStudies: '应用案例',
    mb_news: '新闻资讯',
    mb_resourceCenter: '资源中心',
    mb_downloads: '资料下载',
    mb_industryStandards: '行业标准',
    mb_welderTips: '焊工小知识',
    mb_videoData: '视频资料',
    mb_contactUs: '联系我们',
    mb_officialWebsite: '企业官网',
  },

  footer: {
  // ==================== 顶部体验区域 ====================
  footer_top_title: "奥太30年专业经验，5000+企业的信任之选！",
  footer_top_subtitle: "免费领取 90天奥太产品体验特权，开启您的焊接制造智能化升级",
  footer_top_btn: "申请体验",
  
  // ==================== 快捷入口 ====================
  footer_links_title: "快捷入口",
  // footer_links_about: "关于我们",
  // footer_links_product: "产品中心",
  // footer_links_news: "新闻资讯",
  footer_links_softwareProducts: "软件产品",
  footer_links_hardwareProducts: '硬件产品',
  footer_links_solution: '解决方案',
  footer_links_caseStudies: '应用案例',
  
  // ==================== 联系我们 ====================
  footer_contact_title: "联系我们",
  footer_contact_manager_wang: "王经理",
  footer_contact_manager_xu: "许经理",
  footer_contact_address: "济南市高新区伯乐路282号",
  
  // ==================== 二维码区域 ====================
  footer_qrcode_weldCloud: "山东奥太焊接云系统",
  footer_qrcode_groupControl: "掌上群控APP",
  footer_qrcode_operations: "掌上运维APP",
  footer_qrcode_miniProgram: "奥太微群控小程序",
  
  // ==================== 底部版权 ====================
  footer_copyright_company: "山东奥太电气有限公司",
  footer_copyright_text: "All rights reserved",
  footer_copyright_icp: "鲁ICP备15016186号-5",
},
  // --- 新增：首页 (Home) 国际化配置 (扁平化结构) ---
  home: {
    // Banner
    banner_cloud_title: '智能焊接云系统',
    banner_cloud_subtitle: 'iCloudWeld',
    banner_cloud_desc: '助力焊接企业数字化转型，打造焊接新模式',
    banner_vmes_title: '压力容器焊接管理系统',
    banner_vmes_subtitle: 'VMES',
    banner_vmes_desc: '让焊接企业工艺、焊接生产更高效监管协同',
    banner_smes_title: '钢结构焊接管理系统',
    banner_smes_subtitle: 'SMES',
    banner_smes_desc: '助力焊接企业优化焊接生产资料，降本增效',
    learn_more: '了解更多',

    // System Composition & Framework
    system_composition_tagline: 'SYSTEM COMPOSITION',
    system_composition_title: '奥太智能焊接云系统组成',
    system_composition_desc: '从企业全业务场景的管理需求入手，围绕焊接工艺协同、焊接设备监控、焊工资质认证、焊接工单管控、生产资源调度、焊接成本控制，构建新型焊接生产模式，全面提升企业整体焊接管理水平。',
    system_framework_tagline: 'SYSTEM FRAMEWORK',
    system_framework_title: '系统架构',
    
    // Architecture Points
    arch_equipment_label: '车间设备',
    arch_equipment_desc: '支持奥太及其它品牌的焊机入网；',
    arch_network_label: '网络传输',
    arch_network_desc: '支持4G/5G移动网络、WIFI、有线等多种方式，满足企业多样的联网需求；',
    arch_app_label: '系统应用',
    arch_app_desc: '实现人、机、料、法、环、测全面管理，构建高效的系统化焊接管理体系；',
    arch_integration_label: '系统集成',
    arch_integration_desc: '提供标准信息化接口，与企业ERP、OA、PLM等系统数据共享，避免信息孤岛；',
    arch_deploy_label: '系统部署',
    arch_deploy_desc: '支持奥太专有云 、企业私有云、公有云（阿里、华为等）三种系统部署方案；',

    // Project Cards
    scene_workshop_title: '焊接车间',
    scene_workshop_desc: '实现焊接车间设备网络化改造',
    
    scene_factory_title: '焊接工厂',
    scene_factory_desc: '助力企业实现焊接工厂信息化转型升级',

    scene_mes_title: '焊接MES',
    scene_mes_desc: '为用户提供智能化的综合焊接服务平台',

     // --- 新增：Pricing/功能详情列表项 (对应 home-中文.vue 329-494行) ---
    Main_functions: '主要功能',
    // 焊接车间 (Workshop) 功能列表
    feat_workshop_title: '焊接车间',
    feat_workshop_desc: '实现焊接车间设备网络化改造',
    feat_workshop_item_1: '实现所有品牌焊接设备联网改造；',
    feat_workshop_item_2: '实现设备开机时长、焊接时长自动统计；',
    feat_workshop_item_3: '实时监控焊机运行状态，超范围焊接系统自动报警；',
    feat_workshop_item_4: '一键导出焊接成本报告、焊接实时曲线及报警记录；',

    // 焊接工厂 (Factory) 功能列表
    feat_factory_title: '焊接工厂',
    feat_factory_desc: '助力企业实现焊接工厂信息化转型升级',
    feat_factory_item_1: '实现PQR、WPS的焊接工艺流程化、电子化管理；',
    feat_factory_item_2: '实现焊接任务工单信息化管理与焊接生产流程的数字化改造；',
    feat_factory_item_3: '完成焊工信息档案、持证资质、探伤合格率、工艺符合度、焊工业绩等数字化管理；',
    feat_factory_item_4: '实现焊材库领/退/还信息化管理;',
    feat_factory_item_5: '一键生成各类统计分析报表；',

    // 焊接MES (MES) 功能列表
    feat_mes_title: '焊接MES',
    feat_mes_desc: '为用户提供智能化的综合焊接服务平台',
    feat_mes_item_1: '完成焊接过程中的焊工、焊机、焊材、工艺、质检一体化管理；',
    feat_mes_item_2: '实时监控焊接过程中各环节的工艺数据，生成焊缝工艺符合度报告；',
    feat_mes_item_3: '焊接生产过程信息化，全程监控，焊接数据可追溯;',
    feat_mes_item_4: '自动生成电子化施焊记录单；',
    feat_mes_item_5: '与企业PLM、ERP、OA等系统互联互通，实现数据共享；',

    // Function Framework
    func_framework_tagline: 'SYSTEM FRAMEWORK',
    func_framework_title: '奥太智能焊接云功能框架',

    // Targets
    targets_tagline: 'SYSTEM TARGETS',
    targets_title: '奥太智能焊接云建设目标',
    target_item_1: '实现车间所有焊接设备数字化改造，建立设备资源一览表，实现设备状态实时监控、报警及时处理；保障设备利用率、及时排查设备故障、实时监控设备状态，保障生产节拍；',
    target_item_2: '规范焊接过程中参与的焊工、焊机、焊材、工艺、质检一体化管理；量化焊接过程数据，建立完整的焊接过程数据追溯链',
    target_item_3: '实现车间生产计划管理与焊接生产流程的信息化改造，实际准确有效执行设计的WPS，控制焊工大电流焊接、无资质焊接的情况，通过信息化手段量化焊工焊接时长，建立更准确更便捷的焊工绩效考核方案',
    target_item_4: '支持与PLM、ERP、OA等系统对接，打通企业信息化的“最后一环”，实现基于工业4.0的智慧焊接工厂。',

    // Core Services
    services_tagline: 'SERVICES WE\'RE PROVIDING',
    services_title: '我们为客户提供的核心功能',
    services_desc: '面向企业的全业务场景，围绕工艺协同、工单互联、资源调度、精益制造，构建新型焊接生产模式，为用户提供丰富、安全、稳定的产品功能及服务。',
    
    service_mes_title: '生产管控<br>MES',
    service_mes_desc: '管控生产计划与工单，消除管理偏差，解决人工填表、量化工时成本；',
    service_wps_title: '工艺管理 <br>WPS',
    service_wps_desc: '高效协同监管焊接工艺准确执行，避免大电流焊接、无资质焊接；',
    service_qms_title: '质量监管 <br>QMS',
    service_qms_desc: '建立完整的质量数据追溯链及有效的监测方法，导出施焊记录单；',
    service_wrs_title: '生产资源 <br>WRS',
    service_wrs_desc: '合理调度人员、设备、焊材等参与角色，量化焊接能力；',

    // Solutions Header
    solutions_header_tagline: 'INDUSTRY SOLUTIONS',
    solutions_header_title: '山东奥太30年深耕焊接行业，为企业提供更加垂直的行业解决方案',
    solutions_header_desc: '聚焦压力容器、长输管道、机械制造、核电、煤机、钢结构、船厂、军工、焊培等多个行业，为企业提供计划、工单、工艺、焊接、质检、设备、焊材、焊工等多维度的综合解决方案，助力企业数字化转型升级，赋能中国制造业创新发展。',

    // Solution Categories
    sol_cat_pressure: '压力容器',
    sol_cat_ship: '船舶',
    sol_cat_structure: '钢结构',
    sol_cat_machinery: '工程机械',
    sol_cat_training: '焊培',
    sol_cat_coal: '煤机',
    sol_cat_piping: '长输管道',


    // --- 新增：解决方案通用特性 ---
    feat_welding_process: '焊接工艺',
    feat_welder_operation: '焊工施焊',
    feat_quality_inspection: '质量检验',
    feat_completion_data: '完工资料',
    feat_data_report: '数据报表',
    feat_welding_data: '焊接数据',
    feat_welding_equipment: '焊接设备',
    feat_welder_management: '焊工管理',
    feat_weld_map: '焊缝地图',
    feat_welding_personnel: '焊接人员',
    feat_process_management: '工艺管理',
    feat_production_management: '生产管理',
    feat_quality_management: '质量管理',
    feat_cost_management: '成本管理',
    feat_material_management: '焊材库管理',
    feat_exam_process_mgmt: '考试流程管理',
    feat_exam_monitoring: '考试过程监控',
    feat_exam_data_report: '考试数据报表',
    feat_welding_proc_mgmt: '焊接工艺管理',
    feat_student_info_mgmt: '学员信息管理',
    feat_task_order: '任务工单',


    // Pressure Vessel Solution
    sol_pressure_title: '压力容器解决方案',
    sol_pressure_desc: '压力容器行业解决方案是在奥太智能焊接云系统的基础上进行行业方向特殊化的改进，由智能研发中心针对压力容器行业客户的焊接现场需求自主研发的信息化系统。从MES、ERP等第三方系统获取订单、生产计划、工艺信息；本系统主要进行生产流程、焊接流程、信息监控、数据分析，并将生产相关数据给到第三方系统，形成闭环。本系统实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。',
    sol_get_plan: '获取方案',

    // Ship Solution
    sol_ship_title: '船舶解决方案',
    sol_ship_desc: '船舶解决方案是随着物联网、云计算等技术的发展，积极开展船舶制造智能化研究及现场应用，是面对行业技术发展的必然选择，对于施工单位而言，不论业主方是否提出有关要求，具备焊接数据实时采集、存储、分析的能力，除了促进焊接技术水平的提升外，还能在市场竞争中形成专有技术优势，提高公司市场竞争力的有效手段。并根据客户的实际需求，为了满足企业不同的生产计划及流程，提供定制化解决方案。',
    

    // Steel Structure Solution
    sol_structure_title: '钢结构解决方案',
    sol_structure_desc: '钢结构焊接智能制造解决方案集成了焊接设备，采集设备，钢结构焊接管理系统，对接MES、ERP等第三方系统，旨在提高钢结构焊接的质量、效率，以及提高设备的利用率。系统实时采集、监控、处理和分析焊接数据，提供焊接生产信息，为管理者进行决策提供数据支持。并根据客户的实际需求，为了满足企业不同的生产计划及流程，提供定制化解决方案。',
  

    // Machinery Solution
    sol_machinery_title: '机械制造解决方案',
    sol_machinery_desc: '机械制造行业解决方案是在奥太智能焊接云系统基础上，面向机械制造行业并结合行业特点而开发，旨在解决机械制造行业客户的难点、痛点。系统实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。',
   
    // Training Solution
    sol_training_title: '焊培解决方案',
    sol_training_desc: '焊培领域智能制造解决方案由奥太智能研发中心打造，充分整合自主信息技术和数字化技术，与焊接行业的先进技术深度融合。以提升管理效率、优化业务流程、提高培训质量为目标，基于多年的焊培研发、数字化培训业务积累和技术研究，综合焊接行业的特点，建立适配焊培企业的智能培训技术平台，并提供智能培训全流程的系列解决方案，帮助企业打通各业务系统、设备间的数据壁垒，从传统培训向数字化培训、智能培训转型。',
   
    // Coal Machine Solution
    sol_coal_title: '煤机解决方案',
    sol_coal_desc: '煤机领域智能制造解决方案由奥太智能研发中心打造，以资源高效利用、降本增效为目标，实现工厂人、机、料、法、环、测的规范化管理，建立完整的焊接质量数据追溯链，改良工厂目前管理、生产状况，建造工业物联网平台。',
  
    // Piping Solution
    sol_piping_title: '长输管道解决方案',
    sol_piping_desc: '管道行业解决方案是以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台，结合客户现场焊接设备，辅助用户建立数字化焊接的一整套解决方案，对焊接现场的“人、机、料、法”进行全方位的智能化管理的信息化系统。',
    

    // Trusted Source / Footer
    trusted_source_content: '智能制造焊接数字化解决方案',
    trusted_source_provider: '优秀服务提供商',
    trusted_source_contact_title: '有任何问题请致电我们',
    stat_solutions: '解决方案',
    stat_equipment: '入网设备',
    stat_clients: '企业客户',
    stat_honor: '获得荣誉',

     mb_login1: '扫码下载APP，随时掌控焊接数据',
    mb_login2: '微信扫码直达微群控，轻量体验核心功能'
  },

  productCenter: {
     // --- 页面头部 (Page Header) ---
    page_title_pc: '产品中心', // PC端大标题
    page_title_sw: '软件产品', // 移动端-软件标题
    page_title_hw: '硬件产品', // 移动端-硬件标题
    
    // 描述文本 (PC端包含两段，移动端根据类型显示一段)
    desc_hardware: '硬件产品：通过数字化联网改造、升级的方式，采集设备实时的生产焊接数据，实时掌握设备运行状态、设备利用率、焊工焊接效率、资源消耗（焊材、保护气体、电能）等情况，通过实时的焊接数据与工艺要求对比，掌控焊接质量。',
    desc_software: '软件产品：针对不同行业传统焊接现状，通过软件升级信息化焊接流程，围绕生产过程中的“人、机、料、法、环、测”各元素，提供一整套的信息化软件平台，优化企业管理、监管生产过程、提高生产效率，保证焊接质量的前提下，达到降本增效。',
    
    // 面包屑
    // breadcrumb_home: '首页',
    // breadcrumb_product: '产品中心',
    // breadcrumb_software: '软件产品',
    // breadcrumb_hardware: '硬件产品',

    // --- 通用板块标题 ---
    section_software_title: '软件产品',
    section_hardware_title: '硬件产品',
    
    // --- 软件产品分类标题 ---手机端
    software_cat_industry: '焊接软件',
    software_cat_speciality: '专业软件',
    software_cat_mobile: '移动软件',

    // --- 硬件产品分类标题 ---手机端
    hardware_cat_terminal: '智能终端',
    hardware_cat_gateway_industrial: '焊接工业互联网网关',
    hardware_cat_gateway_robot: '焊接机器人网关',
    hardware_cat_other: '其他设备',

    // --- 列表项通用操作 ---
    action_view: '查看',
    
    // --- 提示信息 ---
    msg_temp_unavailable: '暂时无法查看！',



     // --- 软件产品 - 行业软件 (Industry List) ---
    prod_weldCloud_title: '智能焊接云系统',
    prod_weldCloud_text: '智能焊接云平台是由山东奥太电气有限公司结合国家标准及企业焊接现场实际生产管理与控制现状自主研发的综合化服务平台',
    
    prod_pressureVessel_title: '压力容器焊接管理系统',
    prod_pressureVessel_text: '压力容器焊接管理系统是在奥太智能焊接云系统的基础上进行行业方向特殊化的改进，是由智能研发中心针对压力容器行业客户的焊接现场需求自主研发的信息化系统。它实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。',
    
    prod_steelStructure_title: '钢结构焊接管理系统',
    prod_steelStructure_text: '钢结构焊接管理系统是一套综合性的管理系统，旨在提高钢结构焊接的效率和质量。该系统通过集成多种先进技术，如智能数据采集设备、物联网、大数据分析等，对钢结构焊接的全过程进行监控和管理。',
    
    prod_weldTraining_title: '智慧焊培管理系统',
    prod_weldTraining_text: '智慧焊培管理系统实现焊工资质信息全面数字化管理，优化焊工考试和培训流程，提升操作效率。并通过可视化管理，使焊培中心的运营更加透明和可监控。整合各标准体系，全面管理焊工培训考试流程。',
    
    prod_pipingSystem_title: '管道焊接管理系统',
    prod_pipingSystem_text: '管道焊接管理系统是以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台，结合客户现场焊接设备，辅助用户建立数字化焊接的一整套解决方案，对焊接现场的“人、机、料、法”进行全方位的智能化管理的信息化系统。',

    ce_pipingSystem_title: '工程机械焊接管理系统',
    ce_pipingSystem_text: '工程机械焊接管理系统是以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台，结合客户现场焊接设备，辅助用户建立数字化焊接的一整套解决方案，对焊接现场的“人、机、料、法”进行全方位的智能化管理的信息化系统。',



    // --- 软件产品 - 专业软件 (Speciality List) ---
    prod_weldTechnology_title: '焊接工艺管理系统',
    prod_weldTechnology_text: '通过软件系统的手段辅助焊接工艺人员快速完成焊接工艺文件编制,提高文件传递效率和数据准确性。',
    
    prod_welderInformation_title: '焊工信息管理系统',
    prod_welderInformation_text: '焊工信息管理系统实现焊工档案资质的全面数字化管理，确保焊工持证有效性。对焊工资源进行精确分析，以达到各厂区合理分配的目的。提高焊工管理的效率和准确性。',
    
    prod_weldMaterialWarehouse_title: '焊接资源管理系统',
    prod_weldMaterialWarehouse_text: '焊接资源管理系统是一种专门用于焊材仓储、管理和监控的智能软件系统。该系统可以记录焊材的入库、出库、库存、盘点等信息，帮助企业更好地了解仓库的运行情况，制定更加科学合理的库存管理策略，提高企业的运营效率和竞争力，实现焊材的信息化、智能化管理，提高焊材的利用率和管理效率。',
    
    prod_weldSeamTracking_title: '智能焊缝跟踪系统',
    prod_weldSeamTracking_text: '智能焊缝跟踪系统是应用于自动化焊接的视觉定位系统，主要由激光跟踪器、信号处理器、通讯线、云服务等部分组成，可实现远程数据监控，焊接过程数据云端存储、管理、分析、回溯，数据库远程快速升级，远程诊断等功能，可有效提高焊接质量、焊接效率、以及焊接一致性，降低生产成本。',
    
    prod_videoSystem_title: '智能焊接视讯系统',
    prod_videoSystem_text: '通过智能焊接视讯系统实时监控、回溯车间现场的焊接状况，及时发现、处理突发情况，保证人身安全、财产安全、设备安全等。使用系统可以全天候监控生产，大大提高生产、工作效率。',
    
    prod_robotSystem_title: '智能焊接机器人系统',
    prod_robotSystem_text: '智能焊接机器人系统（iCloudRobot）是面向焊接机器人设备使用者、焊接设备厂商打造的以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台。',

    // --- 软件产品 - 移动软件 (Move List) ---
    prod_groupControlApp_title: '掌上群控',
    prod_groupControlApp_text: '掌上群控APP的使用带给焊工全新的体验及工作模式，遵循了低成本、高效率的工作理念',
    
    prod_weldApp_title: '掌上焊机',
    prod_weldApp_text: '掌上焊机APP是面向设备使用者打造的以设备为中心的智能化远程遥控软件。',
    
    prod_operationApp_title: '掌上运维',
    prod_operationApp_text: '掌上运维APP围绕设备生命周期，从设备入网到日常保养、维修记录，旨在为用户提供移动化、规范化、流程化、信息化、一体化的全方位设备管理服务。',
    
    prod_databaseApplet_title: '奥太资料库小程序',
    prod_databaseApplet_text: '奥太资料库将取代传统纸质说明书，客户可以随时随地通过微信小程序查看电子版说明书，其适用范围覆盖了公司的各类产品',
    
    prod_groupControlApplet_title: '奥太微群控小程序',
    prod_groupControlApplet_text: '奥太微群控是一款基于奥太智能焊接云系统的微信小程序，具有设备监控、成本统计、设备资料、消息提醒等功能。',


    // --- 硬件产品 - 智能终端 (Terminal List) ---
    // ATQ-CJ500-4G
    'hardware_ATQ-CJ500-4G_title': '焊接数据采集仪 ATQ-CJ500系列',
    'hardware_ATQ-CJ500-4G_title_zh': '焊接数据采集仪',
    'hardware_ATQ-CJ500-4G_title_en': 'ATQ-CJ500 系列',
    'hardware_ATQ-CJ500-4G_text': 'ATQ-CJ500系列焊接数据采集仪主要应用于直流弧焊电源，采集焊接过程中实时电流、电压等信号，并通过4G/5G/WIFI/EtherNet等方式接入奥太智能焊接云系统，实现焊机信息化管理。',

    // ATQ-IT070
    'hardware_ATQ-IT070_title': '智能焊接终端 ATQ-IT070',
    'hardware_ATQ-IT070_title_zh': '智能焊接终端',
    'hardware_ATQ-IT070_title_en': 'ATQ-IT070',
    'hardware_ATQ-IT070_text': '奥太ATQ-IT070型智能焊接终端适用于压力容器、化工、钢结构等行业，通过WIFI或者4G等方式接入奥太智能焊接云系统，能够实现焊接过程的智能化管理。',

    // AD-1900
    'hardware_AD-1900_title': '焊接云前置终端 AD-1900',
    'hardware_AD-1900_title_zh': '焊接云前置终端',
    'hardware_AD-1900_title_en': 'AD-1900',
    'hardware_AD-1900_text': '前置终端是部署在企业现场的操作终端，辅助生产员工进行信息输入、数据监控、图纸工艺查看、任务流程控制等工作，提高员工工作效率。',

    // RWSC
    'hardware_RWSC_title': '机器人焊接系统控制终端 RWSC',
    'hardware_RWSC_title_zh': '机器人焊接系统控制终端',
    'hardware_RWSC_title_en': 'RWSC',
    'hardware_RWSC_text': '机器人焊接系统控制面板配套机器人焊机可完成机器人焊接工艺的复杂操作，实现对焊缝类型、焊缝代号、当前焊缝的选择，辅助焊工完成焊接参数的修改，以及焊缝预选、焊接参数微调、焊接工艺复制、多台焊接设备之间焊接工艺共享、用户登录等的功能。',

    // weldCloud-phone (AD-70)
    'hardware_weldCloud-phone_title': '焊接云手持终端 AD-70',
    'hardware_weldCloud-phone_title_zh': '焊接云手持终端',
    'hardware_weldCloud-phone_title_en': 'AD-70',
    'hardware_weldCloud-phone_text': '焊接云手持终端是一款轻便、高性能工业级智能手持终端。可在高温焊接环境下正常工作，防护等级为IP65/IP67，保密性高，适用于车间内禁止携带个人手机等电子产品的用户，可协助用户快速实现焊接信息化管理，提高工作效率。',

    // weldCloud-flat (PAD-80)
    'hardware_weldCloud-flat_title': '焊接云手持平板 PAD-80',
    'hardware_weldCloud-flat_title_zh': '焊接云手持平板',
    'hardware_weldCloud-flat_title_en': 'PAD-80',
    'hardware_weldCloud-flat_text': '机器人焊接系统控制面板配套机器人焊机可完成机器人焊接工艺的复杂操作，实现对焊缝类型、焊缝代号、当前焊缝的选择，辅助焊工完成焊接参数的修改，以及焊缝预选、焊接参数微调、焊接工艺复制、多台焊接设备之间焊接工艺共享、用户登录等的功能。',


    // --- 硬件产品 - 焊接工业互联网网关 (Welding Gateway List) ---
    // ATQ-RS422/4G
    'hardware_ATQ-RS422/4G_title': '通信控制器 ATQ-RS422/4G（外置）',
    'hardware_ATQ-RS422/4G_title_zh': '通信控制器4G（外置）',
    'hardware_ATQ-RS422/4G_title_en': 'ATQ-RS422/4G',
    'hardware_ATQ-RS422/4G_text': 'ATQ-RS422/4G通信控制器，可应用于奥太数字化焊机，实现焊机信息化管理。',

    // ATQ-GW-DWL
    'hardware_ATQ-GW-DWL_title': '通信控制器 ATQ-GW-DWL（内置）',
    'hardware_ATQ-GW-DWL_title_zh': '通信控制器4G（内置）',
    'hardware_ATQ-GW-DWL_title_en': 'ATQ-GW-DWL',
    'hardware_ATQ-GW-DWL_text': 'ATQ-GW-DWL通信控制器，可应用于奥太数字化焊机，实现焊机信息化管理。',

    // ATQ-RS422/WF-II
    'hardware_ATQ-RS422/WF-II_title': '通信控制器 ATQ-RS422/WF-II（外置）',
    'hardware_ATQ-RS422/WF-II_title_zh': '通信控制器WIFI（外置）',
    'hardware_ATQ-RS422/WF-II_title_en': 'ATQ-RS422/WF-II',
    'hardware_ATQ-RS422/WF-II_text': 'AATQ-RS422/WF-II通信控制器，可应用于奥太数字化焊机，实现焊机信息化管理。',

    // ATQ-GW-WF801
    'hardware_ATQ-GW-WF801_title': '通信控制器 ATQ-GW-WF801（内置）',
    'hardware_ATQ-GW-WF801_title_zh': '通信控制器WIFI（内置）',
    'hardware_ATQ-GW-WF801_title_en': 'ATQ-GW-WF801',
    'hardware_ATQ-GW-WF801_text': 'ATQ-GW-WF801通信控制器，通信控制器无线通信方式，可应用于奥太数字化焊机，完成焊机与服务器之间的通信，实现焊机所有参数的采集、控制。',

    // ATQ-RS422-5G
    'hardware_ATQ-RS422-5G_title': '通信控制器 ATQ-RS422-5G（内置）',
    'hardware_ATQ-RS422-5G_title_zh': '通信控制器5G（内置）',
    'hardware_ATQ-RS422-5G_title_en': 'ATQ-RS422-5G',
    'hardware_ATQ-RS422-5G_text': 'ATQ-RS422-5G通信控制器可应用于奥太数字化焊机，通过5G网络通信方式实现焊机联网，实现焊机信息化管理。',

    // ATQ-RS422-4G-IV
    'hardware_ATQ-RS422-4G-IV_title': '通讯控制器多功能网关 ATQ-RS422-4G-IV（内置）',
    'hardware_ATQ-RS422-4G-IV_title_zh': '通讯控制器多功能网关内置',
    'hardware_ATQ-RS422-4G-IV_title_en': 'ATQ-RS422-4G-IV',
    'hardware_ATQ-RS422-4G-IV_text': 'ATQ-RS422-4G-IV通信控制器可应用于奥太数字化焊机，该产品应用于云系统与焊机中间，通过4G、以太网以及WIFI等联网方式实现焊机联网，实现焊机信息化管理。',


    // --- 硬件产品 - 焊接机器人网关 (Robot Gateway List) ---
    // ATR-485-Ⅱ
    'hardware_ATR-485-Ⅱ_title': '通信控制器 ATR-485-Ⅱ',
    'hardware_ATR-485-Ⅱ_title_zh': '通信控制器',
    'hardware_ATR-485-Ⅱ_title_en': 'ATR-485-Ⅱ',
    'hardware_ATR-485-Ⅱ_text': 'ATR-485-Ⅱ通信控制器用于实现奥太焊机与专机或机器人之间的通讯。与专机或机器人之间的通讯采用标准的ModBus-RTU协议。',

    // ATR-CAN-Ⅱ
    'hardware_ATR-CAN-Ⅱ_title': '通信控制器 ATR-CAN-Ⅱ',
    'hardware_ATR-CAN-Ⅱ_title_zh': '通信控制器',
    'hardware_ATR-CAN-Ⅱ_title_en': 'ATR-CAN-Ⅱ',
    'hardware_ATR-CAN-Ⅱ_text': '奥太ATR-CAN-II通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端CAN协议与焊机通信协议的转换。',

    // ATR-CANOPEN
    'hardware_ATR-CANOPEN_title': '通信控制器 ATR-CANOPEN',
    'hardware_ATR-CANOPEN_title_zh': '通信控制器',
    'hardware_ATR-CANOPEN_title_en': 'ATR-CANOPEN',
    'hardware_ATR-CANOPEN_text': '奥太ATR-CANOPEN通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端CANOPEN协议与焊机通信协议的转换。',

    // ATR-DEV-Ⅳ
    'hardware_ATR-DEV-Ⅳ_title': '通信控制器 ATR-DEV-Ⅳ',
    'hardware_ATR-DEV-Ⅳ_title_zh': '通信控制器',
    'hardware_ATR-DEV-Ⅳ_title_en': 'ATR-DEV-Ⅳ',
    'hardware_ATR-DEV-Ⅳ_text': '奥太ATR-DEV-Ⅳ机器人接口盒用于专机或机器人焊接系统，该控制器实现了专机或机器人端DeviceNet协议与焊机通信协议的转换。',

    // ATR-EtherCAT
    'hardware_ATR-EtherCAT_title': '通信控制器 ATR-EtherCAT',
    'hardware_ATR-EtherCAT_title_zh': '通信控制器',
    'hardware_ATR-EtherCAT_title_en': 'ATR-EtherCAT',
    'hardware_ATR-EtherCAT_text': '奥太ATR-EtherCAT通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端EtherCAT协议与焊机通信协议的转换。',

    // ATR-PROFINET
    'hardware_ATR-PROFINET_title': '通信控制器 ATR-PROFINET',
    'hardware_ATR-PROFINET_title_zh': '通信控制器',
    'hardware_ATR-PROFINET_title_en': 'ATR-PROFINET',
    'hardware_ATR-PROFINET_text': '奥太ATR-PROFINET 通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端 PROFINET 协议与焊机通信协议的转换。',

    // ATR-GATEWAY
    'hardware_ATR-GATEWAY_title': '机器人网关 ATR-GATEWAY',
    'hardware_ATR-GATEWAY_title_zh': '机器人网关',
    'hardware_ATR-GATEWAY_title_en': 'ATR-GATEWAY',
    'hardware_ATR-GATEWAY_text': '奥太ATR-GATEWAY系列机器人网关用于专机或机器人焊接系统，该系列产品实现了专机或机器人端通信协议与奥太焊机通信协议的转换，同时支持通过WIFI或4G等方式接入奥太智能焊接云系统。',

    // ATR-GW-EIP
    'hardware_ATR-GW-EIP_title': '机器人网关 ATR-GW-EIP',
    'hardware_ATR-GW-EIP_title_zh': '机器人网关',
    'hardware_ATR-GW-EIP_title_en': 'ATR-GW-EIP',
    'hardware_ATR-GW-EIP_text': '奥太ATR-GW-EIP系列机器人网关主要应用用于专机或机器人焊接系统，该系列产品实现了专机或机器人端通信协议与奥太焊机通信协议的转换，并且可以选配4G或WIFI群控功能。',


    // --- 硬件产品 - 其他设备 (Other List) ---
    // ATQ-SR
    'hardware_ATQ-SR_title': '焊接工艺手持终端 ATQ-SR',
    'hardware_ATQ-SR_title_zh': '焊接工艺手持终端',
    'hardware_ATQ-SR_title_en': 'ATQ-SR',
    'hardware_ATQ-SR_text': 'ATQ系列手持终端适用于奥太数字焊机，实现焊机工艺切换功能。',

    // ATQ-GFS50
    'hardware_ATQ-GFS50_title': '气体流量计 ATQ-GFS50',
    'hardware_ATQ-GFS50_title_zh': '气体流量计',
    'hardware_ATQ-GFS50_title_en': 'ATQ-GFS50',
    'hardware_ATQ-GFS50_text': '奥太ATQ-GFS50气体流量计用于测量焊接保护气体流速。',

    // ATQ-NFC
    'hardware_ATQ-NFC_title': '读卡器 ATQ-NFC',
    'hardware_ATQ-NFC_title_zh': '读卡器',
    'hardware_ATQ-NFC_title_en': 'ATQ-NFC',
    'hardware_ATQ-NFC_text': '奥太ATQ-NFC读卡器主要应用于对焊工卡的识别。',
  },
  
  software: {
    product_demo: "产品演示",
    contact_Us: "联系我们",
    try_now: "立即体验",
    product_value: "产品价值",
    customer_case: "客户案例",

    // --- 智能焊接云系统 (weldCloud) ---
    software_weldCloud_title: '智能焊接云系统',
    software_weldCloud_text: '智能焊接云系统是由山东奥太电气有限公司结合国家标准及企业焊接现场实际生产管理与控制现状自主研发的综合化服务平台',
    software_weldCloud_introduceTitle: '平台介绍',
    software_weldCloud_introduceText: '智能焊接云系统是由山东奥太电气有限公司结合国家标准及企业焊接现场实际生产管理与控制现状自主研发的综合化服务平台，平台深入分析“人机料法环测”全面质量管理理论中的影响产品质量的主要因素， 借助工业互联网平台，运用物联网、云计算、边缘计算、智能检测控制等技术，实现从企业资源计划承接分配到车间的生产订单，焊前准备、焊接过程管理及控制、焊后质量检测并形成完整的产品完工资料。',
    software_weldCloud_solutionTitle: '● 综合性应用平台：多技术融合，焊接自动化、信息化、网络化、智能化为用户提供焊接装备整套解决方案。',
    software_weldCloud_cloudArchitectureTitle: '● 整合企业焊接资源实现产品焊接全过程管理及控制，完成生产现场焊接大数据采集、分析及应用，系统组成：',
    software_weldCloud_text1: '平台由焊接生产中心、信息监控中心、设备管控中心、焊接资源中心、数据报表中心、信息展板中心、 系统配置中心等组成，旨在为客户解决焊接生产过程中管理及控制最终系统输出产品完工资料，减少产品生产过程中大量的文书工作，系统综合分析焊接现场人、机、料、法、 环等关键因素为用户优化流程提供数据支持，更好的助力企业合理的调配生产资源提高产品生产效率。',
    software_weldCloud_text2: '该平台已广泛应用于煤机、压力容器、钢结构、汽车制造、船舶、航空航天等行业，针对焊接工艺要求严格， 焊接工艺规程设计复杂，焊接记录单人工记录纸质流转，焊接任务人工分配效率低的问题，采用智能焊接云系统对内能有效地缩短产品制造周期，消除70%焊接过程中文书工作，提高20%设备利用率， 未关机设备提醒减少人工巡查，智能维保提醒延长设备使用寿命，更好的为企业配置、整合、优化生产要素，提高生产力，焊接工艺精细控制，提高产品质量，提升产品核心竞争力， 同时对外借助工业互联网平台，更好的提高企业科技水平，进而聚合优质资源助力企业快速发展。',

    // --- 钢结构焊接管理系统 (steelStructure) ---
    software_steelStructure_title: '钢结构焊接管理系统',
    software_steelStructure_text: '钢结构焊接管理系统是一套综合性的管理系统，旨在提高钢结构焊接的效率和质量。该系统通过集成多种先进技术，如智能数据采集设备、物联网、大数据分析等，对钢结构焊接的全过程进行监控和管理。',
    software_steelStructure_functionTitle: '产品功能',
    
    software_steelStructure_func_1_title: '焊接工艺管理',
    software_steelStructure_func_1_text: '系统分析不同的焊接工艺规程模板，转换为系统工艺数据，统一管理。并将工艺数据下发到指定设备，通过控制或报警的手段，提高工艺符合度。',
    software_steelStructure_func_2_title: '焊接人员管理',
    software_steelStructure_func_2_text: '系统对焊接人员的基本信息、资质进行统一管理，为焊接任务的派发提供依据。',
    software_steelStructure_func_3_title: '焊缝地图管理',
    software_steelStructure_func_3_text: '通过焊缝地图实时显示焊缝状态，能够更直观的展示产品的进度。',
    software_steelStructure_func_4_title: '焊接任务管理',
    software_steelStructure_func_4_text: '系统根据生产计划制定焊接生产任务，对焊接任务进行分配和管理，确保生产的顺利进行。',
    software_steelStructure_func_5_title: '焊接设备管理',
    software_steelStructure_func_5_text: '系统对焊接设备的基本信息、维护保养进行管理，提供设备的使用率。',
    software_steelStructure_func_6_title: '焊接数据分析',
    software_steelStructure_func_6_text: '系统对焊接过程的生产数据采集、存储，并进行数据分析，为焊接过程的优化、改进提供数据支持。',

    software_steelStructure_value_1_title: '提高生产效率',
    software_steelStructure_value_1_text: '无纸化管理，减少手工填写数据；通过系统优化流程，减少生产过程中的流程等待。从而提高生产效率。',
    software_steelStructure_value_2_title: '提高焊接质量',
    software_steelStructure_value_2_text: '系统对焊接全过程监控，实时记录和反馈问题，减少返工成本，优化焊接工艺，提高焊接质量。',
    software_steelStructure_value_3_title: '促进企业数字化转型',
    software_steelStructure_value_3_text: '打通生产焊接环节，完善和推动企业全面数字化，提高企业竞争力，推进可持续性发展。',

    software_steelStructure_contrastTitle: '钢结构焊接管理系统使用前后对比',
    software_steelStructure_contrast_1_title: '生产效率提升',
    software_steelStructure_contrast_2_title: '焊接质量问题减少',
    software_steelStructure_contrast_3_title: '纸张用量减少',
    software_steelStructure_contrast_4_title: '设备利用率提升',
    software_steelStructure_contrast_5_title: '工艺符合度提升',
    software_steelStructure_contrast_6_title: '数据准确性提升',

    // --- 智能焊接机器人系统 (robotSystem) ---
    software_robotSystem_title: '智能焊接机器人系统',
    software_robotSystem_text: '智能焊接机器人系统（iCloudRobot）是面向焊接机器人设备使用者、焊接设备厂商打造的以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台。',
    software_robotSystem_functionTitle: '其他功能',
    
    software_robotSystem_func_1_title: '设备GPS',
    software_robotSystem_func_1_text: '通过GPS实现设备分布地图，直观展示设备在地图上的位置分布及运行情况。',
    software_robotSystem_func_2_title: '焊接工艺',
    software_robotSystem_func_2_text: '根据不同的焊缝设定不同的焊接工艺、焊接模式及焊接参数等信息，随生产任务下发到每台机器人。',
    software_robotSystem_func_3_title: '在线质量分析',
    software_robotSystem_func_3_text: '通过查看在机器人焊接过程中的详细焊接数据以及报警情况，对机器人焊接质量进行分析。',
    software_robotSystem_func_4_title: '数据报表',
    software_robotSystem_func_4_text: '以车间、班组、人为单位对机器人生产过程中的数据进行日/月/年多维度统计。',
    software_robotSystem_func_5_title: '生产管控',
    software_robotSystem_func_5_text: '对生产过程的项目、图纸、生产流程、焊接材料需求进行管理。',
    software_robotSystem_func_6_title: '设备效率分析',
    software_robotSystem_func_6_text: '通过对机器人焊接时间、待机时间、焊接成本、设备数量的统计，对设备利用率、工作效率进行分析，提升设备的管理水平和运行效率。',

    software_robotSystem_mainFunctionTitle: '产品功能',
    software_robotSystem_mainFunc_1_title: '车间看板',
    software_robotSystem_mainFunc_1_text1: '直观展示机器人在厂区的位置及各个机器人工作站设备的运行状态、运行效率、焊接数据、焊接工艺、焊接人员等信息，实时了解设备的运行情况，提高设备管理效率。',
    software_robotSystem_mainFunc_2_title: '信息监控',
    software_robotSystem_mainFunc_2_text1: '主要用于监控机器人的运行状态、焊接实时曲线、焊接数据、报警信息等相关参数。',

    software_robotSystem_value_1_title: '实时监控和预警',
    software_robotSystem_value_1_text: '智能焊接机器人系统可以对机器人的工作状态、焊接质量等进行实时监测，及时发现并处理问题，同时系统还可以对焊接参数进行调整和优化，进一步提高产品质量。',
    software_robotSystem_value_2_title: '提高数据安全性',
    software_robotSystem_value_2_text: '智能焊接机器人系统可以记录焊接过程中的各种数据，如焊接电流、电压、速度等，方便后续的数据分析和追溯，提高了数据安全性。',
    software_robotSystem_value_3_title: '保证产品质量',
    software_robotSystem_value_3_text: '智能焊接机器人系统精确监控，合理匹配焊接工艺，提高机器人机器人焊接精度，可以避免人为因素导致的产品质量问题。',

    software_robotSystem_contrastTitle: '智能焊接机器人系统使用前后对比',
    software_robotSystem_contrast_1_title: '产品质量提升',
    software_robotSystem_contrast_2_title: '生产成本降低',
    software_robotSystem_contrast_3_title: '数据安全性提高',
    software_robotSystem_contrast_4_title: '设备利用率提高',

    // --- 压力容器焊接管理系统 (pressureVessel) ---
    software_pressureVessel_title: '压力容器焊接管理系统',
    // software_pressureVessel_text: '压力容器焊接管理系统是在奥太智能焊接云系统的基础上进行行业方向特殊化的改进，由智能研发中心针对压力容器行业客户的焊接现场需求自主研发的信息化系统。从MES、ERP等第三方系统获取订单、生产计划、工艺信息；本系统主要进行生产流程、焊接流程、信息监控、数据分析，并将生产相关数据给到第三方系统，形成闭环。本系统实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。',
    software_pressureVessel_text: '基于奥太智能焊接云系统，智能研发中心为压力容器行业量身打造的专业焊接管理平台。系统无缝对接MES、ERP等第三方系统，实现订单、计划、工艺数据的自动同步；覆盖生产流程、焊接执行、信息监控与数据分析全链路，并将生产数据回传至第三方系统，形成管理闭环。持续迭代优化，快速响应客户需求，助力企业高效发展。',
    software_pressureVessel_functionTitle: '其他功能',
    
    software_pressureVessel_func_1_title: '焊接记录单报表',
    software_pressureVessel_func_1_text: '焊接记录单无纸化在线生成，保证了记录单里内容的准确性，节省了焊工的填写时间，提高焊接效率',
    software_pressureVessel_func_2_title: '数据统计报表',
    software_pressureVessel_func_2_text: '通过人、机、料、法、环五个维度统计生产数据，为企业提供数据支持',
    software_pressureVessel_func_3_title: '历史数据追溯',
    software_pressureVessel_func_3_text: '可通过焊缝信息查询到此焊缝的施焊人员信息、使用的焊机信息、以及焊缝的实时焊接参数信息，方便客户追溯重要的焊接数据',

    software_pressureVessel_mainFunctionTitle: '产品功能',
    software_pressureVessel_mainFunc_1_title: '焊接监控中心',
    software_pressureVessel_mainFunc_1_text1: '实时显示车间焊接设备工作状态以及电流、电压、气流量等焊接数据。若焊接设备出现故障，及时发现、及时响应。',
    software_pressureVessel_mainFunc_1_text2: '动态获取整个车间的焊接设备的使用情况，实时显示焊机的使用率、开动率以及时间利用率。实时分析焊接设备的使用情况，管理层根据数据合理规划焊接设备使用，提高焊接设备利用率，控制成本。',
    software_pressureVessel_mainFunc_2_title: '焊接资源中心',
    software_pressureVessel_mainFunc_2_text1: '建立产品的标准工艺库，焊工执行焊缝焊接时，系统会自动提取焊缝对应的WPS工艺要求并远程下发给焊机，保证了严格按照WPS规定的焊接工艺进行施焊',
    software_pressureVessel_mainFunc_2_text2: '建立合理的焊材管理流程，把控焊工领料、还料流程。通过焊材管理流程，实时掌握焊材使用情况',

    software_pressureVessel_value_1_title: '提高生产效率',
    software_pressureVessel_value_1_text: '自动跟踪焊接过程，优化焊接工作流程，减少无效的沟通和操作时间，从而提高焊接效率。',
    software_pressureVessel_value_2_title: '提高产品质量',
    software_pressureVessel_value_2_text: '系统根据工艺实现精确控制焊机，防止大电流焊接，减少人为因素导致的产品缺陷，提高产品的质量和一致性。',
    software_pressureVessel_value_3_title: '追溯焊接数据',
    software_pressureVessel_value_3_text: '实时采集、记录焊接数据，数据存档，焊接数据不丢失，随时随地查看，助力企业实现数字化管理。',

    software_pressureVessel_contrastTitle: '压力容器焊接管理系统使用前后对比',
    software_pressureVessel_contrast_1_title: '生产效率提升',
    software_pressureVessel_contrast_2_title: '产品质量提高',
    software_pressureVessel_contrast_3_title: '成本降低',
    software_pressureVessel_contrast_4_title: '安全行提升',

    // --- 智慧焊培管理系统 (weldTraining) ---
    software_weldTraining_title: '智慧焊培管理系统',
    software_weldTraining_text: '智慧焊培管理系统实现焊工资质信息全面数字化管理，优化焊工考试和培训流程，提升操作效率。并通过可视化管理，使焊培中心的运营更加透明和可监控。整合各标准体系，全面管理焊工培训考试流程。',
    software_weldTraining_functionTitle: '其他功能',
    
    software_weldTraining_func_1_title: '焊接培训管理',
    software_weldTraining_func_1_text: '建立完善的培训知识库和操作经验分享平台，搭建标准化的培训管理流程。',
    software_weldTraining_func_2_title: '焊接考试管理',
    software_weldTraining_func_2_text: '管理各标准体系的焊工考试流程，对考试过程全面监控。',
    software_weldTraining_func_3_title: '焊接工艺管理',
    software_weldTraining_func_3_text: '系统对不同的焊接工艺规程模板进行系统分析，将其转换为系统工艺数据，并实现集中管理。',
    software_weldTraining_func_4_title: '焊工资质管理',
    software_weldTraining_func_4_text: '建立完善的焊工信息库，满足企业对焊工的资格查询与审核。',
    software_weldTraining_func_5_title: '焊接现场管理',
    software_weldTraining_func_5_text: '通过现场配置可视化终端与控制系统的方式，实现考试现场可视化管理。',
    software_weldTraining_func_6_title: '焊接数据分析',
    software_weldTraining_func_6_text: '系统对考试过程的数据采集，存储，并进行数据分析，发现培训考试中的问题。',

    software_weldTraining_mainFunctionTitle: '产品功能',
    software_weldTraining_mainFunc_1_title: '打造智能化焊接培训平台',
    software_weldTraining_mainFunc_1_text1: '打造一个智能化、网络化、信息化焊接培训平台，对焊接中心的设备、材料和人力资源进行统一管理。',
    software_weldTraining_mainFunc_1_text2: '追踪和监控焊接设备的使用情况和状态，包括设备的实时数据、故障报警等。以确保培训考试过程中规范性和有效性。',
    software_weldTraining_mainFunc_2_title: '实时监测实训中心运行情况',
    software_weldTraining_mainFunc_2_text1: '实时监测实训中心的运行情况，对焊工的操作进行监控和分析，收集实训中心的焊接数据，通过统计数据分析和可视化技术，将焊接数据转化为直观的统计图表，帮助管理者了解实训情况和焊接质量，支持数据驱动的决策',

    software_weldTraining_value_1_title: '提高管理效率',
    software_weldTraining_value_1_text: '系统取代了传统的纸质文件流转，减少资源浪费，方便快捷管理人员信息检索，提高了管理效率。',
    software_weldTraining_value_2_title: '优化业务流程',
    software_weldTraining_value_2_text: '智能培训计划和在线考试平台加速了业务流程，提高了整体效率。',
    software_weldTraining_value_3_title: '提高培训质量',
    software_weldTraining_value_3_text: '系统对培训考试全过程监控，实时记录和反馈问题，及时发现问题并进行针对性的改进',

    software_weldTraining_contrastTitle: '智慧焊培管理使用前后对比',
    software_weldTraining_contrast_1_title: '管理效能提升',
    software_weldTraining_contrast_2_title: '业务流程优化',
    software_weldTraining_contrast_3_title: '培训效果提升',
    software_weldTraining_contrast_4_title: '运营透明度提升',

    // --- 智能焊缝跟踪系统 (weldSeamTracking) ---
    software_weldSeamTracking_title: '智能焊缝跟踪系统',
    software_weldSeamTracking_text: '智能焊缝跟踪系统是应用于自动化焊接的视觉定位系统，主要由激光跟踪器、信号处理器、通讯线、云服务等部分组成，可实现远程数据监控，焊接过程数据云端存储、管理、分析、回溯，数据库远程快速升级，远程诊断等功能，可有效提高焊接质量、焊接效率、以及焊接一致性，降低生产成本。',
    software_weldSeamTracking_functionTitle: '产品功能',
    
    software_weldSeamTracking_func_1_title: '激光跟踪',
    software_weldSeamTracking_func_1_text: '通过激光跟踪器实时采集焊缝信息图像。',
    software_weldSeamTracking_func_2_title: '图像处理',
    software_weldSeamTracking_func_2_text: '对采集焊缝图像信息进行处理。',
    software_weldSeamTracking_func_3_title: '实时通讯',
    software_weldSeamTracking_func_3_text: '将焊缝位置、尺寸等信息实时发送给机器人、PLC等控制系统。',
    software_weldSeamTracking_func_4_title: '远程升级',
    software_weldSeamTracking_func_4_text: '通过互联网或局域网实现工艺库自动升级。',
    software_weldSeamTracking_func_5_title: '数据存储',
    software_weldSeamTracking_func_5_text: '定时存储焊缝跟踪数据，方便后续的数据分析和查询。',
    software_weldSeamTracking_func_6_title: '数据可视化',
    software_weldSeamTracking_func_6_text: '通过图表、曲线、图像等方式将数据可视化，方便直观地查看数据分析结果。',

    software_weldSeamTracking_value_1_title: '提高焊接质量',
    software_weldSeamTracking_value_1_text: '通过实时监测和记录焊接数据，可以及时发现和解决焊接过程中出现的问题，避免焊接缺陷的产生，从而提高焊接质量。',
    software_weldSeamTracking_value_2_title: '提升生产效率',
    software_weldSeamTracking_value_2_text: '智能焊缝跟踪系统能够实现焊接过程的自动化和智能化，减少人工干预，提高焊接速度和生产效率。',
    software_weldSeamTracking_value_3_title: '促进工艺优化',
    software_weldSeamTracking_value_3_text: '通过对大量焊接数据的分析，可以深入了解焊接过程的规律和特点，为工艺参数的优化和焊接设备的改进提供依据。',

    software_weldSeamTracking_contrastTitle: '智能焊缝跟踪系统使用前后对比',
    software_weldSeamTracking_contrast_1_title: '焊接质量提升',
    software_weldSeamTracking_contrast_2_title: '生产效率提升',
    software_weldSeamTracking_contrast_3_title: '生产成本降低',
    software_weldSeamTracking_contrast_4_title: '安全性提高',

    // --- 奥太质量管理系统 (qualitySystem) ---
    software_qualitySystem_title: '奥太质量管理系统',
    software_qualitySystem_text: '奥太质量管理系统是对整个调检流程上的每一个环节进行全方位的监控，通过对焊机信息、调检步骤、出产日期、调检人员、流水线的数据监控从而实现对产品质量的把控，达到产品预期。',
    software_qualitySystem_functionTitle: '产品功能',
    
    software_qualitySystem_value_1_title: '标准化',
    software_qualitySystem_value_1_text: '检验流程标准化、调检步骤标准化',
    software_qualitySystem_value_2_title: '智能化',
    software_qualitySystem_value_2_text: '绝大多数调检结果的判定通过系统自动判定，解决人工判断存在误差的情况。',
    software_qualitySystem_value_3_title: '自动化',
    software_qualitySystem_value_3_text: '自动分析现有质量数据，生成质量报表。',

    software_qualitySystem_contrastTitle: '奥太质量管理系统使用前后对比',

    // --- 奥太资料库小程序 (databaseApplet / databaseApplet-productSoftware) ---
    // 注：JSON中有两个key指向类似内容，此处合并为主要的一个 databaseApplet
    software_databaseApplet_title: '奥太资料库小程序',
    software_databaseApplet_text: '奥太资料库将取代传统纸质说明书，客户可以随时随地通过微信小程序查看电子版说明书，其适用范围覆盖了公司的各类产品',
    software_databaseApplet_functionTitle: '小程序入口', // 对应 functionTitle
    software_databaseApplet_funtionAppletTitle: '小程序界面展示', // 对应 funtionAppletTitle (如有需要)
    
    software_databaseApplet_mainFunctionTitle: '功能模块',
    software_databaseApplet_mainFunc_1_title: '资料库',
    software_databaseApplet_mainFunc_1_text: '资料库也就是小程序首页，上方输入框可以根据设备型号搜索相应资料，资料包含设备说明书、宣传资料、宣传视频（宣传视频是视频网站地址，可以自行跳转观看）；中间部分是奥太资料库发布的新闻资讯，主要包含如何使用说明书、调查问卷以及安装要求等，点击即可查看；点击中间的扫码，扫描焊机后面板的二维码即可进行查看。',
    software_databaseApplet_mainFunc_2_title: '历史',
    software_databaseApplet_mainFunc_2_text: '历史界面主要是方便客户，查看最近使用的资料，无需重复搜索点击即看。',
    software_databaseApplet_mainFunc_3_title: '留言板',
    software_databaseApplet_mainFunc_3_text: '客户可以将对奥太的诉求或建议通过该界面进行提交，我们在收到信息后也会第一时间处理。',
    software_databaseApplet_mainFunc_4_title: '关于',
    software_databaseApplet_mainFunc_4_text: '关于界面展示的是企业的基本信息与联系方式。',

    software_databaseApplet_contrastTitle: '产品价值',
    software_databaseApplet_contrast_1_title: '环保节能',
    software_databaseApplet_contrast_1_text: '相比于传统的纸质说明书，奥太资料库不需要使用纸张和印刷油墨，因此可以减少对环境的污染，同时也能够节省能源。',
    software_databaseApplet_contrast_2_title: '方便使用',
    software_databaseApplet_contrast_2_text: '可以通过电子设备进行存储和阅读，用户可以随时随地查看说明书，而不需要携带纸质说明书。此外，电子化说明书还可以通过搜索功能快速找到需要的信息，提高使用效率。',
    software_databaseApplet_contrast_3_title: '降低成本',
    software_databaseApplet_contrast_3_text: '可以降低生产成本和物流成本，因为不需要印刷和运输纸质说明书。',
    software_databaseApplet_contrast_4_title: '提高信息更新效率',
    software_databaseApplet_contrast_4_text: '可以随时进行更新和修改，而不需要重新印刷纸质说明书。这可以确保用户获得最新的产品信息和使用方法。',

    // --- 掌上群控 (groupControlApp) ---
    software_groupControlApp_title: '掌上群控',
    software_groupControlApp_scene_1_title: '山东某压力客户',
    software_groupControlApp_scene_1_introduceTitle: '项目需求',
    software_groupControlApp_scene_1_introduce_1: '● 施焊记录单无纸化：人工填写施焊记录单不仅占用大量时间，数据准确性也无法保证。',
    software_groupControlApp_scene_1_introduce_2: '● 生产流程数字化：实现车间生产计划管理与焊接生产流程的数字化改造，完成焊接过程中的焊工、焊机、焊材、工艺、质检一体化管理。',
    software_groupControlApp_scene_1_meritTltle: '解决方案',
    software_groupControlApp_scene_1_merit_1: '焊工通过扫描生产任务二维码开展焊接生产活动。',
    software_groupControlApp_scene_1_merit_2: '管理人员在线管控生产过程。',
    software_groupControlApp_scene_1_merit_3: '系统自动生成施焊记录，无需人工干预。',

    software_groupControlApp_scene_2_title: '江苏某钢结构企业',
    software_groupControlApp_scene_2_introduceTitle: '项目需求',
    software_groupControlApp_scene_2_introduce_1: '● 焊缝工艺严格执行：焊缝工艺远程下发，焊工严格按照要求的焊接参数进行施焊。',
    software_groupControlApp_scene_2_introduce_2: '● 焊工资质认证：焊工在开始焊接前，使用本人身份信息，扫码焊缝二维码，符合条件可开始焊接。',
    software_groupControlApp_scene_2_introduce_3: '● 焊接质量追溯：量化焊接过程数据，建立完整的焊接质量数据追溯链，结合工艺分析质量问题。',
    software_groupControlApp_scene_2_meritTltle: '解决方案',
    software_groupControlApp_scene_2_merit_1: '通过焊缝二维码实现焊接过程中的焊工、焊机、焊材、工艺、质检一体化管理。',
    software_groupControlApp_scene_2_merit_2: '从焊缝、设备、焊工等不同维度进行成本统计与焊接质量数据追溯。',

    // --- 掌上焊机 (weldApp) ---
    software_weldApp_title: '掌上焊机',

    // --- 掌上运维 (operationApp) ---
    software_operationApp_title: '掌上运维',

    // --- 管道焊接管理系统 (pipingSystem) ---
    software_pipingSystem_title: '管道焊接管理系统',
    // software_pipingSystem_text: '管道焊接管理系统是以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台，结合客户现场焊接设备，辅助用户建立数字化焊接的一整套解决方案，对焊接现场的“人、机、料、法”进行全方位的智能化管理的信息化系统。',
    software_pipingSystem_text: '管道焊接管理系统是以焊接系统为核心的网络化、信息化、自动化、智能化服务平台。系统与现场焊接设备深度融合，协助用户构建完整的数字化焊接解决方案，实现对“人、机、料、法”四大要素的全方位智能化管理。',
    
    software_pipingSystem_mainFunctionTitle: '产品功能',
    software_pipingSystem_mainFunc_1_title: '设备监控',
    software_pipingSystem_mainFunc_1_text: '监控设备实时运行状态、焊口焊层编号、焊接参数及阈值报警信息',
    software_pipingSystem_mainFunc_2_title: '地理位置监控',
    software_pipingSystem_mainFunc_2_text: '该模块用于实时查看控制系统的设备状态和位置信息。',
    software_pipingSystem_mainFunc_3_title: '数据统计',
    software_pipingSystem_mainFunc_3_text: '查看、导入控制系统的成本耗材统计、报警统计等信息。',
    software_pipingSystem_mainFunc_4_title: '设备监控大屏',
    software_pipingSystem_mainFunc_4_text: '查看焊机状态、实时焊接数据、阈值报警故障报警信息，查看控制系统基本信息、使用人员信息、使用时间、焊接工艺规程及当前焊接的焊口、焊层信息。',
    software_pipingSystem_mainFunc_5_title: '工程组织监控大屏',
    software_pipingSystem_mainFunc_5_text: '可查看工程简介、报警占比信息以及设备列表。',
    software_pipingSystem_mainFunc_6_title: 'GPS监控大屏',
    software_pipingSystem_mainFunc_6_text: '实时掌握焊机位置，准确把控项目进度。',

    software_pipingSystem_value_1_title: '焊接规范化',
    software_pipingSystem_value_1_text: '设备关联工艺规程，焊接过程严格把控焊接参数，有效保证焊接质量。',
    software_pipingSystem_value_2_title: '检测自动化',
    software_pipingSystem_value_2_text: '实时监控焊接过程，及时推送阈值超限提醒，及时提醒焊工规范焊接过程。',
    software_pipingSystem_value_3_title: '配置智能化',
    software_pipingSystem_value_3_text: '每个设备可根据自身焊接模式或不同场景配置不同阈值参数和阈值范围。',

    // --- 焊接资源管理系统 (weldMaterialWarehouse) ---
    software_weldMaterialWarehouse_title: '焊接资源管理系统',
    software_weldMaterialWarehouse_text: '焊接资源管理系统是一种专门用于焊材仓储、管理和监控的智能软件系统。该系统可以记录焊材的入库、出库、库存、盘点等信息，帮助企业更好地了解仓库的运行情况，制定更加科学合理的库存管理策略，提高企业的运营效率和竞争力，实现焊材的信息化、智能化管理，提高焊材的利用率和管理效率。',
    software_weldMaterialWarehouse_textList_1: '规范焊材管理',
    software_weldMaterialWarehouse_textList_2: '提高工作效率',
    software_weldMaterialWarehouse_textList_3: '减少人工失误',
    software_weldMaterialWarehouse_textList_4: '提高库存准确性',

    software_weldMaterialWarehouse_mainFunctionTitle: '产品功能',
    software_weldMaterialWarehouse_mainFunc_1_title: '入库管理',
    software_weldMaterialWarehouse_mainFunc_1_text: '对合格的焊材进行登记入库操作，填写并打印入库单，记录焊材的名称、规格、数量、生产日期、保质期等信息，并建立焊材库存档案。',
    software_weldMaterialWarehouse_mainFunc_2_title: '出库管理',
    software_weldMaterialWarehouse_mainFunc_2_text: '对合格的焊材进行登记出库操作，填写并打印出库单，记录焊材的名称、规格、数量、生产日期、保质期等信息，并建立焊材库存档案。',
    software_weldMaterialWarehouse_mainFunc_3_title: '库存管理',
    software_weldMaterialWarehouse_mainFunc_3_text: '可以精确查询当前库存中各种焊材的库存量、牌号、规格等信息，方便管理人员随时了解库存情况。',
    software_weldMaterialWarehouse_mainFunc_4_title: '库存盘点',
    software_weldMaterialWarehouse_mainFunc_4_text: '以月/年为周期对仓库内的焊材进行清点 ， 保证焊材完好无损、帐物相符，确保日常生产正常进行。',
    software_weldMaterialWarehouse_mainFunc_5_title: '单据查询',
    software_weldMaterialWarehouse_mainFunc_5_text: '根据需要查询和打印各种报表信息，包括入库明细表、出库明细表、库存报表等，方便管理人员进行数据分析和决策。',
    software_weldMaterialWarehouse_mainFunc_6_title: '出入库统计',
    software_weldMaterialWarehouse_mainFunc_6_text: '系统可以对每个仓库焊材的出入库情况进行统计，包括入库数量、出库数量、库存数量等，以及相应的操作人员、时间等信息。用户可以根据需要进行时间段的统计和分析，了解仓库具体的出入库情况。',

    software_weldMaterialWarehouse_value_1_title: '提高管理效率',
    software_weldMaterialWarehouse_value_1_text: '通过智能化的管理方式，提高了焊材的出入库、盘点等操作的效率和准确性，减少了人工操作的繁琐和误差，降低了管理成本。',
    software_weldMaterialWarehouse_value_2_title: '优化库存结构',
    software_weldMaterialWarehouse_value_2_text: '系统通过对库存数据分析，帮助企业及时调整库存结构，避免库存积压和浪费，降低了库存成本。',
    software_weldMaterialWarehouse_value_3_title: '保证焊材质量',
    software_weldMaterialWarehouse_value_3_text: '通过预防性维护和预警功能，系统可以及时发现和处理焊材库存过期等问题，保证了焊材的质量和使用效果。',

    software_weldMaterialWarehouse_contrastTitle: '焊接资源管理系统使用前后对比',
    software_weldMaterialWarehouse_contrast_1_title: '焊材利用率',
    software_weldMaterialWarehouse_contrast_2_title: '管理效率提高',
    software_weldMaterialWarehouse_contrast_3_title: '生产效率提高',
    software_weldMaterialWarehouse_contrast_4_title: '焊材成本节约',

    // --- 焊接工艺管理系统 (weldTechnology) ---
    software_weldTechnology_title: '焊接工艺管理系统',
    software_weldTechnology_text: '通过软件系统的手段辅助焊接工艺人员快速完成焊接工艺文件编制,提高文件传递效率和数据准确性。',
    software_weldTechnology_functionTitle: '解决问题',
    
    software_weldTechnology_mainFunctionTitle: '产品功能',
    software_weldTechnology_mainFunc_1_title: 'PQR数据管理',
    software_weldTechnology_mainFunc_1_text: '支持焊接工艺评定文件及数据基本管理；支持焊接工艺评定数据导入与导出；支持焊接工艺评定速查与筛选.',
    software_weldTechnology_mainFunc_2_title: 'WPS文件编制',
    software_weldTechnology_mainFunc_2_text: '焊接工艺卡制作时，根据输入的母材、厚度等信息自动筛选符合条件的焊接工艺评定报告工艺参数，制卡人员选择符合的参数，系统自动带入，同时系统带有自动记忆功能，每当完成一种焊接工艺卡，下次制作时可直接调用，只需简单修改就能完成工艺卡制作。',
    software_weldTechnology_mainFunc_2_text1: '支持系统根据工艺人员输入的焊接方法、母材牌号、规格、热处理种类、焊接位置等信息筛选焊工与焊接工艺评定，并实现焊评数据中评定编号、焊接层道、电流、电压、预热温度、层间温度等数据自动填充到焊接工艺卡中，可对其中某项参数进行修改。',
    software_weldTechnology_mainFunc_3_title: '焊接工艺执行监控',
    software_weldTechnology_mainFunc_3_text: '实时监控每台设备运行状态、产品、焊工、关键工艺数据情况， 焊接故障可及时报警。',
    software_weldTechnology_mainFunc_3_text1: '实时监控设备状态、焊工、焊接电流、电压等关键工艺数据，显示焊接数据曲线，包括设备基本信息、产品信息、当前设备使用率等多方位信息。',
    software_weldTechnology_mainFunc_4_title: '工艺符合度',
    software_weldTechnology_mainFunc_4_text: '统计工艺符合度报表，展示每条焊缝的焊接有效时长、超范围焊接时长、工艺符合度、施焊人员等信息。',
    software_weldTechnology_mainFunc_4_text1: '统计焊工的焊接工艺符合度达成率,并进行排序。',

    software_weldTechnology_value_1_title: '工艺制造',
    software_weldTechnology_value_1_text: '规范化、智能化',
    software_weldTechnology_value_2_title: '工艺文件',
    software_weldTechnology_value_2_text: '工艺文件数字化、可扩展化',
    software_weldTechnology_value_3_title: '工艺监控',
    software_weldTechnology_value_3_text: '工艺监控标准化、自动化',

    software_weldTechnology_contrastTitle: '焊接工艺管理系统使用前后对比',
    software_weldTechnology_contrast_1_title: '文件编制效率提升',
    software_weldTechnology_contrast_2_title: '纸质文件减少',
    software_weldTechnology_contrast_3_title: '工艺符合度提升',

    // --- 焊工信息管理系统 (welderInformation) ---
    software_welderInformation_title: '焊工信息管理系统',
    software_welderInformation_text: '焊工信息管理系统实现焊工档案资质的全面数字化管理，确保焊工持证有效性。对焊工资源进行精确分析，以达到各厂区合理分配的目的。提高焊工管理的效率和准确性。',
    software_welderInformation_functionTitle: '产品功能',
    
    software_welderInformation_func_1_title: '焊工档案管理',
    software_welderInformation_func_1_text: '建立完善的焊工信息库，实现焊工个人信息的维护和管理，提供简洁直观的界面，方便查看和更新基本信息。',
    software_welderInformation_func_2_title: '焊工持证信息',
    software_welderInformation_func_2_text: '跟踪焊工的持证状态，了解焊工资格期限情况，满足企业对焊工的资格查询。',
    software_welderInformation_func_3_title: '焊工焊绩',
    software_welderInformation_func_3_text: '对焊工业绩进行维护满足企业精确派工需求。',
    software_welderInformation_func_4_title: '焊工探伤合格率',
    software_welderInformation_func_4_text: '跟踪焊工参与的探伤项目，记录合格与不合格的探伤结果。统计焊工的探伤合格率，提供直观的报表和分析。',
    software_welderInformation_func_5_title: '焊工工时统计',
    software_welderInformation_func_5_text: '按焊工维度记录每日焊接工时，生成月度工时统计报表，实现精准的焊工工时管理。',
    software_welderInformation_func_6_title: '焊工工艺符合度',
    software_welderInformation_func_6_text: '生成焊工工艺符合度报表，展示焊缝的工艺符合度以及施焊人员等关键信息。',

    software_welderInformation_value_1_title: '提高管理效率',
    software_welderInformation_value_1_text: '简化了焊工信息录入和查询流程，提高了管理效率。',
    software_welderInformation_value_2_title: '提升焊接质量',
    software_welderInformation_value_2_text: '通过可视化数据报表，分析焊工焊接项目合格率和焊接工艺符合度，提升焊接质量。',
    software_welderInformation_value_3_title: '提高精确性',
    software_welderInformation_value_3_text: '减少了手动劳动和信息遗漏，实现了精准的资质匹配，避免证不对工的情况。',

    software_welderInformation_contrastTitle: '焊工信息管理系统使用前后对比',
    software_welderInformation_contrast_1_title: '管理效率提升',
    software_welderInformation_contrast_2_title: '焊接质量',
    software_welderInformation_contrast_3_title: '数据准确性',

    // --- 智能焊接视讯系统 (videoSystem) ---
    software_videoSystem_title: '智能焊接视讯系统',
    software_videoSystem_text: '通过智能焊接视讯系统实时监控、回溯车间现场的焊接状况，及时发现、处理突发情况，保证人身安全、财产安全、设备安全等。使用系统可以全天候监控生产，大大提高生产、工作效率。',
    software_videoSystem_functionTitle: '产品功能',
    
    software_videoSystem_func_1_title: '设备信息监控',
    software_videoSystem_func_1_text: '系统实时监控车间现场，监控焊接设备的实时数据，以及监控焊接人员、焊接设备的工作状况。',
    software_videoSystem_func_2_title: '设备信息管理',
    software_videoSystem_func_2_text: '系统对焊接设备的基本信息、维护保养进行管理，以及对监控设备的基本信息进行管理。焊接设备与监控设备关联，通过视频监控设备，来提高设备的使用率。',
    software_videoSystem_func_3_title: '设备数据追溯',
    software_videoSystem_func_3_text: '系统对焊接过程的数据进行采集、存储。通过系统追溯历史数据的同时，播放焊接视频，便于更直观的进行数据分析。',
    software_videoSystem_func_4_title: '成本信息统计',
    software_videoSystem_func_4_text: '系统采集焊接数据，对数据进行存储、分析，统计焊接设备的焊丝用量、气流量、电量。便于管理层优化焊接生产、降低生产成本，提供数据支持。',
    software_videoSystem_func_5_title: '工时信息统计',
    software_videoSystem_func_5_text: '通过焊接工时统计以及视频监控的双重监测，了解焊接设备的使用情况，管理者通过相应的管理方式来提高焊接设备的使用率。',
    software_videoSystem_func_6_title: '报警信息统计',
    software_videoSystem_func_6_text: '实时统计报警数据并分析，管理者通过监控视频，远程监控报警焊机的状况，及时处理，以便于提高工作效率。',

    software_videoSystem_value_1_title: '提高生产效率',
    software_videoSystem_value_1_text: '远程视频监控车间现场状况，及时发现生产中的不足，及时调整，提高生产效率。',
    software_videoSystem_value_2_title: '提高设备使用率',
    software_videoSystem_value_2_text: '实时视频监控车间现场设备使用状况，能够及时发现焊接设备的问题以及使用焊接设备不合理的情况，及时处理，从而提高设备使用率。',
    software_videoSystem_value_3_title: '生产数据追溯',
    software_videoSystem_value_3_text: '监控视频、焊接数据存档。通过历史数据和视频，更直观的了解当时的生产状况，有助于管理者后期制定生产计划提供全面的数据支持。',

    software_videoSystem_contrastTitle: '智能焊接视讯系统使用前后对比',
    software_videoSystem_contrast_1_title: '设备使用率提升',
    software_videoSystem_contrast_2_title: '生产效率提升',
    software_videoSystem_contrast_3_title: '安全性提高',

    // --- 奥太微群控小程序 (groupControlApplet) ---
    software_groupControlApplet_title: '奥太微群控小程序',
    software_groupControlApplet_text: '奥太微群控是一款基于奥太智能焊接云系统的微信小程序，具有设备监控、成本统计、设备资料、消息提醒等功能。用户无需下载APP，打开手机微信APP的扫一扫功能，即可在手机中体验奥太智能焊接云系统的智能化产品。',
    software_groupControlApplet_functionTitle: '小程序入口',
    
    software_groupControlApplet_mainFunctionTitle: '功能模块',
    software_groupControlApplet_mainFunc_1_title: '实时监控',
    software_groupControlApplet_mainFunc_1_text: '实时显示焊机运行状态 ，实时显示工作时长等信息',
    software_groupControlApplet_mainFunc_2_title: '消息提醒',
    software_groupControlApplet_mainFunc_2_text: '系统消息、企业消息、设备故障信息实时通知',
    software_groupControlApplet_mainFunc_3_title: '设备资料',
    software_groupControlApplet_mainFunc_3_text: '奥太设备说明书、故障代码等资料实时查阅',

    software_groupControlApplet_contrastTitle: '产品价值'
  },

  hardware: {
    hardware_products: "硬件产品",
    hardware_products_text: "通过数字化联网改造、升级的方式，采集设备实时的生产焊接数据，实时掌握设备运行状态、设备利用率、焊工焊接效率、资源消耗（焊材、保护气体、电能）等情况，通过实时的焊接数据与工艺要求对比，掌控焊接质量。",
    product_center: "产品中心",
    product_center_text:"以客户的成功定义成功，赋能企业管理，来自企业的信赖",
    // --- 通用 ---
    hardware_common_featureTitle: "功能特点及优势",
    hardware_common_applicableModels: "<span style='font-weight: bold;'>适用机型：</span>",
    hardware_common_remark: "备注",
    technical_specifications:"技术参数",

    // --- ATQ-RS422/4G ---
    hardware_ATQ_RS422_4G_title: "通信控制器4G外置 ATQ-RS422/4G",
    hardware_ATQ_RS422_4G_title_zh: "通信控制器4G外置",
    hardware_ATQ_RS422_4G_content1_1: "ATQ-RS422/4G通信控制器，可应用于奥太数字化焊机，该产品应用在上位机系统与焊机之间，通过4G实现焊机与上位机系统通信数据的上下行。并且可按照客户应用需求，选配误差在2.5M内的GPS定位。可以及时发现客户焊机故障，并提供及时、精准的售后服务。",
    hardware_ATQ_RS422_4G_content1_3: "■ 适配奥太数字化群控焊机专用接口，实施使用便捷",
    hardware_ATQ_RS422_4G_content1_4: "①操作和接入方式简单，无需进行网络配置",
    hardware_ATQ_RS422_4G_content1_5: "②无需繁琐的现场组网施工，降低实施费用",
    hardware_ATQ_RS422_4G_content1_6: "③无需准备和维护服务器，可随时随地登录查看",
    hardware_ATQ_RS422_4G_content1_7: "④可从容应对复杂的现场条件",
    hardware_ATQ_RS422_4G_content1_8: "■ 与焊机主板直接通信，获取实时焊接电流、焊接电压、送丝速度，无需外加其他传感器，完成实时数据的监控以及统计，包括给定电流、给定电压、焊接电流、焊接电压、送丝速度、焊接时间等",
    hardware_ATQ_RS422_4G_content1_9: "■ 采样频率: 标准为1HZ，可根据用户实际情况进行定制",
    hardware_ATQ_RS422_4G_content1_10: "■ 数据传输稳定性: 整个焊接设备通过4G传输到焊接云服务器，稳定的三大运营商4G网络以及设备的缓存功能保证了数据实时性以及完整性",
    hardware_ATQ_RS422_4G_content_1: "ATQ-RS422/4G通信控制器，可应用于奥太数字化焊机，实现焊机信息化管理。",
    hardware_ATQ_RS422_4G_tableTitle: "技术参数",
    hardware_ATQ_RS422_4G_table_tb1_1: "型号",
    hardware_ATQ_RS422_4G_table_tb3_1: "备注",
    hardware_ATQ_RS422_4G_table_tb1_2: "额定输入电压",
    hardware_ATQ_RS422_4G_table_tb2_2: "AC38V",
    hardware_ATQ_RS422_4G_table_tb3_2: "焊机内部供电",
    hardware_ATQ_RS422_4G_table_tb1_3: "联网方式",
    hardware_ATQ_RS422_4G_table_tb2_3: "4G",
    hardware_ATQ_RS422_4G_table_tb1_4: "4G",
    hardware_ATQ_RS422_4G_table_tb2_4: "移动、联通、电信",
    hardware_ATQ_RS422_4G_table_tb3_4: "SIM卡出厂自带",
    hardware_ATQ_RS422_4G_table_tb1_5: "气体流量检测",
    hardware_ATQ_RS422_4G_table_tb2_5: "支持气体流量检测",
    hardware_ATQ_RS422_4G_table_tb3_5: "需另外采购气体流量检测设备",
    hardware_ATQ_RS422_4G_table_tb1_6: "LBS(基于位置服务)",
    hardware_ATQ_RS422_4G_table_tb2_6: "基站定位",
    hardware_ATQ_RS422_4G_table_tb3_6: "附近有基站信号，并配有SIM卡",
    hardware_ATQ_RS422_4G_table_tb1_7: "刷卡功能",
    hardware_ATQ_RS422_4G_table_tb2_7: "支持",
    hardware_ATQ_RS422_4G_table_tb3_7: "采购焊机时需配套刷卡模块",
    hardware_ATQ_RS422_4G_table_tb1_8: "安装方式",
    hardware_ATQ_RS422_4G_table_tb2_8: "焊机外挂",
    hardware_ATQ_RS422_4G_table_tb1_9: "外壳防护等级",
    hardware_ATQ_RS422_4G_table_tb2_9: "IP21S",
    hardware_ATQ_RS422_4G_table_tb1_10: "绝缘等级",
    hardware_ATQ_RS422_4G_table_tb2_10: "H",

    // --- ATQ-RS422/WF-II ---
    hardware_ATQ_RS422_WF_II_title: "通信控制器WIFI外置 ATQ-RS422/WF-II",
    hardware_ATQ_RS422_WF_II_title_zh: "通信控制器WIFI外置",
    hardware_ATQ_RS422_WF_II_content1_1: "ATQ系列通信控制器，可应用于奥太数字化焊机，完成焊机与服务器之间的通信，实现焊机所有参数的采集、控制。 通信控制器可选用有线、无线通信方式，内部设有实时时钟及大容量数据存储器，当无法连接到服务器时可实现数据暂存，保证系统数据完整性。",
    hardware_ATQ_RS422_WF_II_content1_3: "■ 奥太数字化群控焊机专用接口，出厂后安装调试完毕，无需客户现场改造",
    hardware_ATQ_RS422_WF_II_content1_4: "■ 与焊机主板直接通信，获取实时焊接电流、焊接电压、送丝速度，无需外加其他传感器，完成实时数据的监控以及统计，包括给定电流、给定电压、焊接电流、焊接电压、送丝速度、焊接时间等",
    hardware_ATQ_RS422_WF_II_content1_5: "■ 采样频率：标准为1HZ，可根据用户实际情况进行定制",
    hardware_ATQ_RS422_WF_II_content1_6: "■ 数据安全保密性：焊接数据所存放的焊接云服务器放置在用户机房，保证保密性数据的安全",
    hardware_ATQ_RS422_WF_II_content1_7: "■ 数据传输稳定性：整个焊接设备通过WiFi传输到车间无线网络，途径企业网络，最后到达焊接云服务器，成熟的网络部署保证了数据实时性以及完整性",
    hardware_ATQ_RS422_WF_II_content1_8: "■ 网络部署后无需顾虑流量费：所有设备都是采用工业WiFi数据传输，一次性部署网络后，所有的无线设备都可以使用，不会涉及流量套餐费用",
    hardware_ATQ_RS422_WF_II_content_1: "ATQ-RS422/WF-II通信控制器，可应用于奥太数字化焊机，实现焊机信息化管理。",
    hardware_ATQ_RS422_WF_II_tableTitle: "技术参数",
    hardware_ATQ_RS422_WF_II_table_tb1_1: "型号",
    hardware_ATQ_RS422_WF_II_table_tb2_1: "ATQ-RS422/WF-II",
    hardware_ATQ_RS422_WF_II_table_tb1_2: "额定输入电压",
    hardware_ATQ_RS422_WF_II_table_tb2_2: "AC38V",
    hardware_ATQ_RS422_WF_II_table_tb3_2: "焊机内部供电",
    hardware_ATQ_RS422_WF_II_table_tb1_3: "联网方式",
    hardware_ATQ_RS422_WF_II_table_tb2_3: "WIFI",
    hardware_ATQ_RS422_WF_II_table_tb1_4: "WIFI",
    hardware_ATQ_RS422_WF_II_table_tb2_4: "AP",
    hardware_ATQ_RS422_WF_II_table_tb3_4: "AP必须是英文名称",
    hardware_ATQ_RS422_WF_II_table_tb1_5: "气体流量检测",
    hardware_ATQ_RS422_WF_II_table_tb2_5: "支持气体流量检测",
    hardware_ATQ_RS422_WF_II_table_tb3_5: "需另外采购气体流量检测设备",
    hardware_ATQ_RS422_WF_II_table_tb1_6: "刷卡功能",
    hardware_ATQ_RS422_WF_II_table_tb2_6: "支持",
    hardware_ATQ_RS422_WF_II_table_tb3_6: "采购焊机时需配套刷卡模块",
    hardware_ATQ_RS422_WF_II_table_tb1_7: "安装方式",
    hardware_ATQ_RS422_WF_II_table_tb2_7: "焊机外挂",
    hardware_ATQ_RS422_WF_II_table_tb1_8: "外壳防护等级",
    hardware_ATQ_RS422_WF_II_table_tb2_8: "IP21S",
    hardware_ATQ_RS422_WF_II_table_tb1_9: "绝缘等级",
    hardware_ATQ_RS422_WF_II_table_tb2_9: "H",

    // --- ATR-485-Ⅱ ---
    hardware_ATR_485_II_title: "通信控制器 ATR-485-Ⅱ",
    hardware_ATR_485_II_title_zh: "通信控制器",
    hardware_ATR_485_II_content_1: "ATR-485-Ⅱ通信控制器用于实现奥太焊机与专机或机器人之间的通讯。与专机或机器人之间的通讯采用标准的ModBus-RTU协议。",
    hardware_ATR_485_II_content_3: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_485_II_tableTitle: "技术参数",
    hardware_ATR_485_II_table_tb1_1: "型号",
    hardware_ATR_485_II_table_tb2_1: "ATR-485-Ⅱ",
    hardware_ATR_485_II_table_tb1_2: "电源",
    hardware_ATR_485_II_table_tb2_2: "交流38V",
    hardware_ATR_485_II_table_tb1_3: "通信接口",
    hardware_ATR_485_II_table_tb2_3: "RS422、RS485",
    hardware_ATR_485_II_table_tb1_4: "指示灯",
    hardware_ATR_485_II_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_485_II_table_tb1_5: "工作环境",
    hardware_ATR_485_II_table_tb2_5: "-20℃~40℃",
    hardware_ATR_485_II_table_tb1_6: "防护等级",
    hardware_ATR_485_II_table_tb2_6: "IP23S",
    hardware_ATR_485_II_table_tb1_7: "结构",
    hardware_ATR_485_II_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_485_II_table_tb1_8: "外形尺寸",
    hardware_ATR_485_II_table_tb2_8: "104*100*50",

    // --- ATR-CAN-Ⅱ ---
    hardware_ATR_CAN_II_title: "通信控制器 ATR-CAN-Ⅱ",
    hardware_ATR_CAN_II_title_zh: "通信控制器",
    hardware_ATR_CAN_II_content_1: "奥太ATR-CAN-II通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端CAN协议与焊机通信协议的转换。",
    hardware_ATR_CAN_II_content_3: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_CAN_II_tableTitle: "技术参数",
    hardware_ATR_CAN_II_table_tb1_1: "型号",
    hardware_ATR_CAN_II_table_tb2_1: "ATR-CAN-II",
    hardware_ATR_CAN_II_table_tb1_2: "电源",
    hardware_ATR_CAN_II_table_tb2_2: "交流38V",
    hardware_ATR_CAN_II_table_tb1_3: "通信接口",
    hardware_ATR_CAN_II_table_tb2_3: "RS422、CAN",
    hardware_ATR_CAN_II_table_tb1_4: "指示灯",
    hardware_ATR_CAN_II_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_CAN_II_table_tb1_5: "工作环境",
    hardware_ATR_CAN_II_table_tb2_5: "-20℃~40℃",
    hardware_ATR_CAN_II_table_tb1_6: "防护等级",
    hardware_ATR_CAN_II_table_tb2_6: "IP23S",
    hardware_ATR_CAN_II_table_tb1_7: "结构",
    hardware_ATR_CAN_II_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_CAN_II_table_tb1_8: "外形尺寸",
    hardware_ATR_CAN_II_table_tb2_8: "104*100*50",

    // --- ATR-CANOPEN ---
    hardware_ATR_CANOPEN_title: "通信控制器 ATR-CANOPEN",
    hardware_ATR_CANOPEN_title_zh: "通信控制器",
    hardware_ATR_CANOPEN_content_1: "奥太ATR-CANOPEN通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端CANOPEN协议与焊机通信协议的转换。",
    hardware_ATR_CANOPEN_content_2: "CANOPEN是一种基于CAN总线技术的开放型、符合全球工业标准的低成本、高性能的通信网络。",
    hardware_ATR_CANOPEN_content_4: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_CANOPEN_tableTitle: "技术参数",
    hardware_ATR_CANOPEN_table_tb1_1: "型号",
    hardware_ATR_CANOPEN_table_tb2_1: "ATR-CANOPEN",
    hardware_ATR_CANOPEN_table_tb1_2: "电源",
    hardware_ATR_CANOPEN_table_tb2_2: "交流38V",
    hardware_ATR_CANOPEN_table_tb1_3: "通信接口",
    hardware_ATR_CANOPEN_table_tb2_3: "RS422、CANOpen",
    hardware_ATR_CANOPEN_table_tb1_4: "指示灯",
    hardware_ATR_CANOPEN_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_CANOPEN_table_tb1_5: "工作环境",
    hardware_ATR_CANOPEN_table_tb2_5: "-20℃~40℃",
    hardware_ATR_CANOPEN_table_tb1_6: "防护等级",
    hardware_ATR_CANOPEN_table_tb2_6: "IP23S",
    hardware_ATR_CANOPEN_table_tb1_7: "结构",
    hardware_ATR_CANOPEN_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_CANOPEN_table_tb1_8: "外形尺寸",
    hardware_ATR_CANOPEN_table_tb2_8: "104*100*50",

    // --- ATR-DEV-Ⅳ ---
    hardware_ATR_DEV_IV_title: "通信控制器 ATR-DEV-Ⅳ",
    hardware_ATR_DEV_IV_title_zh: "通信控制器",
    hardware_ATR_DEV_IV_content_1: "奥太ATR-DEV-Ⅳ机器人接口盒用于专机或机器人焊接系统，该控制器实现了专机或机器人端DeviceNet协议与焊机通信协议的转换。",
    hardware_ATR_DEV_IV_content_2: "DeviceNet是一种基于CAN总线技术的开放型、符合全球工业标准的低成本、高性能的通信网络。",
    hardware_ATR_DEV_IV_content_4: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_DEV_IV_tableTitle: "技术参数",
    hardware_ATR_DEV_IV_table_tb1_1: "型号",
    hardware_ATR_DEV_IV_table_tb2_1: "ATR-CANOPEN",
    hardware_ATR_DEV_IV_table_tb1_2: "电源",
    hardware_ATR_DEV_IV_table_tb2_2: "交流38V",
    hardware_ATR_DEV_IV_table_tb1_3: "通信接口",
    hardware_ATR_DEV_IV_table_tb2_3: "RS422、DeviceNet",
    hardware_ATR_DEV_IV_table_tb1_4: "指示灯",
    hardware_ATR_DEV_IV_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_DEV_IV_table_tb1_5: "工作环境",
    hardware_ATR_DEV_IV_table_tb2_5: "-20℃~40℃",
    hardware_ATR_DEV_IV_table_tb1_6: "防护等级",
    hardware_ATR_DEV_IV_table_tb2_6: "IP23S",
    hardware_ATR_DEV_IV_table_tb1_7: "结构",
    hardware_ATR_DEV_IV_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_DEV_IV_table_tb1_8: "外形尺寸",
    hardware_ATR_DEV_IV_table_tb2_8: "104*100*50",

    // --- ATR-EtherCAT ---
    hardware_ATR_EtherCAT_title: "通信控制器 ATR-EtherCAT",
    hardware_ATR_EtherCAT_title_zh: "通信控制器",
    hardware_ATR_EtherCAT_content_1: "奥太ATR-EtherCAT通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端EtherCAT协议与焊机通信协议的转换。",
    hardware_ATR_EtherCAT_content_2: "本产品EtherCAT接口使用EtherCAT协议芯片，完全符合国际标准和规范。",
    hardware_ATR_EtherCAT_content_4: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_EtherCAT_tableTitle: "技术参数",
    hardware_ATR_EtherCAT_table_tb1_1: "型号",
    hardware_ATR_EtherCAT_table_tb2_1: "ATR-EtherCAT",
    hardware_ATR_EtherCAT_table_tb1_2: "电源",
    hardware_ATR_EtherCAT_table_tb2_2: "交流38V",
    hardware_ATR_EtherCAT_table_tb1_3: "通信接口",
    hardware_ATR_EtherCAT_table_tb2_3: "RS422、EtherCAT",
    hardware_ATR_EtherCAT_table_tb1_4: "指示灯",
    hardware_ATR_EtherCAT_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_EtherCAT_table_tb1_5: "工作环境",
    hardware_ATR_EtherCAT_table_tb2_5: "-20℃~40℃",
    hardware_ATR_EtherCAT_table_tb1_6: "防护等级",
    hardware_ATR_EtherCAT_table_tb2_6: "IP23S",
    hardware_ATR_EtherCAT_table_tb1_7: "结构",
    hardware_ATR_EtherCAT_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_EtherCAT_table_tb1_8: "外形尺寸",
    hardware_ATR_EtherCAT_table_tb2_8: "104*100*50",

    // --- ATR-PROFINET ---
    hardware_ATR_PROFINET_title: "通信控制器 ATR-FROFINET",
    hardware_ATR_PROFINET_title_zh: "通信控制器",
    hardware_ATR_PROFINET_content_1: "奥太 ATR-PROFINET 通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端 PROFINET 协议与焊机通信协议的转换。",
    hardware_ATR_PROFINET_content_2: "PROFINET 是新一代基于工业以太网技术的自动化总线标准。本产品符合 PROFINET IO 一致性类别：CC-C；从硬件级支持 PROFINET 协议 ,包括 PTCP 和 LLDP；具有两个支持自动协商、自动交叉、全双工 100Mpbs 的以太网接口。",
    hardware_ATR_PROFINET_content_4: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_PROFINET_tableTitle: "技术参数",
    hardware_ATR_PROFINET_table_tb1_1: "型号",
    hardware_ATR_PROFINET_table_tb2_1: "ATR-PROFINET",
    hardware_ATR_PROFINET_table_tb1_2: "电源",
    hardware_ATR_PROFINET_table_tb2_2: "交流38V",
    hardware_ATR_PROFINET_table_tb1_3: "通信接口",
    hardware_ATR_PROFINET_table_tb2_3: "RS422、PROFINET",
    hardware_ATR_PROFINET_table_tb1_4: "指示灯",
    hardware_ATR_PROFINET_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_PROFINET_table_tb1_5: "工作环境",
    hardware_ATR_PROFINET_table_tb2_5: "-20℃~40℃",
    hardware_ATR_PROFINET_table_tb1_6: "防护等级",
    hardware_ATR_PROFINET_table_tb2_6: "IP23S",
    hardware_ATR_PROFINET_table_tb1_7: "结构",
    hardware_ATR_PROFINET_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_PROFINET_table_tb1_8: "外形尺寸",
    hardware_ATR_PROFINET_table_tb2_8: "104*100*50",

    // --- ATR-GATEWAY ---
    hardware_ATR_GATEWAY_title: "机器人网关 ATR-GATEWAY",
    hardware_ATR_GATEWAY_title_zh: "机器人网关",
    hardware_ATR_GATEWAY_illustrateTitle: "机器人网关系列产品功能对照表：",
    hardware_ATR_GATEWAY_content1_1: "奥太ATR-GATEWAY通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端多种通信协议与奥太焊机通信协议的转换。",
    hardware_ATR_GATEWAY_content1_3: "■ 奥太ATR-GATEWAY系列机器人网关主要应用于专机或机器人焊接系统，该系列产品实现了专机或机器人端通信协议与奥太焊机通信协议的转换，并且可以选配4G或WIFI群控功能。",
    hardware_ATR_GATEWAY_content1_4: "■ 焊机与机器人通信的ALL-IN-ONE解决方案。同一款接口盒可以支持多种协议，更换通信方式无需重复采购。ATR-GATEWAY型机器人网关支持的通信协议包括DeviceNet、Canopen、AOTAICAN、 MODBUS-RTU、 MODBUS-TCP。",
    hardware_ATR_GATEWAY_content1_5: "■ 能够通过多种网络通信方式（4G、WIFI等）接入奥太智能焊接云系统和智能焊接机器人监控系统",
    hardware_ATR_GATEWAY_content_1: "奥太ATR-GATEWAY通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端多种通信协议与奥太焊机通信协议的转换。",
    hardware_ATR_GATEWAY_content_3: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_GATEWAY_tableTitle: "技术参数",
    hardware_ATR_GATEWAY_table_tb1_1: "型号",
    hardware_ATR_GATEWAY_table_tb2_1: "ATR-GATEWAY",
    hardware_ATR_GATEWAY_table_tb1_2: "电源",
    hardware_ATR_GATEWAY_table_tb2_2: "交流38V",
    hardware_ATR_GATEWAY_table_tb1_3: "通信接口",
    hardware_ATR_GATEWAY_table_tb2_3: "RS422、RS485、CAN、以太网（10M/100M自适应）",
    hardware_ATR_GATEWAY_table_tb1_4: "指示灯",
    hardware_ATR_GATEWAY_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_GATEWAY_table_tb1_5: "工作环境",
    hardware_ATR_GATEWAY_table_tb2_5: "-20℃~40℃",
    hardware_ATR_GATEWAY_table_tb1_6: "防护等级",
    hardware_ATR_GATEWAY_table_tb2_6: "IP23S",
    hardware_ATR_GATEWAY_table_tb1_7: "结构",
    hardware_ATR_GATEWAY_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_GATEWAY_table_tb1_8: "外形尺寸",
    hardware_ATR_GATEWAY_table_tb2_8: "104*100*50",

    // --- ATR-GW-EIP ---
    hardware_ATR_GW_EIP_title: "机器人网关 ATR-GW-EIP",
    hardware_ATR_GW_EIP_title_zh: "机器人网关",
    hardware_ATR_GW_EIP_illustrateTitle: "机器人网关系列产品功能对照表：",
    hardware_ATR_GW_EIP_content1_1: "奥太ATR-GW-EIP通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端多种通信协议与奥太焊机通信协议的转换。",
    hardware_ATR_GW_EIP_content1_3: "■ 奥太ATR-GW-EIP系列机器人网关主要应用于专机或机器人焊接系统，该系列产品实现了专机或机器人端通信协议与奥太焊机通信协议的转换，并且可以选配4G或WIFI群控功能。",
    hardware_ATR_GW_EIP_content1_4: "■ 焊机与机器人通信的ALL-IN-ONE解决方案。同一款接口盒可以支持多种协议，更换通信方式无需重复采购。ATR-GW-EIP型机器人网关支持的通信协议包括DeviceNet、Canopen、AOTAICAN、 MODBUS-RTU、 MODBUS-TCP和EtherNet/IP。",
    hardware_ATR_GW_EIP_content1_5: "■ 能够通过多种网络通信方式（4G、WIFI等）接入奥太智能焊接云系统和智能焊接机器人监控系统",
    hardware_ATR_GW_EIP_content_1: "奥太ATR-GW-EIP通信控制器用于专机或机器人焊接系统，该控制器实现了专机或机器人端多种通信协议与奥太焊机通信协议的转换。",
    hardware_ATR_GW_EIP_content_3: "NBC-350R/500R，MAG-350RL，MAG-350RPL，Pulse MIG-350RP/500RP，WSM-400R，WSME-315R，WSM-400RHW等奥太机器人配套焊机。",
    hardware_ATR_GW_EIP_tableTitle: "技术参数",
    hardware_ATR_GW_EIP_table_tb1_1: "型号",
    hardware_ATR_GW_EIP_table_tb2_1: "ATR-GW-EIP",
    hardware_ATR_GW_EIP_table_tb1_2: "电源",
    hardware_ATR_GW_EIP_table_tb2_2: "交流38V",
    hardware_ATR_GW_EIP_table_tb1_3: "通信接口",
    hardware_ATR_GW_EIP_table_tb2_3: "RS422、RS485、CAN、以太网（10M/100M自适应）",
    hardware_ATR_GW_EIP_table_tb1_4: "指示灯",
    hardware_ATR_GW_EIP_table_tb2_4: "电源指示灯、通信状态指示灯",
    hardware_ATR_GW_EIP_table_tb1_5: "工作环境",
    hardware_ATR_GW_EIP_table_tb2_5: "-20℃~40℃",
    hardware_ATR_GW_EIP_table_tb1_6: "防护等级",
    hardware_ATR_GW_EIP_table_tb2_6: "IP23S",
    hardware_ATR_GW_EIP_table_tb1_7: "结构",
    hardware_ATR_GW_EIP_table_tb2_7: "铝型材一体式结构",
    hardware_ATR_GW_EIP_table_tb1_8: "外形尺寸",
    hardware_ATR_GW_EIP_table_tb2_8: "104*100*50",

    // --- ATQ-CJ500-4G ---
    hardware_ATQ_CJ500_4G_title: "焊接数据采集仪 ATQ-CJ500系列",
    hardware_ATQ_CJ500_4G_title_zh: "焊接数据采集仪",
    hardware_ATQ_CJ500_4G_content1_1: "焊接数据采集仪主要应用于直流弧焊电源，采集焊接过程中实时电流、电压等信号，并通过4G方式接入奥太智能焊接云系统，实现焊机信息化管理。",
    hardware_ATQ_CJ500_4G_content1_3: "■ 焊接实际电流实时采集",
    hardware_ATQ_CJ500_4G_content1_4: "■ 焊接实际电压实时采集",
    hardware_ATQ_CJ500_4G_content1_5: "■ 气体流量实时监测",
    hardware_ATQ_CJ500_4G_content1_6: "■ 送丝速度实时监测",
    hardware_ATQ_CJ500_4G_content1_7: "■ 参数超限报警和停机",
    hardware_ATQ_CJ500_4G_content1_8: "■ 通过IC卡或手机APP实现人员、焊机和工件相互绑定，实现焊接质量追溯以及焊工工作量统计等功能",
    hardware_ATQ_CJ500_4G_content1_9: "■ 支持多种网络接入方式",
    hardware_ATQ_CJ500_4G_content1_10: "支持接入有线以太网(可以使用有线局域网连接，适合对保密要求较高的客户)",
    hardware_ATQ_CJ500_4G_content1_11: "支持接入无线WIFI网络（焊机可在WIFI网络覆盖区域内任意移动）",
    hardware_ATQ_CJ500_4G_content1_12: "支持接入4G、5G网络（焊机可在4G、5G网络覆盖区域内任意移动）",
    hardware_ATQ_CJ500_4G_content1_13: "用户可以根据实际需要选择合适的网络接入方式",
    hardware_ATQ_CJ500_4G_content_1: "ATQ-CJ500系列焊接数据采集仪主要应用于直流弧焊电源，采集焊接过程中实时电流、电压等信号，并通过4G/5G/WIFI/EtherNet等方式接入奥太智能焊接云系统，实现焊机信息化管理。",
    hardware_ATQ_CJ500_4G_tableTitle: "技术参数",
    hardware_ATQ_CJ500_4G_table_tb1_1: "型号",
    hardware_ATQ_CJ500_4G_table_tb2_1: "ATQ-CJ500-4G",
    hardware_ATQ_CJ500_4G_table_tb1_2: "额定输入电压",
    hardware_ATQ_CJ500_4G_table_tb2_2: "两相380V",
    hardware_ATQ_CJ500_4G_table_tb1_3: "联网方式",
    hardware_ATQ_CJ500_4G_table_tb2_3: "4G/5G/WIFI/EtherNet",
    hardware_ATQ_CJ500_4G_table_tb1_4: "5G",
    hardware_ATQ_CJ500_4G_table_tb2_4: "移动、联通、电信支持 NSA 和 SA 模式",
    hardware_ATQ_CJ500_4G_table_tb3_4: "向下兼容4G",
    hardware_ATQ_CJ500_4G_table_tb1_5: "EtherNet",
    hardware_ATQ_CJ500_4G_table_tb2_5: "10/100M",
    hardware_ATQ_CJ500_4G_table_tb1_6: "4G",
    hardware_ATQ_CJ500_4G_table_tb2_6: "移动、联通、电信",
    hardware_ATQ_CJ500_4G_table_tb3_6: "SIM卡出厂自带",
    hardware_ATQ_CJ500_4G_table_tb1_7: "WIFI",
    hardware_ATQ_CJ500_4G_table_tb2_7: "2.4G（IEEE802.11b/g/n 标准）",
    hardware_ATQ_CJ500_4G_table_tb1_8: "IC卡刷卡功能",
    hardware_ATQ_CJ500_4G_table_tb2_8: "支持",
    hardware_ATQ_CJ500_4G_table_tb1_9: "气体流量检测",
    hardware_ATQ_CJ500_4G_table_tb2_9: "支持",
    hardware_ATQ_CJ500_4G_table_tb3_9: "需采购气体流量设备",
    hardware_ATQ_CJ500_4G_table_tb1_10: "LBS(基于位置服务)",
    hardware_ATQ_CJ500_4G_table_tb2_10: "基站定位",
    hardware_ATQ_CJ500_4G_table_tb3_10: "附近有基站信号，并配有SIM卡",
    hardware_ATQ_CJ500_4G_table_tb1_11: "离线存储功能",
    hardware_ATQ_CJ500_4G_table_tb2_11: "12个月循环存储",
    hardware_ATQ_CJ500_4G_table_tb3_11: "需另外采购Micro SD卡",
    hardware_ATQ_CJ500_4G_table_tb1_12: "安装方式",
    hardware_ATQ_CJ500_4G_table_tb2_12: "外置",
    hardware_ATQ_CJ500_4G_table_tb1_13: "外壳防护等级",
    hardware_ATQ_CJ500_4G_table_tb2_13: "IP21S",
    hardware_ATQ_CJ500_4G_table_tb1_14: "绝缘等级",
    hardware_ATQ_CJ500_4G_table_tb2_14: "H",

    // --- ATQ-IT070 ---
    hardware_ATQ_IT070_title: "智能焊接终端 ATQ-IT070",
    hardware_ATQ_IT070_title_zh: "智能焊接终端",
    hardware_ATQ_IT070_content1_1: "奥太ATQ-IT070型智能焊接终端适用于压力容器、化工、钢结构等行业，通过WIFI或者4G等方式接入奥太智能焊接云系统，能够实现焊接过程的智能化管理。",
    hardware_ATQ_IT070_content1_3: "■ 具备人机交互功能，支持按键以及触摸两种方式操作",
    hardware_ATQ_IT070_content1_4: "■ 支持IC卡自动识别焊工身份",
    hardware_ATQ_IT070_content1_5: "■ 实现焊接任务远程下发，保证焊工严格使用焊接工艺参数进行施焊",
    hardware_ATQ_IT070_content1_6: "■ 自动统计分析焊接过程，实现焊工工作过程、焊机工作过程的远程监测，统计焊机、焊工有效工时和工作量",
    hardware_ATQ_IT070_content1_7: "■ 支持断网续传功能，当网络异常后，数据将存储本地，网络恢复后，数据将自动进行上传，保证了数据的连续性",
    hardware_ATQ_IT070_content1_8: "■ 支持USB应用程序升级，通过智能焊接云系统实现应用程序远程升级",
    hardware_ATQ_IT070_content1_9: "■ 支持焊接数据报表导出",
    hardware_ATQ_IT070_content1_10: "■ 支持工艺数据库的远程更新",
    hardware_ATQ_IT070_content_1: "奥太ATQ-IT070型智能焊接终端适用于压力容器、化工、钢结构等行业，通过WIFI或者4G等方式接入奥太智能焊接云系统，能够实现焊接过程的智能化管理。",
    hardware_ATQ_IT070_tableTitle: "技术参数",
    hardware_ATQ_IT070_table_tb1_1: "型号",
    hardware_ATQ_IT070_table_tb2_1: "ATQ-IT070",
    hardware_ATQ_IT070_table_tb1_2: "额定输入电压",
    hardware_ATQ_IT070_table_tb2_2: "AC38V-42V",
    hardware_ATQ_IT070_table_tb1_3: "通信接口",
    hardware_ATQ_IT070_table_tb2_3: "RS422、RS485、CAN、以太网、WIFI/4G、USB",
    hardware_ATQ_IT070_table_tb1_4: "工作温度",
    hardware_ATQ_IT070_table_tb2_4: "-30℃~70℃",
    hardware_ATQ_IT070_table_tb1_5: "存储温度",
    hardware_ATQ_IT070_table_tb2_5: "-30℃~80℃",
    hardware_ATQ_IT070_table_tb1_6: "外壳防护等级",
    hardware_ATQ_IT070_table_tb2_6: "IP21S",

    // --- ATQ-GFS50 ---
    hardware_ATQ_GFS50_title: "气体流量计 ATQ-GFS50",
    hardware_ATQ_GFS50_title_zh: "气体流量计",
    hardware_ATQ_GFS50_content1_1: "奥太ATQ-GFS50气体流量计用于测量焊接保护气体流速，统计焊接保护气体流量。通过奥太4G/WIFI通信控制器可将流量及流速上传到奥太智能焊接云系统。",
    hardware_ATQ_GFS50_content1_3: "■ 焊接保护气体流速关联焊接质量，焊接保护气体流量关联生产成本",
    hardware_ATQ_GFS50_content1_4: "■ 可进行焊接保护气体流量及流速的实时测量，支持纯氩气，纯二氧化碳以及氩气与二氧化碳多种混合比例的气体测量",
    hardware_ATQ_GFS50_content1_5: "■ 通过奥太4G或WIFI通信控制器将焊接保护气体实时数据上传到奥太智能焊接云系统",
    hardware_ATQ_GFS50_content_1: "奥太ATQ-GFS50气体流量计用于测量焊接保护气体流速。",
    hardware_ATQ_GFS50_tableTitle: "技术参数",
    hardware_ATQ_GFS50_table_tb1_1: "型号",
    hardware_ATQ_GFS50_table_tb2_1: "ATQ-GFS50",
    hardware_ATQ_GFS50_table_tb1_2: "额定输入电压",
    hardware_ATQ_GFS50_table_tb2_2: "DC12-24V",
    hardware_ATQ_GFS50_table_tb1_3: "通信方式",
    hardware_ATQ_GFS50_table_tb2_3: "RS485",
    hardware_ATQ_GFS50_table_tb1_4: "气体类型",
    hardware_ATQ_GFS50_table_tb2_4: "Ar",
    hardware_ATQ_GFS50_table_tb1_5: "气体类型",
    hardware_ATQ_GFS50_table_tb2_5: "CO2",
    hardware_ATQ_GFS50_table_tb1_6: "气体类型",
    hardware_ATQ_GFS50_table_tb2_6: "Ar 92％，CO2 8％",
    hardware_ATQ_GFS50_table_tb1_7: "气体类型",
    hardware_ATQ_GFS50_table_tb2_7: "Ar 80％，CO2 20％",
    hardware_ATQ_GFS50_table_tb1_8: "气体类型",
    hardware_ATQ_GFS50_table_tb2_8: "Ar 60％，CO2 40％",
    hardware_ATQ_GFS50_table_tb1_9: "安装方式",
    hardware_ATQ_GFS50_table_tb2_9: "焊机外挂",
    hardware_ATQ_GFS50_table_tb1_10: "外壳防护等级",
    hardware_ATQ_GFS50_table_tb2_10: "IP21S",
    hardware_ATQ_GFS50_table_tb1_11: "绝缘等级",
    hardware_ATQ_GFS50_table_tb2_11: "H",

    // --- ATQ-NFC ---
    hardware_ATQ_NFC_title: "读卡器 ATQ-NFC",
    hardware_ATQ_NFC_title_zh: "读卡器",
    hardware_ATQ_NFC_content1_1: "奥太ATQ-NFC读卡器主要应用于对焊工IC卡的识别。通过对IC卡ID的校验，可进行焊工的信息识别、认证、考勤管理。通过奥太4G/WIFI通信控制器可将人员信息上传到奥太智能焊接云系统。",
    hardware_ATQ_NFC_content1_3: "■ 基于射频识别技术开发的ATQ-NFC读卡器，可用于识别IC卡的ID，读写IC卡的存储区。",
    hardware_ATQ_NFC_content1_4: "■ 通过对IC卡ID的校验，可进行焊工的信息识别、认证、考勤管理。",
    hardware_ATQ_NFC_content1_5: "■ 群控焊机可支持刷卡开机与关机功能。",
    hardware_ATQ_NFC_content_1: "奥太ATQ-NFC读卡器主要应用于对焊工卡的识别。",
    hardware_ATQ_NFC_tableTitle: "技术参数",
    hardware_ATQ_NFC_table_tb1_1: "型号",
    hardware_ATQ_NFC_table_tb2_1: "ATQ-NFC",
    hardware_ATQ_NFC_table_tb1_2: "额定输入电压",
    hardware_ATQ_NFC_table_tb2_2: "DC5V",
    hardware_ATQ_NFC_table_tb1_3: "通信方式",
    hardware_ATQ_NFC_table_tb2_3: "RS422",
    hardware_ATQ_NFC_table_tb1_4: "刷卡距离",
    hardware_ATQ_NFC_table_tb2_4: "8CM",
    hardware_ATQ_NFC_table_tb1_5: "卡类型",
    hardware_ATQ_NFC_table_tb2_5: "M1卡",
    hardware_ATQ_NFC_table_tb3_5: "出厂自带",
    hardware_ATQ_NFC_table_tb1_6: "安装方式",
    hardware_ATQ_NFC_table_tb2_6: "焊机外挂",
    hardware_ATQ_NFC_table_tb1_7: "安装方式",
    hardware_ATQ_NFC_table_tb2_7: "焊机外挂",
    hardware_ATQ_NFC_table_tb1_8: "外壳防护等级",
    hardware_ATQ_NFC_table_tb2_8: "IP21S",
    hardware_ATQ_NFC_table_tb1_9: "绝缘等级",
    hardware_ATQ_NFC_table_tb2_9: "H",

    // --- AD-1900 ---
    hardware_AD_1900_title: "焊接云前置终端 AD-1900",
    hardware_AD_1900_title_zh: "焊接云前置终端",
    hardware_AD_1900_content1_1: "前置终端是部署在企业现场的操作终端，辅助生产员工进行信息输入、数据监控、图纸工艺查看、任务流程控制等工作，提高员工工作效率。",
    hardware_AD_1900_content1_3: "■ 焊前信息录入",
    hardware_AD_1900_content1_4: "■ 焊接任务、流程控制",
    hardware_AD_1900_content1_5: "■ 焊接过程中产品信息、参数实时监控",
    hardware_AD_1900_content1_6: "■ 方便现场人员查看产品结构图纸、焊接工艺规程等信息",
    hardware_AD_1900_content1_7: "■ 稳定可靠、坚固耐用、安装简单、接口丰富、兼容性好，在粉尘、烟雾、高/低温环境下，均可正常工作，具备良好的环境适应能力",
    hardware_AD_1900_content1_8: "■ 具有强大的数据处理、数据传输、转换、分析能力，与奥太智能焊接云系统无缝结合，对焊接生产过程实时监控，根据不同工况变化给予快速响应",
    hardware_AD_1900_content1_9: "■ 提供比普通PC更加安全可靠的使用环境，以及更低的功耗，更高的安全性",
    hardware_AD_1900_content1_10: "■ 相比传统终端更多是数据采集和传输，对于特征数据的抓取和数据预处理能力大大提高。随着智能芯片和算法的升级，其自身具备更多提取特征值和压缩的功能，为数据查找和传输降低门槛",
    hardware_AD_1900_content_1: "前置终端是部署在企业现场的操作终端，辅助生产员工进行信息输入、数据监控、图纸工艺查看、任务流程控制等工作，提高员工工作效率。",
    hardware_AD_1900_tableTitle: "技术参数",
    hardware_AD_1900_table_tb1_1: "型号",
    hardware_AD_1900_table_tb2_1: "AD-1900",
    hardware_AD_1900_table_tb1_2: "产品类型",
    hardware_AD_1900_table_tb2_2: "终端机",
    hardware_AD_1900_table_tb1_3: "显示屏",
    hardware_AD_1900_table_tb2_3: "19寸触摸屏",
    hardware_AD_1900_table_tb1_4: "CPU",
    hardware_AD_1900_table_tb2_4: "J1900",
    hardware_AD_1900_table_tb1_5: "内存",
    hardware_AD_1900_table_tb2_5: "4GB内存",
    hardware_AD_1900_table_tb1_6: "显示",
    hardware_AD_1900_table_tb2_6: "1XVGA,1XDVI,1XHDMI",
    hardware_AD_1900_table_tb1_7: "硬盘",
    hardware_AD_1900_table_tb2_7: "128G固态硬盘",
    hardware_AD_1900_table_tb1_8: "网络",
    hardware_AD_1900_table_tb2_8: "INTEL RTL8111E/F， 10/100/1000Mbps, 2×LAN",
    hardware_AD_1900_table_tb1_9: "无线",
    hardware_AD_1900_table_tb2_9: "1x3G/WiFi SMA天线（可选）",
    hardware_AD_1900_table_tb1_10: "串口",
    hardware_AD_1900_table_tb2_10: "5x COM",
    hardware_AD_1900_table_tb1_11: "USB",
    hardware_AD_1900_table_tb2_11: "4XUSB2.0，2XUSB3.0",
    hardware_AD_1900_table_tb1_12: "音频",
    hardware_AD_1900_table_tb2_12: "1XMic-in, 1XLine-out",
    hardware_AD_1900_table_tb1_13: "扩展接口",
    hardware_AD_1900_table_tb2_13: "2XMini Pcle",
    hardware_AD_1900_table_tb1_14: "电源",
    hardware_AD_1900_table_tb2_14: "交流220V",
    hardware_AD_1900_table_tb1_15: "外型尺寸LxWxH(mm)",
    hardware_AD_1900_table_tb2_15: "520×400×1650",
    hardware_AD_1900_table_tb1_16: "屏幕分辨率",
    hardware_AD_1900_table_tb2_16: "1280x1024",
    hardware_AD_1900_table_tb1_17: "工作温度",
    hardware_AD_1900_table_tb2_17: "-20℃～70℃",

    // --- RWSC ---
    hardware_RWSC_title: "机器人焊接系统控制终端 RWSC",
    hardware_RWSC_title_zh: "机器人焊接系统控制终端",
    hardware_RWSC_content1_1: "机器人焊接系统控制面板配套机器人焊机可完成机器人焊接工艺的复杂操作，实现对焊缝类型、焊缝代号、当前焊缝的选择，辅助焊工完成焊接参数的修改，以及焊缝预选、焊接参数微调、焊接工艺复制、多台焊接设备之间焊接工艺共享、用户登录等的功能。",
    hardware_RWSC_content1_3: "■ 实现焊缝类型、焊缝代号的选择",
    hardware_RWSC_content1_4: "■ 辅助焊工对焊接参数、手弧参数、摆动参数、偏移量等参数进行修改",
    hardware_RWSC_content1_5: "■ 焊缝预选",
    hardware_RWSC_content1_6: "■ 焊接参数微调",
    hardware_RWSC_content1_7: "■ 焊接工艺的复制、共享功能",
    hardware_RWSC_content1_8: "■ 用户登录实现用户对各自工艺的管理",
    hardware_RWSC_content_1: "机器人焊接系统控制面板配套机器人焊机可完成机器人焊接工艺的复杂操作，实现对焊缝类型、焊缝代号、当前焊缝的选择，辅助焊工完成焊接参数的修改，以及焊缝预选、焊接参数微调、焊接工艺复制、多台焊接设备之间焊接工艺共享、用户登录等的功能。",
    hardware_RWSC_tableTitle: "技术参数",
    hardware_RWSC_table_tb1_1: "型号",
    hardware_RWSC_table_tb2_1: "RWSC",
    hardware_RWSC_table_tb1_2: "额定输入电压",
    hardware_RWSC_table_tb2_2: "AC38V-42V",
    hardware_RWSC_table_tb1_3: "通信接口",
    hardware_RWSC_table_tb2_3: "RS422、RS485、CAN、以太网、WIFI/4G、USB",
    hardware_RWSC_table_tb1_4: "工作温度",
    hardware_RWSC_table_tb2_4: "-30℃~70℃",
    hardware_RWSC_table_tb1_5: "存储温度",
    hardware_RWSC_table_tb2_5: "-30℃~80℃",
    hardware_RWSC_table_tb1_6: "外壳防护等级",
    hardware_RWSC_table_tb2_6: "IP21S",

    // --- ATQ-SR ---
    hardware_ATQ_SR_title: "焊接工艺手持终端 ATQ-SR",
    hardware_ATQ_SR_title_zh: "焊接工艺手持终端",
    hardware_ATQ_SR_content_1: "ATQ系列手持终端适用于奥太数字焊机，实现焊机工艺切换功能。",
    hardware_ATQ_SR_tableTitle: "技术参数",

    // --- ATQ-GW-DWL ---
    hardware_ATQ_GW_DWL_title: "通信控制器4G内置 ATQ-GW-DWL",
    hardware_ATQ_GW_DWL_title_zh: "通信控制器4G内置",
    hardware_ATQ_GW_DWL_content1_1: "ATQ-GW-DWL通信控制器，可应用于奥太数字化焊机，该产品应用在上位机系统与焊机之间，通过4G实现焊机与上位机系统通信数据的上下行。并且可按照客户应用需求，选配误差在2.5M内的GPS定位。可以及时发现客户焊机故障，并提供及时、精准的售后服务。",
    hardware_ATQ_GW_DWL_content1_3: "■ 适配奥太数字化群控焊机专用接口，实施使用便捷",
    hardware_ATQ_GW_DWL_content1_4: "①内置焊机内部，一体化设计",
    hardware_ATQ_GW_DWL_content1_5: "②无需繁琐的现场组网施工，降低实施费用",
    hardware_ATQ_GW_DWL_content1_6: "③无需准备和维护服务器，可随时随地登录查看",
    hardware_ATQ_GW_DWL_content1_7: "④可从容应对复杂的现场条件",
    hardware_ATQ_GW_DWL_content1_8: "■ 与焊机主板直接通信，获取实时焊接电流、焊接电压、送丝速度，无需外加其他传感器，完成实时数据的监控以及统计，包括给定电流、给定电压、焊接电流、焊接电压、送丝速度、焊接时间等",
    hardware_ATQ_GW_DWL_content1_9: "■ 采样频率: 标准为1HZ，可根据用户实际情况进行定制",
    hardware_ATQ_GW_DWL_content1_10: "■ 数据传输稳定性: 整个焊接设备通过4G传输到焊接云服务器，稳定的三大运营商4G网络以及设备的缓存功能保证了数据实时性以及完整性",
    hardware_ATQ_GW_DWL_content_1: "ATQ-GW-DWL通信控制器，可应用于奥太数字化焊机，实现焊机信息化管理。",
    hardware_ATQ_GW_DWL_tableTitle: "技术参数",
    hardware_ATQ_GW_DWL_table_tb1_1: "型号",
    hardware_ATQ_GW_DWL_table_tb2_1: "ATQ-GW-DWL",
    hardware_ATQ_GW_DWL_table_tb1_2: "额定输入电压",
    hardware_ATQ_GW_DWL_table_tb2_2: "AC19V",
    hardware_ATQ_GW_DWL_table_tb3_2: "焊机内部供电",
    hardware_ATQ_GW_DWL_table_tb1_3: "联网通讯方式",
    hardware_ATQ_GW_DWL_table_tb2_3: "4G",
    hardware_ATQ_GW_DWL_table_tb1_4: "4G",
    hardware_ATQ_GW_DWL_table_tb2_4: "移动、联通、电信",
    hardware_ATQ_GW_DWL_table_tb3_4: "SIM卡出厂自带",
    hardware_ATQ_GW_DWL_table_tb1_5: "气体流量检测",
    hardware_ATQ_GW_DWL_table_tb2_5: "支持气体流量检测",
    hardware_ATQ_GW_DWL_table_tb3_5: "需另外采购气体流量检测设备",
    hardware_ATQ_GW_DWL_table_tb1_6: "LBS(基于位置服务)",
    hardware_ATQ_GW_DWL_table_tb2_6: "基站定位",
    hardware_ATQ_GW_DWL_table_tb3_6: "附近有基站信号，并配有SIM卡",
    hardware_ATQ_GW_DWL_table_tb1_7: "IC卡刷卡功能",
    hardware_ATQ_GW_DWL_table_tb2_7: "支持",
    hardware_ATQ_GW_DWL_table_tb3_7: "焊机时需配套刷卡模块",
    hardware_ATQ_GW_DWL_table_tb1_8: "安装方式",
    hardware_ATQ_GW_DWL_table_tb2_8: "焊机内置",
    hardware_ATQ_GW_DWL_table_tb1_9: "外壳防护等级",
    hardware_ATQ_GW_DWL_table_tb2_9: "IP21S",
    hardware_ATQ_GW_DWL_table_tb1_10: "绝缘等级",
    hardware_ATQ_GW_DWL_table_tb2_10: "H",

    // --- ATQ-GW-WF801 ---
    hardware_ATQ_GW_WF801_title: "通信控制器WIFI内置 ATQ-GW-WF801",
    hardware_ATQ_GW_WF801_title_zh: "通信控制器WIFI内置",
    hardware_ATQ_GW_WF801_content1_1: "ATQ系列通信控制器，通信控制器无线通信方式，可应用于奥太数字化焊机，完成焊机与服务器之间的通信，实现焊机所有参数的采集、控制。",
    hardware_ATQ_GW_WF801_content1_3: "■ 奥太数字化群控焊机一体化设计，出厂前整机调试完毕，无需客户现场改造",
    hardware_ATQ_GW_WF801_content1_4: "■ 与焊机主板直接通信，获取实时焊接电流、焊接电压、送丝速度，无需外加其他传感器，完成实时数据的监控以及统计，包括给定电流、给定电压、焊接电流、焊接电压、送丝速度、焊接时间等",
    hardware_ATQ_GW_WF801_content1_5: "■ 采样频率：标准为1HZ，可根据用户实际情况进行定制",
    hardware_ATQ_GW_WF801_content1_6: "■ 数据安全保密性：焊接数据所存放的焊接云服务器放置在用户机房，保证保密性数据的安全",
    hardware_ATQ_GW_WF801_content1_7: "■ 数据传输稳定性：整个焊接设备通过WiFi传输到车间无线网络，途径企业网络，最后到达焊接云服务器，成熟的网络部署保证了数据实时性以及完整性",
    hardware_ATQ_GW_WF801_content1_8: "■ 网络部署后无需顾虑流量费：所有设备都是采用工业WiFi数据传输，一次性部署网络后，所有的无线设备都可以使用，不会涉及流量套餐费用",
    hardware_ATQ_GW_WF801_content_1: "ATQ-GW-WF801通信控制器，通信控制器无线通信方式，可应用于奥太数字化焊机，完成焊机与服务器之间的通信，实现焊机所有参数的采集、控制。",
    hardware_ATQ_GW_WF801_tableTitle: "技术参数",
    hardware_ATQ_GW_WF801_table_tb1_1: "型号",
    hardware_ATQ_GW_WF801_table_tb2_1: "ATQ-GW-WF801",
    hardware_ATQ_GW_WF801_table_tb1_2: "额定输入电压",
    hardware_ATQ_GW_WF801_table_tb2_2: "AC19V",
    hardware_ATQ_GW_WF801_table_tb3_2: "焊机内部供电",
    hardware_ATQ_GW_WF801_table_tb1_3: "联网通讯方式",
    hardware_ATQ_GW_WF801_table_tb2_3: "WIFI",
    hardware_ATQ_GW_WF801_table_tb1_4: "WIFI",
    hardware_ATQ_GW_WF801_table_tb2_4: "2.4G（IEEE802.11b/g/n)",
    hardware_ATQ_GW_WF801_table_tb1_5: "刷卡功能",
    hardware_ATQ_GW_WF801_table_tb2_5: "支持",
    hardware_ATQ_GW_WF801_table_tb3_5: "需采购刷卡设备",
    hardware_ATQ_GW_WF801_table_tb1_6: "气体流量检测",
    hardware_ATQ_GW_WF801_table_tb2_6: "支持",
    hardware_ATQ_GW_WF801_table_tb3_6: "需采购气体流量设备",
    hardware_ATQ_GW_WF801_table_tb1_7: "安装方式",
    hardware_ATQ_GW_WF801_table_tb2_7: "焊机内置",
    hardware_ATQ_GW_WF801_table_tb1_8: "外壳防护等级",
    hardware_ATQ_GW_WF801_table_tb2_8: "IP21S",
    hardware_ATQ_GW_WF801_table_tb1_9: "绝缘等级",
    hardware_ATQ_GW_WF801_table_tb2_9: "H",

    // --- ATQ-RS422-5G ---
    hardware_ATQ_RS422_5G_title: "通信控制器5G内置 ATQ-RS422-5G",
    hardware_ATQ_RS422_5G_title_zh: "通信控制器5G内置",
    hardware_ATQ_RS422_5G_content1_1: "ATQ-RS422-5G通信控制器可应用于奥太数字化焊机，该产品应用于上位机系统与焊机中间，通过5G网络通信方式实现焊机联网，实现焊机与上位机系统通信数据的上下行。",
    hardware_ATQ_RS422_5G_content1_3: "■ 适配奥太数字化群控焊机专用接口，安装便捷、使用简单方便",
    hardware_ATQ_RS422_5G_content1_4: "①.操作和接入方式简单，无需进行网络配置",
    hardware_ATQ_RS422_5G_content1_5: "②.无需繁琐的现场组网施工，降低实施费用",
    hardware_ATQ_RS422_5G_content1_6: "③.采用 3GPP Release 15 技术，同时支持 5G NSA 和 SA 模式。 支持 TDD 和 FDD 两种模式，向下兼容 4G/3G",
    hardware_ATQ_RS422_5G_content1_7: "④.工业级设计与高强防护，可从容应对复杂的工业现场条件",
    hardware_ATQ_RS422_5G_content1_8: "⑤.数据传输速率快，5G SA Sub-6模式下：下行2 Gbps；上行 1 Gbps",
    hardware_ATQ_RS422_5G_content1_9: "■ 与焊机主板直接通信，获取实时焊接电流、焊接电压、送丝速度等参数，无需外加其他传感器，完成实时数据的监控以及统计，包括给定电流、给定电压、焊接电流、焊接电压、送丝速度、焊接时间等",
    hardware_ATQ_RS422_5G_content1_10: "■ 采样频率: 标准为1H采样，可根据用户实际情况进行定制",
    hardware_ATQ_RS422_5G_content1_11: "■ 数据传输稳定性：整个焊接设备信息通过5G网络传输到焊接云服务器，5G网络支持国内四大运营商，以及设备的缓存功能保证了数据实时性及完整性",
    hardware_ATQ_RS422_5G_content_1: "ATQ-RS422-5G通信控制器可应用于奥太数字化焊机，通过5G网络通信方式实现焊机联网，实现焊机信息化管理。",
    hardware_ATQ_RS422_5G_tableTitle: "技术参数",
    hardware_ATQ_RS422_5G_table_tb1_1: "型号",
    hardware_ATQ_RS422_5G_table_tb2_1: "ATQ-RS422/5G",
    hardware_ATQ_RS422_5G_table_tb1_2: "额定输入电压",
    hardware_ATQ_RS422_5G_table_tb2_2: "AC19V",
    hardware_ATQ_RS422_5G_table_tb3_2: "焊机内部供电",
    hardware_ATQ_RS422_5G_table_tb1_3: "联网通讯方式",
    hardware_ATQ_RS422_5G_table_tb2_3: "5G",
    hardware_ATQ_RS422_5G_table_tb1_4: "5G (运营商)",
    hardware_ATQ_RS422_5G_table_tb2_4: "移动、联通、电信",
    hardware_ATQ_RS422_5G_table_tb3_4: "5G SIM流量卡需另采购",
    hardware_ATQ_RS422_5G_table_tb1_5: "5G（模式）",
    hardware_ATQ_RS422_5G_table_tb2_5: "支持 NSA 和 SA 模式",
    hardware_ATQ_RS422_5G_table_tb1_6: "5G（网络）",
    hardware_ATQ_RS422_5G_table_tb2_6: "向下兼容 4G/3G",
    hardware_ATQ_RS422_5G_table_tb1_7: "气体流量检测",
    hardware_ATQ_RS422_5G_table_tb2_7: "支持气体流量检测",
    hardware_ATQ_RS422_5G_table_tb3_7: "需另外采购气体流量检测设备",
    hardware_ATQ_RS422_5G_table_tb1_8: "离线存储功能",
    hardware_ATQ_RS422_5G_table_tb2_8: "12个月循环存储",
    hardware_ATQ_RS422_5G_table_tb3_8: "需另外采购Micro SD卡",
    hardware_ATQ_RS422_5G_table_tb1_9: "刷卡功能",
    hardware_ATQ_RS422_5G_table_tb2_9: "支持",
    hardware_ATQ_RS422_5G_table_tb3_9: "采购焊机时需配套刷卡模块",
    hardware_ATQ_RS422_5G_table_tb1_10: "安装方式",
    hardware_ATQ_RS422_5G_table_tb2_10: "焊机内置",
    hardware_ATQ_RS422_5G_table_tb1_11: "外壳防护等级",
    hardware_ATQ_RS422_5G_table_tb2_11: "IP21S",
    hardware_ATQ_RS422_5G_table_tb1_12: "绝缘等级",
    hardware_ATQ_RS422_5G_table_tb2_12: "H",

    // --- ATQ-RS422-4G-IV ---
    hardware_ATQ_RS422_4G_IV_title: "通讯控制器多功能网关内置 ATQ-RS422-4G-IV",
    hardware_ATQ_RS422_4G_IV_title_zh: "通讯控制器多功能网关内置",
    hardware_ATQ_RS422_4G_IV_content1_1: "ATQ-RS422-4G-IV通信控制器可应用于奥太数字化焊机，该产品应用于上位机系统与焊机中间，通过4G、以太网以及WIFI通信等联网方式实现焊机联网，实现焊机与上位机系统通信数据的上下行。",
    hardware_ATQ_RS422_4G_IV_content1_3: "■ 适配奥太数字化群控焊机专用接口，安装便捷、使用简单方便",
    hardware_ATQ_RS422_4G_IV_content1_4: "①.操作和接入方式简单，使用APP进行网络切换及相关参数配置，方便客户后期使用",
    hardware_ATQ_RS422_4G_IV_content1_5: "②.可以根据现场网络情况，选择合适的网络通信方式，无需繁琐的现场组网施工，降低使用费用",
    hardware_ATQ_RS422_4G_IV_content1_6: "③.支持数据离线存储(一个月)，可应用于无网络信号下作业",
    hardware_ATQ_RS422_4G_IV_content1_7: "④.支持GPS定位(室外)，支持基站定位",
    hardware_ATQ_RS422_4G_IV_content1_8: "⑤.工业级设计与高强防护，可从容应对复杂的工业现场条件",
    hardware_ATQ_RS422_4G_IV_content1_9: "■ 与焊机主板直接通信，获取实时焊接电流、焊接电压、送丝速度等参数，无需外加其他传感器，完成实时数据的监控以及统计，包括给定电流、给定电压、焊接电流、焊接电压、送丝速度、焊接时间等",
    hardware_ATQ_RS422_4G_IV_content1_10: "■ 采样频率: 标准为1H采样，可根据用户实际情况进行定制",
    hardware_ATQ_RS422_4G_IV_content1_11: "■ 数据传输稳定性：整个焊接设备信息通过4G、WiFi、以太网传输到焊接云服务器，4G网络支持国内三大运营商，多种网络通讯方式以及设备的缓存功能保证了数据实时性及完整性",
    hardware_ATQ_RS422_4G_IV_content_1: "ATQ-RS422-4G-IV通信控制器可应用于奥太数字化焊机，通过4G、以太网以及WIFI等联网方式实现焊机联网，实现焊机信息化管理。",
    hardware_ATQ_RS422_4G_IV_tableTitle: "技术参数",
    hardware_ATQ_RS422_4G_IV_table_tb1_1: "型号",
    hardware_ATQ_RS422_4G_IV_table_tb2_1: "ATQ-RS422/4G-IV",
    hardware_ATQ_RS422_4G_IV_table_tb1_2: "额定输入电压",
    hardware_ATQ_RS422_4G_IV_table_tb2_2: "AC19V",
    hardware_ATQ_RS422_4G_IV_table_tb3_2: "焊机内部供电",
    hardware_ATQ_RS422_4G_IV_table_tb1_3: "联网通讯方式",
    hardware_ATQ_RS422_4G_IV_table_tb2_3: "4G/ WIFI /以太网",
    hardware_ATQ_RS422_4G_IV_table_tb1_4: "4G",
    hardware_ATQ_RS422_4G_IV_table_tb2_4: "移动、联通、电信",
    hardware_ATQ_RS422_4G_IV_table_tb3_4: "SIM卡出厂自带",
    hardware_ATQ_RS422_4G_IV_table_tb1_5: "WIFI",
    hardware_ATQ_RS422_4G_IV_table_tb2_5: "2.4G（符合IEEE 802.11b/g/n/a/ac 标准）",
    hardware_ATQ_RS422_4G_IV_table_tb1_6: "以太网",
    hardware_ATQ_RS422_4G_IV_table_tb2_6: "100M",
    hardware_ATQ_RS422_4G_IV_table_tb1_7: "气体流量检测",
    hardware_ATQ_RS422_4G_IV_table_tb2_7: "支持气体流量检测",
    hardware_ATQ_RS422_4G_IV_table_tb3_7: "需另外采购气体流量检测设备",
    hardware_ATQ_RS422_4G_IV_table_tb1_8: "GNSS(全球卫星导航系统)",
    hardware_ATQ_RS422_4G_IV_table_tb2_8: "GPS/GLONASS/BD",
    hardware_ATQ_RS422_4G_IV_table_tb3_8: "室外无遮挡环境",
    hardware_ATQ_RS422_4G_IV_table_tb1_9: "LBS(基于位置服务)",
    hardware_ATQ_RS422_4G_IV_table_tb2_9: "基站定位",
    hardware_ATQ_RS422_4G_IV_table_tb3_9: "附近有基站信号，并配有SIM卡",
    hardware_ATQ_RS422_4G_IV_table_tb1_10: "离线存储功能",
    hardware_ATQ_RS422_4G_IV_table_tb2_10: "1个月循环存储",
    hardware_ATQ_RS422_4G_IV_table_tb3_10: "需另外采购Micro SD卡",
    hardware_ATQ_RS422_4G_IV_table_tb1_11: "刷卡功能",
    hardware_ATQ_RS422_4G_IV_table_tb2_11: "支持",
    hardware_ATQ_RS422_4G_IV_table_tb3_11: "采购焊机时需配套刷卡模块",
    hardware_ATQ_RS422_4G_IV_table_tb1_12: "安装方式",
    hardware_ATQ_RS422_4G_IV_table_tb2_12: "焊机内置",
    hardware_ATQ_RS422_4G_IV_table_tb1_13: "外壳防护等级",
    hardware_ATQ_RS422_4G_IV_table_tb2_13: "IP21S",
    hardware_ATQ_RS422_4G_IV_table_tb1_14: "绝缘等级",
    hardware_ATQ_RS422_4G_IV_table_tb2_14: "H",

    // --- weldCloud-phone ---
    hardware_weldCloud_phone_title: "焊接云手持终端 AD-70",
    hardware_weldCloud_phone_title_zh: "焊接云手持终端",
    hardware_weldCloud_phone_content1_1: "焊接云手持终端AD-70是一款轻便、高性能工业级智能手持终端。可在高温焊接环境下正常工作，防护等级为IP65/IP67，保密性高，适用于车间内禁止携带个人手机等电子产品的用户，可协助用户快速实现焊接信息化管理，提高工作效率。",
    hardware_weldCloud_phone_content1_3: "■ 安卓操作系统: 系统操作简单，交互界面友好，安全性高，兼容性好",
    hardware_weldCloud_phone_content1_4: "■ 屏幕耐损伤: 屏幕具有卓越的抗损伤性能，防刮耐磨，坚韧可靠，同时支持手套或湿手操作",
    hardware_weldCloud_phone_content1_5: "■ 5.5寸IPS高清大屏: 配备1080P全高清显示屏，采用时下最先进的IPS显示技术，可视角度大，色彩还原能力强",
    hardware_weldCloud_phone_content1_6: "■ IP65/IP67高防护等级： C70达到IEC密封规格，能够在风尘水浸环境中正常作业，即便在1米深的水中，浸泡长达30分钟，仍可正常运行，能够满足各种苛刻环境条件下的使用",
    hardware_weldCloud_phone_content1_7: "■ 1.8m抗跌落：在操作温度范围内，6面均能承受多次从1.8米高处跌落至混凝土地面的冲击",
    hardware_weldCloud_phone_content1_8: "■ 持久续航：标配4000mAh高密度可充电锂聚合物电池，并支持强悍的闪充技术，全天候高轻度持续工作使用无忧",
    hardware_weldCloud_phone_content_1: "焊接云手持终端AD-70是一款轻便、高性能工业级智能手持终端。可在高温焊接环境下正常工作，防护等级为IP65/IP67，保密性高，适用于车间内禁止携带个人手机等电子产品的用户，可协助用户快速实现焊接信息化管理，提高工作效率。",
    hardware_weldCloud_phone_tableTitle: "产品参数",
    hardware_weldCloud_phone_table_tb1_1: "型号",
    hardware_weldCloud_phone_table_tb2_1: "AD-70",
    hardware_weldCloud_phone_table_tb1_2: "显示屏",
    hardware_weldCloud_phone_table_tb2_2: "5.5英寸，IPS IGZO 1440x720分辨率",
    hardware_weldCloud_phone_table_tb1_3: "触摸屏",
    hardware_weldCloud_phone_table_tb2_3: "支持多点触控，支持手套或湿手操作",
    hardware_weldCloud_phone_table_tb1_4: "CPU",
    hardware_weldCloud_phone_table_tb2_4: "高通骁龙TM 662八核, 2.0 GHz",
    hardware_weldCloud_phone_table_tb1_5: "RAM+ROM",
    hardware_weldCloud_phone_table_tb2_5: "3GB+32GB",
    hardware_weldCloud_phone_table_tb1_6: "拓展内存",
    hardware_weldCloud_phone_table_tb2_6: "MicroSD (TF)卡可扩展至128GB",
    hardware_weldCloud_phone_table_tb1_7: "操作系统",
    hardware_weldCloud_phone_table_tb2_7: "Android 11",
    hardware_weldCloud_phone_table_tb1_8: "工作环境",
    hardware_weldCloud_phone_table_tb2_8: "-20 ℃~+50 ℃",
    hardware_weldCloud_phone_table_tb1_9: "外形尺寸L xW xH(mm)",
    hardware_weldCloud_phone_table_tb2_9: "160.0 x 76.0 x 17.0",
    hardware_weldCloud_phone_table_tb1_10: "电池",
    hardware_weldCloud_phone_table_tb2_10: "4420 mAh",

    // --- weldCloud-flat ---
    hardware_weldCloud_flat_title: "焊接云手持平板 PAD-80",
    hardware_weldCloud_flat_title_zh: "焊接云手持平板",
    hardware_weldCloud_flat_content1_1: "焊接云手持平板PAD-80是一款轻便、高性能工业级智能手持平板，可在高温焊接环境下正常工作，防护等级为IP65，保密性高，适用于车间内禁止携带个人手机等电子产品的用户，可协助用户快速实现焊接信息化管理，提高工作效率。",
    hardware_weldCloud_flat_content1_3: "■ 安卓操作系统: 系统操作简单，交互界面友好，安全性高，兼容性好",
    hardware_weldCloud_flat_content1_4: "■ 屏幕耐损伤: 屏幕具有卓越的抗损伤性能，防刮耐磨，坚韧可靠，同时支持手套或湿手操作",
    hardware_weldCloud_flat_content1_5: "■ 8寸IPS高清大屏: 配备1080P全高清显示屏，采用时下最先进的IPS显示技术，可视角度大，色彩还原能力强",
    hardware_weldCloud_flat_content1_6: "■ IP65高防护等级：达到IEC密封规格，能够在风尘水浸环境中正常作业，即便在1米深的水中，浸泡长达30分钟，仍可正常运行，能够满足各种苛刻环境条件下的使用",
    hardware_weldCloud_flat_content1_7: "■ 1.5m抗跌落：在操作温度范围内，6面均能承受多次从1.5米高处跌落至混凝土地面的冲击",
    hardware_weldCloud_flat_content1_8: "■ 持久续航：标配8000mAh高密度可充电锂聚合物电池，并支持强悍的闪充技术，全天候高轻度持续工作使用无忧",
    hardware_weldCloud_flat_content1_9: "■ 支持NFC功能: 可在指定软件支持下，实现焊工刷卡焊接、焊工信息认证、焊接资质认证等功能",
    hardware_weldCloud_flat_content_1: "焊接云手持平板PAD-80是一款轻便、高性能工业级智能手持平板，可在高温焊接环境下正常工作，防护等级为IP65，保密性高，适用于车间内禁止携带个人手机等电子产品的用户，可协助用户快速实现焊接信息化管理，提高工作效率。",
    hardware_weldCloud_flat_tableTitle: "产品参数",
    hardware_weldCloud_flat_table_tb1_1: "型号",
    hardware_weldCloud_flat_table_tb2_1: "PAD-80",
    hardware_weldCloud_flat_table_tb1_2: "显示屏",
    hardware_weldCloud_flat_table_tb2_2: "8英寸， IPS LTPS 1280 x 800分辨率",
    hardware_weldCloud_flat_table_tb1_3: "触摸屏",
    hardware_weldCloud_flat_table_tb2_3: "支持多点触控，支持手套或湿手操作",
    hardware_weldCloud_flat_table_tb1_4: "CPU",
    hardware_weldCloud_flat_table_tb2_4: "Qualcomm 1.8GHz 八核",
    hardware_weldCloud_flat_table_tb1_5: "RAM+ROM",
    hardware_weldCloud_flat_table_tb2_5: "3GB+32GB  / 4GB+64GB",
    hardware_weldCloud_flat_table_tb1_6: "拓展内存",
    hardware_weldCloud_flat_table_tb2_6: "MicroSD (TF)卡可扩展至128GB",
    hardware_weldCloud_flat_table_tb1_7: "操作系统",
    hardware_weldCloud_flat_table_tb2_7: "Android 9",
    hardware_weldCloud_flat_table_tb1_8: "工作环境",
    hardware_weldCloud_flat_table_tb2_8: "-20 ℃~+50 ℃",
    hardware_weldCloud_flat_table_tb1_9: "外形尺寸L xW xH(mm)",
    hardware_weldCloud_flat_table_tb2_9: "250.8 x 152.0 x 15.0",
    hardware_weldCloud_flat_table_tb1_10: "电池",
    hardware_weldCloud_flat_table_tb2_10: "8000 mAh",
  },

  solution: {
    // --- 之前提取的 ---
    solution_page_title: "解决方案",
    solution_page_subtitle: "聚焦工业互联网行业，为企业提供360°解决方案，助力企业数字化转型升级，赋能中国制造业创新发展",
    solution_breadcrumb_home: "首页",
    solution_breadcrumb_current: "解决方案",
    solution_industry_title: "行业解决方案",
    solution_unavailable_warning: "暂时无法查看！",
    solution_workshop_title: "车间信息化升级",
    solution_workshop_text_1: "现场焊机：将车间现有焊机通过设备改造，实现焊接数据采集，包括焊接电流、焊接电压、保护气体流量、送丝速度等数据的实时采集。",
    solution_workshop_text_2: "网络传输： 根据客户实际车间情况，企业可以选择焊机采用无线WiFi、4G、5G等方式。",
    solution_workshop_text_3: "系统应用：智能焊接生产管理系统为企业提供焊生产在线派工、焊接设备远程监控、焊工工时统计、接数据在线分析，焊接成本统计报表等功能。系统采用B/S(浏览器/服务器)或其他网络架构，可方便的通过企业网络实现数据远程访问、及可实现与企业信息系统对接实现数据共享。",

    // --- 新增：详情页 ---
    solution_detail_demo: "产品演示",
    solution_detail_contact: "联系我们",

    
    // --- 横向导航 ---
    solution_nav_overview: "方案概况",
    solution_nav_architecture: "方案架构",
    solution_nav_scene: "解决方案场景",
    solution_nav_custom: "客户案例",
    
    // --- 方案概况 ---
    solution_overview_title: "方案概况",
    
    // --- 方案架构 ---
    solution_architecture_title: "方案架构",
    
    // --- 解决方案场景 ---
    solution_scene_title: "解决方案场景",
    
    // --- 客户案例 ---
    solution_custom_title: "客户案例",


    // ==================== 通用 ====================
  solution_common_introduceTitle: "项目需求",
  solution_common_meritTitle: "解决方案",
  
  // ==================== 列表页 ====================
  solution_list_pressureVessel_title: "压力容器行业",
  solution_list_pressureVessel_text: "压力容器行业解决方案是在奥太智能焊接云系统的基础上进行行业方向特殊化的改进，由智能研发中心针对压力容器行业客户的焊接现场需求自主研发的信息化系统。从MES、ERP等第三方系统获取订单、生产计划、工艺信息；本系统主要进行生产流程、焊接流程、信息监控、数据分析，并将生产相关数据给到第三方系统，形成闭环。本系统实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。",
  
  solution_list_ship_title: "船舶行业",
  solution_list_ship_text: "船舶解决方案是随着物联网、云计算等技术的发展，积极开展船舶制造智能化研究及现场应用，是面对行业技术发展的必然选择，对于施工单位而言，不论业主方是否提出有关要求，具备焊接数据实时采集、存储、分析的能力，除了促进焊接技术水平的提升外，还能在市场竞争中形成专有技术优势，提高公司市场竞争力的有效手段。并根据客户的实际需求，为了满足企业不同的生产计划及流程，提供定制化解决方案。",
  
  solution_list_steelStructure_title: "钢结构行业",
  solution_list_steelStructure_text: "钢结构焊接智能制造解决方案集成了焊接设备，采集设备，钢结构焊接管理系统，对接MES、ERP等第三方系统，旨在提高钢结构焊接的质量、效率，以及提高设备的利用率。系统实时采集、监控、处理和分析焊接数据，提供焊接生产信息，为管理者进行决策提供数据支持。并根据客户的实际需求，为了满足企业不同的生产计划及流程，提供定制化解决方案。",
  
  solution_list_machinery_title: "工程机械行业",
  solution_list_machinery_text: "满足工程机械行业多种业务模式，从个性化的订单选配、多层级计划管理模式、复杂的物料齐套规划、频繁的设计变更管理、精细化制造执行和用料管控、精准的售后服务等行业特性，提供一站式整体解决方案。",
  
  solution_list_industry_title: "应用行业",
  solution_list_industry_text: "服务于压力容器、船舶、钢结构、工程机械、焊培、煤机、管道、化工等不同行业。",
  
  solution_list_weldTraining_title: "焊培行业",
  solution_list_weldTraining_text: "焊培领域智能制造解决方案由奥太智能研发中心打造，充分整合自主信息技术和数字化技术，与焊接行业的先进技术深度融合。以提升管理效率、优化业务流程、提高培训质量为目标，基于多年的焊培研发、数字化培训业务积累和技术研究，综合焊接行业的特点，建立适配焊培企业的智能培训技术平台，并提供智能培训全流程的系列解决方案，帮助企业打通各业务系统、设备间的数据壁垒，从传统培训向数字化培训、智能培训转型。",
  
  solution_list_coalMachine_title: "煤机行业",
  solution_list_coalMachine_text: "煤机领域智能制造解决方案由奥太智能研发中心打造，以资源高效利用、降本增效为目标，实现工厂人、机、料、法、环、测的规范化管理，建立完整的焊接质量数据追溯链，改良工厂目前管理、生产状况，建造工业物联网平台。",
  
  solution_list_piping_title: "管道行业",
  solution_list_piping_text: '管道焊接智能制造解决方案是以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台，结合客户现场焊接设备，辅助用户建立数字化焊接的一整套解决方案，对焊接现场的"人、机、料、法"进行全方位的智能化管理的信息化系统。',
  
  solution_list_chemicalIndustry_title: "化工行业",
  solution_list_chemicalIndustry_text: "化工焊接智能制造解决方案是真正将焊接、实际生产产品关联，实现产品质量追溯，形成完善产品档案，规范焊接现场参与的人、机、料、法、环等关键因素，满足国家、业主、自身对焊接质量的高规范要求，提供完整的焊接数据追溯链的信息化平台",
  
  solution_menu_weldCloud: "智能焊接云平台",

  // ==================== 详情 - 钢结构 ====================
  solution_detail_steelStructure_text: "钢结构焊接管理系统是一套综合性的管理系统，旨在提高钢结构焊接的效率和质量。该系统通过集成多种先进技术，如智能数据采集设备、物联网、大数据分析等，对钢结构焊接的全过程进行监控和管理。",
  solution_detail_steelStructure_title: "钢结构焊接智能制造解决方案",
  solution_detail_steelStructure_summarize: "钢结构焊接智能制造解决方案集成了焊接设备，采集设备，钢结构焊接管理系统，对接MES、ERP等第三方系统，旨在提高钢结构焊接的质量、效率，以及提高设备的利用率。系统实时采集、监控、处理和分析焊接数据，提供焊接生产信息，为管理者进行决策提供数据支持。并根据客户的实际需求，为了满足企业不同的生产计划及流程，提供定制化解决方案。",

  // 场景1 - 江苏某客户
  solution_detail_steelStructure_scene1_title: "江苏某客户",
  solution_detail_steelStructure_scene1_introduce1: "● 焊缝地图管理：统筹管理项目产品焊缝信息，实现焊缝扫码管理。通过现场扫码或者管理者远程查询，获取焊缝的实时信息数据、有效焊接时长以及施焊人员信息。",
  solution_detail_steelStructure_scene1_introduce2: "● 焊工管理及认证：与现有人员管理系统集成，实现焊工信息动态更新，焊工在开始焊接前，使用本人身份信息，扫描焊缝二维码，符合条件可开始焊接。",
  solution_detail_steelStructure_scene1_introduce3: "● 焊缝工艺严格执行：焊缝工艺远程下发，焊工严格按照要求的焊接参数进行施焊。",
  solution_detail_steelStructure_scene1_merit1: "硬件：对现场奥太NBC-500III以及其他品牌焊机采用奥太专用焊接联网设备进行改造，实现多品牌焊机入网。",
  solution_detail_steelStructure_scene1_merit2: "硬件：实现断网情况下的离线存储功能，达到断点续传功能，保证焊接数据的连续性。",
  solution_detail_steelStructure_scene1_merit3: "软件：建立产品数字化工艺库，实时监控焊接过程中各环节的工艺数据，屏蔽大电流焊接、无资质焊接。",
  solution_detail_steelStructure_scene1_merit4: "软件：系统内实现焊工任务的创建以及派发，可实现任务批量下发，节约管理人员的操作时间。",
  solution_detail_steelStructure_scene1_merit5: "软件：焊工通过手机APP登录，扫描现场焊缝信息二维码、焊机二维码，进行施焊，实现了人机焊缝的关联。",

  // 场景2 - 安徽某客户
  solution_detail_steelStructure_scene2_title: "安徽某客户",
  solution_detail_steelStructure_scene2_introduce1: "● 实现奥太数字化焊机MZ-1000IV和其它品牌埋弧焊直流电源的联网改造。",
  solution_detail_steelStructure_scene2_introduce2: "● 实时监控、追溯焊接数据。",
  solution_detail_steelStructure_scene2_introduce3: "● 焊件焊接之前进行人机绑定、计划制定，将人、机、焊件关联。",
  solution_detail_steelStructure_scene2_merit1: "硬件：奥太数字化焊机MZ-1000IV采用专用的群控通信控制器将焊机联网，从而实现群控系统各项功能。",
  solution_detail_steelStructure_scene2_merit2: "硬件：其他品牌焊机直流焊机采用外接焊接数据采集仪将焊机联网，从而实现群控系统各项功能。",
  solution_detail_steelStructure_scene2_merit3: "硬件：IC/ID读卡器：人机绑定设备，实时将焊工信息上传到群控系统服务器，资质认证通过才可以进行焊接，否则禁止焊接。可使用现场焊工的焊工卡（饭卡）或者采用奥太专用IC卡。",
  solution_detail_steelStructure_scene2_merit4: "硬件：掌上群控APP：焊接系统的手机APP，系统大部分功能手机APP也可实现，方便客户随时随地都可以对系统进行操作。",
  solution_detail_steelStructure_scene2_merit5: "软件：追溯和实时监控焊接数据。",
  solution_detail_steelStructure_scene2_merit6: "软件：制定生产计划流程，将人、机、焊件绑定。",

  // 场景3 - 邢台某客户
  solution_detail_steelStructure_scene3_title: "邢台某客户",
  solution_detail_steelStructure_scene3_introduce1: "● 客户实现奥太数字化焊机MZ-1000IV埋弧焊直流电源的联网改造；客户采购NBC-500III数字化焊机。",
  solution_detail_steelStructure_scene3_introduce2: "● 实时数据监控，收集焊接时长。",
  solution_detail_steelStructure_scene3_introduce3: "● 焊接数据允许客户信息部调用。",
  solution_detail_steelStructure_scene3_merit1: "硬件：奥太数字化焊机MZ-1000IV、NBC-500III采用专用的群控通信控制器将焊机联网，从而实现群控系统各项功能。",
  solution_detail_steelStructure_scene3_merit2: "软件：实时收集焊接数据，统计焊接工时，通过时长计算焊工工资。",
  solution_detail_steelStructure_scene3_merit3: "软件：客户数据同步：焊接实时数据、历史数据、汇总数据同步到客户数据库，供客户调用。",

  // ==================== 详情 - 压力容器 ====================
  solution_detail_pressureVessel_text: "压力容器行业解决方案是在奥太智能焊接云系统的基础上进行行业方向特殊化的改进，是由智能研发中心针对压力容器行业客户的焊接现场需求自主研发的信息化系统。它实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。",
  solution_detail_pressureVessel_title: "压力容器行业解决方案",
  solution_detail_pressureVessel_summarize: "压力容器行业解决方案是在奥太智能焊接云系统的基础上进行行业方向特殊化的改进，由智能研发中心针对压力容器行业客户的焊接现场需求自主研发的信息化系统。从MES、ERP等第三方系统获取订单、生产计划、工艺信息；本系统主要进行生产流程、焊接流程、信息监控、数据分析，并将生产相关数据给到第三方系统，形成闭环。本系统实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。",

  // 场景1 - 大连某客户
  solution_detail_pressureVessel_scene1_title: "大连某压力容器客户",
  solution_detail_pressureVessel_scene1_mbTitle: "大连某客户",
  solution_detail_pressureVessel_scene1_introduce1: "● 解决多品牌焊机入网问题。",
  solution_detail_pressureVessel_scene1_introduce2: "● 施焊记录单无纸化问题。",
  solution_detail_pressureVessel_scene1_introduce3: "● 生产流程进行信息化升级，实现数字化管理。",
  solution_detail_pressureVessel_scene1_merit1: "硬件：对现场采用奥太专用焊接联网设备进行改造，实现多品牌焊机入网，设备具有较强的抗干扰特性以及采集数据准确性特点。",
  solution_detail_pressureVessel_scene1_merit2: "硬件：采用车间手持终端，焊工人员登录用户名，实现焊机、焊缝、焊材的扫码，下发任务的接收以及任务提交等操作。",
  solution_detail_pressureVessel_scene1_merit3: "软件：实现车间生产计划管理与焊接生产流程的数字化改造，完成焊接过程中的焊工、焊机、焊材、工艺、质检一体化管理。",
  solution_detail_pressureVessel_scene1_merit4: "软件：系统内实现焊工任务的创建以及派发，可实现任务批量下发，节约管理人员的操作时间。",
  solution_detail_pressureVessel_scene1_merit5: "软件：完全与生产流程结合，直接导出焊接记录单，生成的记录数据更加真实可靠，节省焊工大量焊接时间。",

  // 场景2 - 青岛某客户
  solution_detail_pressureVessel_scene2_title: "青岛某压力容器客户",
  solution_detail_pressureVessel_scene2_mbTitle: "青岛某客户",
  solution_detail_pressureVessel_scene2_introduce1: "● 焊接记录单：根据不同客户产品，自动生成不同格式的焊接记录单，如神钢、EEP、光和、桑明等格式。",
  solution_detail_pressureVessel_scene2_introduce2: "● 规范控制：将用户的焊接工艺下传到焊机，焊机将严格按照此工艺进行焊接。",
  solution_detail_pressureVessel_scene2_introduce3: "● 焊材管理：记录焊材领出与归还。",
  solution_detail_pressureVessel_scene2_merit1: "硬件：每台焊机采用的IC读卡设备，使焊工刷卡后可以选择管理人员下发的焊接任务，再次刷卡后作为任务的完成。",
  solution_detail_pressureVessel_scene2_merit2: "软件：根据企业内部工作任务进行标准化、规范化，建立相应的电子流程方案。由原来班组长口头下达焊接任务方式，改为计划员打印纸质的派工后，由班组长直接分发给焊工。",
  solution_detail_pressureVessel_scene2_merit3: "软件：由原来焊工手动填写焊接记录单，改为系统直接打印输出，由焊工盖章确认。",
  solution_detail_pressureVessel_scene2_merit4: "软件：焊材票的创建、领取、回收均在系统上进行操作，最终将进行相关表单的审核以及电子存档。",

  // 场景3 - 临沂某客户
  solution_detail_pressureVessel_scene3_title: "临沂某压力容器客户",
  solution_detail_pressureVessel_scene3_mbTitle: "临沂某客户",
  solution_detail_pressureVessel_scene3_introduce1: "● 解决现有焊机的定制软件配套使用，并要考虑后续采购奥太焊机的系统兼容性。",
  solution_detail_pressureVessel_scene3_introduce2: "● 施焊记录单无纸化、无损检测单的系统流程、无纸化存档。",
  solution_detail_pressureVessel_scene3_introduce3: "● 该企业的焊接产品需相应的焊工资质，所以希望控制焊工大电流焊接、无资质焊接的情况，减少因不按照工艺焊接造成的质量问题。",
  solution_detail_pressureVessel_scene3_merit1: "硬件：对现场其他品牌焊机采用奥太专用焊接联网设备进行改造，实现多品牌焊机入网，设备具有较强的抗干扰特性以及采集数据准确性特点。",
  solution_detail_pressureVessel_scene3_merit2: "硬件：采用车间终端模式，班组长将任务派发到焊工，焊工刷卡领取任务同时将工艺信息下传到焊机中。",
  solution_detail_pressureVessel_scene3_merit3: "软件：建立产品数字化工艺库，实时监控焊接过程中各环节的工艺数据，屏蔽大电流焊接、无资质焊接。",
  solution_detail_pressureVessel_scene3_merit4: "软件：自动生成焊接记录单、焊工绩效、焊接成本、设备KPI等各类报表。",

  // ==================== 详情 - 焊培 ====================
  solution_detail_weldTraining_text: "建立一套全面数字化、智能化的焊工培训和考试管理系统，提高管理效能、优化业务流程，同时保障培训的实时监控和数据可视化。",
  solution_detail_weldTraining_title: "焊培行业解决方案",
  solution_detail_weldTraining_summarize: "焊培领域智能制造解决方案由奥太智能研发中心打造，充分整合自主信息技术和数字化技术，与焊接行业的先进技术深度融合。以提升管理效率、优化业务流程、提高培训质量为目标，基于多年的焊培研发、数字化培训业务积累和技术研究，综合焊接行业的特点，建立适配焊培企业的智能培训技术平台，并提供智能培训全流程的系列解决方案，帮助企业打通各业务系统、设备间的数据壁垒，从传统培训向数字化培训、智能培训转型。",

  // 场景1 - 山东某核电
  solution_detail_weldTraining_scene1_title: "山东某核电",
  solution_detail_weldTraining_scene1_introduce1: '● 结合奥太物联网焊机，使传统的实训室打造成为"xx客户智慧焊接培训基地"。',
  solution_detail_weldTraining_scene1_introduce2: "● 中控大屏终端实时显示整个实训室的培训项目情况。",
  solution_detail_weldTraining_scene1_introduce3: "● 每个工位显示终端显示现场相关信息。",
  solution_detail_weldTraining_scene1_introduce4: "● 无纸化流程，学员通过刷卡进行考试，并远程监控考试情况。",
  solution_detail_weldTraining_scene1_merit1: "硬件: 奥太焊机(PlusWSM-400a)具备联网(WiFi)、学员认证、学员刷卡领取任务、刷卡下发焊接工艺等功能。",
  solution_detail_weldTraining_scene1_merit2: "软件-考试流程: 焊培负责人将工艺、人员进行数据建档，由于客户已有数据文件，根据客户提供的模板，可直接将数据导入，不需要多次操作。",
  solution_detail_weldTraining_scene1_merit3: "软件-考试流程: 制定考试计划，在考试前将考试计划派工给学员。为学员提供考试专用卡，学员刷卡将工艺下传到设备开始进行考试。",
  solution_detail_weldTraining_scene1_merit4: "软件-信息监控: 中控大屏及工位终端可实时显示培训项目焊接信息、学员信息、焊接工艺规程、工位视频监控、焊接数据实时曲线。",

  // 场景2 - 某核电检修
  solution_detail_weldTraining_scene2_title: "某核电检修",
  solution_detail_weldTraining_scene2_introduce1: "● 完成焊接工艺规程建档，并与Excel中的技能评定项目关联。",
  solution_detail_weldTraining_scene2_introduce2: "● 导入或系统建立学员信息，提供资质认证功能。",
  solution_detail_weldTraining_scene2_introduce3: "● 在Excel编制实训焊件信息，与焊接工艺规程关联并快速导入。",
  solution_detail_weldTraining_scene2_introduce4: "● 设计主界面，显示焊接信息、工艺规程、视频监控、焊机曲线、学员信息。每工位配备一体机、摄像头、点阵屏。",
  solution_detail_weldTraining_scene2_introduce5: "● 实现焊接工艺下发至焊机，锁定焊接参数。",
  solution_detail_weldTraining_scene2_merit1: "硬件：中控大屏终端：实训室配备大屏看板，实时显示整个实训室的考试项目情况以及考试说明。",
  solution_detail_weldTraining_scene2_merit2: "硬件：工位显示终端：每个焊接工位均配备24寸一体机，显示器上会显示工位相关信息",
  solution_detail_weldTraining_scene2_merit3: "硬件：视频监控：每个焊接工位配备海康威视摄像头，实时监控工位信息。",
  solution_detail_weldTraining_scene2_merit4: "软件：软件实现了对产品、工艺和学员等数据的建档。",
  solution_detail_weldTraining_scene2_merit5: "软件：制定考试计划，并在考试前将计划分配给相应的学员。每位学员都会得到一张专用卡，通过刷卡，学员可以将相关工艺传输到设备，启动考试。",
  solution_detail_weldTraining_scene2_merit6: "软件：软实时展示培训项目的焊接信息、学员资料、焊接工艺规程、工位视频监控以及焊接数据的实时曲线。",

  // 场景3 - 广西某焊机培训学校
  solution_detail_weldTraining_scene3_title: "广西某焊机培训学校",
  solution_detail_weldTraining_scene3_introduce1: "● 建立产品、工艺、焊接材料等焊接资源中心。",
  solution_detail_weldTraining_scene3_introduce2: "● 学员信息、学员资质管理，方便后期对各学员进行焊接学习/焊接考试焊接培训过程中考试信息监控，无纸化流程提供适合车间看板的软件系统大屏。",
  solution_detail_weldTraining_scene3_merit1: "硬件:对现场设备进行改造，可进行工艺控制。",
  solution_detail_weldTraining_scene3_merit2: "硬件:设备具备联网、刷卡功能、离线数据上传功能。",
  solution_detail_weldTraining_scene3_merit3: "软件:产品、工艺、学员等数据建档。",
  solution_detail_weldTraining_scene3_merit4: "软件:制定考试计划，在考试前将考试计划派工给学员。",
  solution_detail_weldTraining_scene3_merit5: "软件:为学员提供考试专用卡，学员刷卡将工艺下传到设备开始进行考试。",
  solution_detail_weldTraining_scene3_merit6: "软件:可实时显示培训项目焊接信息、学员信息、焊接工艺规程、工位视频监控、焊接数据实时曲线。",

  // ==================== 详情 - 煤机 ====================
  solution_detail_coalMachine_text: '系统围绕人、设备、产品、工艺为中心，以"生产流程"为主线，实现焊接生产过程的规范化管理，设备全过程的管理及控制，做到工厂全方位智慧覆盖。',
  solution_detail_coalMachine_title: "煤机行业解决方案",
  solution_detail_coalMachine_summarize: "煤机领域智能制造解决方案由奥太智能研发中心打造，以资源高效利用、降本增效为目标，实现工厂人、机、料、法、环、测的规范化管理，建立完整的焊接质量数据追溯链，改良工厂目前管理、生产状况，建造工业物联网平台。",

  // 场景1 - 河南某煤机企业
  solution_detail_coalMachine_scene1_title: "河南某煤机企业",
  solution_detail_coalMachine_scene1_introduce1: "● 焊工焊接工时有效统计: 实时记录设备/焊工的工作时长，有效统计出设备利用率和焊工焊接效率。",
  solution_detail_coalMachine_scene1_introduce2: "● 焊接耗材统计: 统计实际焊接过程中所产生的耗材消耗，以设备或焊工为统计节点，以小时、天、月、年作为统计单位，可有效统计出车间的焊材消耗数量。",
  solution_detail_coalMachine_scene1_introduce3: "● 焊接数据监控: 可实时监控焊接电流、电压，以及远程下传焊接参数等。",
  solution_detail_coalMachine_scene1_merit1: "硬件: 对现场奥太Pulse MIG-500Ⅲ、以及WSME系列焊机采用奥太专用焊接联网设备进行入网。",
  solution_detail_coalMachine_scene1_merit2: "硬件: 实现断网情况下的离线存储功能，达到断点续传功能，保证焊接数据的连续性。",
  solution_detail_coalMachine_scene1_merit3: "软件: 建立产品数字化工艺库，实时监控焊接过程中各环节的工艺数据，屏蔽大电流焊接。",
  solution_detail_coalMachine_scene1_merit4: "软件: 系统内实现焊工人员信息统计，可实时检测焊材消耗，以及控制焊接参数范围。",
  solution_detail_coalMachine_scene1_merit5: "软件: 建立焊接资源一览表，实时掌握焊接资源信息以及焊接人员信息。",
  solution_detail_coalMachine_scene1_merit6: "软件: 与MES管理系统进行接口对接，远程下发焊接工艺，控制焊接范围。",

  // 场景2 - 贵阳某煤机企业
  solution_detail_coalMachine_scene2_title: "贵阳某煤机企业",
  solution_detail_coalMachine_scene2_introduce1: "● 现场为机器人生产线，实时监控机器人焊接工艺参数。",
  solution_detail_coalMachine_scene2_introduce2: "● 解决NBC系列焊机及机器人入网问题。",
  solution_detail_coalMachine_scene2_introduce3: "● 机器人工艺程序现场可视化设置，减少停机时间，提高生产效率。",
  solution_detail_coalMachine_scene2_introduce4: "● 实现数据远程共享，与MES系统进行数据接口对接问题。",
  solution_detail_coalMachine_scene2_merit1: "硬件: 对现场奥太NBC系列焊机及机器人采用奥太专用焊接联网设备进行入网。",
  solution_detail_coalMachine_scene2_merit2: "硬件: 焊接过程中超范围焊接现场报警。",
  solution_detail_coalMachine_scene2_merit3: "软件: 建立完整的焊接质量数据追溯链。",
  solution_detail_coalMachine_scene2_merit4: "软件: 系统内实现焊工人员信息统计，可实时检测焊材消耗，以及控制焊接参数范围。",
  solution_detail_coalMachine_scene2_merit5: "软件: 实现焊前资质认证、工艺自动下发焊机、焊接过程超范围焊接警功能。",
  solution_detail_coalMachine_scene2_merit6: "软件: 与MES管理系统进行接口对接，提供设备、焊工、成本等方面的各种报表，提供完整的数据服务。",

  // ==================== 详情 - 工程机械 ====================
  solution_detail_machinery_text: "满足工程机械业多种业务模式，从个性化的订单选配、多层级计划管理模式、复杂的物料齐套规划、频繁的设计变更管理、精细化制造执行和用料管控、精准的售后服务等行业特性，提供一站式整体解决方案。",
  solution_detail_machinery_title: "工程机械行业解决方案",
  solution_detail_machinery_summarize: "工程机械行业解决方案是在奥太智能焊接云系统基础上，面向工程机械行业并结合行业特点而开发，旨在解决工程机械行业客户的难点、痛点。系统实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。",

  // 场景1 - 工程机型龙头企业
  solution_detail_machinery_scene1_title: "工程机型龙头企业",
  solution_detail_machinery_scene1_introduce1: "● 打造使用机器人焊接、RGV运输的自动化产线。",
  solution_detail_machinery_scene1_introduce2: "● 如何获取工件当前所处工序以及当前焊接设备的实时状态。",
  solution_detail_machinery_scene1_introduce3: "● 提高产品质量。",
  solution_detail_machinery_scene1_introduce4: "● 与企业内部各系统之间进行交互，消除信息孤岛。",
  solution_detail_machinery_scene1_merit1: "机器人焊接自动化产线，自动化焊接效率达到83.4%；通过RGV在各工序间进行转运，进一步提高自动化率，减少安全事故发生的概率。",
  solution_detail_machinery_scene1_merit2: "系统智能调配产线计划以及为决策人员提供数据。",
  solution_detail_machinery_scene1_merit3: "建立产线3D大屏，物料在线实时查看，设备状态实时显示。",
  solution_detail_machinery_scene1_merit4: "与客户系统以接口方式对接，进行数据交互。",

  // 场景2 - 佛山某机械制造企业
  solution_detail_machinery_scene2_title: "佛山某机械制造企业",
  solution_detail_machinery_scene2_introduce1: "● 对现场多品牌焊机进行数据采集，实时监控设备电流、电压、气流量、送丝速度。",
  solution_detail_machinery_scene2_introduce2: "● 工艺下传，达到远程控制焊机电流、电压等工艺参数，超限报警。",
  solution_detail_machinery_scene2_introduce3: "● 焊接数据汇总，将提取到的数据进行汇总展示。",
  solution_detail_machinery_scene2_introduce4: "● 与企业内系统进行交互，打通信息闭环。",
  solution_detail_machinery_scene2_merit1: "硬件：对现场采用奥太专用焊接联网设备进行改造，实现多品牌焊机入网，设备具有较强的抗干扰特性以及采集数据准确性特点。",
  solution_detail_machinery_scene2_merit2: "硬件：增加刷卡设备，焊工可以通过饭卡来控制设备的开关以及工艺下传。",
  solution_detail_machinery_scene2_merit3: "软件：建立产品数字化工艺库，实时监控焊接过程中各环节的工艺数据，屏蔽大电流焊接、无资质焊接。",

  // 场景3 - 山东某工程机械企业
  solution_detail_machinery_scene3_title: "山东某工程机械企业",
  solution_detail_machinery_scene3_introduce1: "● 办公室远程监控。",
  solution_detail_machinery_scene3_introduce2: "● 焊接成本统计。",
  solution_detail_machinery_scene3_introduce3: "● 设备KPI大屏。",
  solution_detail_machinery_scene3_introduce4: "● 可以远程监控现场生产情况。",
  solution_detail_machinery_scene3_merit1: "以人员、组织结构、焊机等多维角度进行成本统计，充分挖掘有效数据，为客户决策提供基础。",
  solution_detail_machinery_scene3_merit2: "一目了然的了解近期设备各项指标，充分了解设备使用情况。",

  // ==================== 详情 - 管道 ====================
  solution_detail_piping_text: '管道行业解决方案是以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台，结合客户现场焊接设备，辅助用户建立数字化焊接的一整套解决方案，对焊接现场的"人、机、料、法"进行全方位的智能化管理的信息化系统',
  solution_detail_piping_title: "管道行业解决方案",
  solution_detail_piping_summarize: '管道行业解决方案是以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台，结合客户现场焊接设备，辅助用户建立数字化焊接的一整套解决方案，对焊接现场的"人、机、料、法"进行全方位的智能化管理的信息化系统。',

  // 场景1 - 河北某管道研究院
  solution_detail_piping_scene1_title: "河北某管道研究院",
  solution_detail_piping_scene1_introduce1: "● 设备方面：保障设备利用率，降低停机率，提高生产效率",
  solution_detail_piping_scene1_introduce2: "● 人员方面：精准记录和统计焊工工时、效率",
  solution_detail_piping_scene1_introduce3: "● 工艺方面：有效贯彻执行WPS工艺规范",
  solution_detail_piping_scene1_introduce4: "● 品质方面：精准记录和追溯焊接数据",
  solution_detail_piping_scene1_merit1: "设备方面：所有设备入网管理，精准记录开机时间、关机时间、工作数据，并计算统计",
  solution_detail_piping_scene1_merit2: "人员方面：焊工与设备关联，精准记录焊工工时，辅以可视化界面，直观展示焊工工作效率",
  solution_detail_piping_scene1_merit3: "工艺方面：工艺和WPS规范信息下传至焊接和控制系统，并严格控制焊机和控制系统参数符合工艺要求",
  solution_detail_piping_scene1_merit4: "品质方面：焊接记录单机焊接数据自动获取保存，没有中间环节及人工操作，保证数据真实可靠",

  // 场景2 - 临沂某长输管道客户
  solution_detail_piping_scene2_title: "临沂某长输管道客户",
  solution_detail_piping_scene2_introduce1: "● 施工/焊接数据采集技术研究，对焊接过程实时跟踪，及早发现质量隐患，减少重大质量问题的出现",
  solution_detail_piping_scene2_introduce2: "● 偏远地区数据高效传输技术研究，解决隧道等受限空间及河流山谷跨越的施工环境艰苦恶劣，工作人员多，人员不安全行为等潜在隐患",
  solution_detail_piping_scene2_merit1: "整个管控系统从坡口、预热、根焊、热焊、填充、盖面、无损检测、防腐检测以及整个过程的环境监测和GPS定位，实时检测各工序的相关数据以及做出相应的数据分析",

  // ==================== 详情 - 船舶 ====================
  solution_detail_ship_text: "船舶解决方案是随着物联网、云计算等技术的发展，积极开展船舶制造智能化研究及现场应用，是面对行业技术发展的必然选择，对于施工单位而言，不论业主方是否提出有关要求，具备焊接数据实时采集、存储、分析的能力，除了促进焊接技术水平的提升外，还能在市场竞争中形成专有技术优势，提高公司市场竞争力的有效手段。并根据客户的实际需求，为了满足企业不同的生产计划及流程，提供定制化解决方案。",
  solution_detail_ship_title: "船舶行业解决方案",
  solution_detail_ship_summarize: "奥太5G智慧焊接系统为船舶制造企业搭建了一个安全、可靠的焊接信息化管理平台，实现了一体化集成管控，得以充分发挥信息化、自动化的综合管理效益，全面提高了企业的精细化生产管理水平。它不仅仅作为企业信息化平台的数据底层，肩负起现场数据采集、焊机监控及控制的重任，也能为焊接数据分析提供坚实的支撑。奥太智慧焊接系统可以作为企业数字化转型、智能经济、数字经济和云端化的基础，助力企业向智能制造转型升级。",

  // 场景1 - 大连某船舶客户
  solution_detail_ship_scene1_title: "大连某船舶客户",
  solution_detail_ship_scene1_introduce1: "● 绩效考核难：船体较大，船舱的焊工工时无有效监管，如何掌握焊工工作量制定合理的绩效考核政策。",
  solution_detail_ship_scene1_introduce2: '● 工作协调难：难以将生产过程中的"人机料法环测"实现闭环管理、数字化、智能化的协同管理。',
  solution_detail_ship_scene1_introduce3: "● 人员管理难：人员结构复杂，外包队、施工队、本企业焊工混杂，焊接资质与焊接质量参差不齐，焊接数据无法溯源。",
  solution_detail_ship_scene1_introduce4: "● 设备管控难：船厂焊机设备保有量大，分布占地面积广，焊机利用率与维修保养时效较低，统一调度协调难",
  solution_detail_ship_scene1_merit1: "焊接设备数字化：焊接设备网络化改造，通讯过程加密，快速实现焊机参数自动采集及远程控制",
  solution_detail_ship_scene1_merit2: "焊接过程规范化：规范人、机、料、发、环、测试等各环节焊接生产要素参与角色的工作流程",
  solution_detail_ship_scene1_merit3: '焊接系统集成化：与企业MES、ERP等系统互联互通，实现数据共享，避免"信息孤岛"',
  solution_detail_ship_scene1_merit4: '焊接工厂智慧化：通过多个方面的技术集成和流程优化，消除生产过程瓶颈点，完成"智慧焊接工厂"建设',
  
  },
  case: {
      // ==================== Banner ====================
      case_banner_title: "应用案例",
      case_banner_subtitle: "服务于高铁、船舶、机械、钢构、冶金、石化等不同行业",
      
      // ==================== 面包屑 ====================
      case_breadcrumb_home: "首页",
      case_breadcrumb_current: "应用案例",
      
      // ==================== 菜单分类 ====================
      case_menu_pressureVessel: "压力容器行业",
      case_menu_mechanical: "机械制造行业",
      case_menu_weldingTraining: "焊培行业",
      case_menu_coalMachine: "煤机行业",
      case_menu_steelStructure: "钢结构行业",
      case_menu_piping: "管道行业",
      case_menu_ship: "船舶行业",
      
      // ==================== 卡片通用 ====================
      case_card_deliveryDate: "交付日期：",
      case_card_weldingQuantity: "焊接数量：",
      case_card_viewMore: "查看更多",
      
      // ==================== 压力容器行业案例 ====================
      case_pressureVessel_1_text: "此客户是世界炼油用加氢反应器的最大供货商，根据国家有关部门要求，必须将原始焊接记录单生成电子版文档进行打印、存档以备追溯。此客户是世界炼油用加氢反应器的最大供货商，根据国家有关部门要求，必须将原始焊接记录单生成电子版文档进行打印、存档以备追溯。",
      case_pressureVessel_1_title: "辽宁某压力容器客户",
      
      case_pressureVessel_2_text: "企业专注于设备制造能力的资源综合利用型的环境工程。主要产品分为环境工程项目、大型铆焊、工业锅炉系列三大类产品。",
      case_pressureVessel_2_title: "山东某压力客户",
      
      // ==================== 机械制造行业案例 ====================
      case_mechanical_1_text: "公司致力于为水电、制浆造纸、金属以及分离技术四大业务领域以及许多其它行业和产品提供技术和解决方案。",
      case_mechanical_1_title: "广东某机械外企",
      
      // ==================== 焊培行业案例 ====================
      case_weldingTraining_1_text: '致力于"建设精品核电工程，创造良好运行业绩，培育优秀员工队伍，提供满意投资回报，奉献低碳绿色能源"，着力打造建设一流、运营一流、管理一流核电企业。',
      case_weldingTraining_1_title: "山东某核电企业",
      
      case_weldingTraining_2_text: "经教育部批准成立的一所公办全日制普通高等职业院校，全国高职高专院校人才培养工作水平评估优秀学校，国家示范性高职建设重点培育8所院校之一，国家创新发展行动计划优质校。",
      case_weldingTraining_2_title: "广西某焊机培训学校",
      
      // ==================== 煤机行业案例 ====================
      case_coalMachine_1_text: "主营产品为矿用液压支架，液压支架产品装备了全国大型煤炭基地的1700多个工作面，轨道车辆、钢箱桥梁、衬砌台车等产品逐步走向规模化、产业化发展道路。。",
      case_coalMachine_1_title: "河南某煤机企业",
      
      case_coalMachine_2_text: "主要经营煤炭工程行业的成套设备、机电产品、防爆电气产品、安全技术装备、瓦斯发电机的设计、生产、供应、技术服务;备品配件的生产、经销;",
      case_coalMachine_2_title: "贵州某煤机企业",
      
      // ==================== 钢结构行业案例 ====================
      case_steelStructure_1_text: "是专业制造钢桥梁、钢结构、铁路道岔、城市轨道交通设备、大型起重机械的大型国有企业",
      case_steelStructure_1_title: "江苏某钢结构企业",
      
      // ==================== 管道行业案例 ====================
      case_piping_1_text: "公司拥有油气长输管道流动保障、仿真优化、管道添加剂、管道完整性管理和管道泄漏检测与安全预警等技术",
      case_piping_1_title: "河北某管道企业",
      
      case_piping_2_text: "承担了国内外多项油气管道工程、地面和地下大型油气储备库、民宅和医院建筑等工程项目管理、EPC承包、施工监理、咨询服务、技术服务、设备监造服务等任务。",
      case_piping_2_title: "四川某管道企业",
      
      // ==================== 船舶行业案例 ====================
      case_ship_1_text: "随着物联网、云计算等技术的发展，积极开展船舶制造智能化研究及现场应用，是面对行业技术发展的必然选择，是提高公司市场竞争力的有效手段。对于施工单位而言，不论业主方是否提出有关要求，具备焊接数据实时采集、存储、分析的能力，除了促进焊接技术水平的提升外，还能在市场竞争中形成专有技术优势，提高行业竞争力；对于工艺设计单位而言，加强船舶智能化工艺系统的深入研究，进一步扩充、优化现有一体化信息体系，在今后项目设计的前期，有利于提出更完整、全面的智能化方案，拓展公司智能化业务，形成闭环产业链，形成新的经济增长点",
      case_ship_1_title: "大连某船舶企业",
  },

  news: {
  // ==================== Banner ====================
  news_banner_title: "新闻资讯",
  news_banner_subtitle: "以客户的成功定义成功，赋能企业管理，来自企业的信赖",
  
  // ==================== 面包屑 ====================
  news_breadcrumb_home: "首页",
  news_breadcrumb_news: "新闻资讯",
  
  // ==================== 分类 ====================
  news_type_mediaReport: "媒体报道",
  news_type_companyNews: "公司新闻",
  
  // ==================== 列表通用 ====================
  news_list_title: "新闻列表",
  news_card_viewDetail: "查看详情",
  
  // ==================== 详情通用 ====================
  news_detail_previous: "上一条",
  news_detail_next: "下一条",
  news_detail_noMore: "没有了",
  
  // ==================== 新闻标题 ====================
  news_title_20250702: '奥太智能焊接云系统上榜2025年度船舶工业"强链品牌"产品！',
  news_centent_20250702: '近日，中国船舶工业行业协会(以下简称"中国船协")组织开展了2025年度船舶工业"强链品牌"产品申报和认定工作，根据中国船舶工业行业协会《船舶工业"强链品牌"产品认定办法(试行)》，经企业自愿申报、中国船协组织专家依据《T/CANSI148-2023 船舶工业强链品牌产品认定规范》进行审查，共29家船舶工业企业的43项产品符合认定条件:奥太智能焊接云系统成功上榜"2025年度船舶工业"强链品牌"产品。',
  
  news_title_20250617: "【埃森展·智能焊接云系统】奥太智能焊接云系统-智能化焊接全方位解决方案",
  news_centent_20250617: "【埃森展·智能焊接云系统】奥太智能焊接云系统-智能化焊接全方位解决方案",
  
  news_title_20240819: "奥太上榜2024年度济南市数字化转型诊断服务商名单！",
  news_centent_20240819: '近几年山东奥太不断打破传统焊接行业的模式,大力发展"绿色、高效、智能"焊接装备及技艺,并且已经逐步建立起自己的智能焊接生态圈,在今年的第27届北京·埃森焊接与切割展览会上受到业内人士和合作伙伴们的广泛关注和认可。未来,山东奥太将持续为制造行业绿色化、数字化、智能化的转型升级注入能量。',
  
  news_title_20230703: '奥太上榜2023年度山东省"十强"产业集群领军企业名单！',
  news_centent_20230703: '奥太作为国家制造业单项冠军和两次国家科技进步二等奖获奖企业，始终坚定落实国家"双碳"和新旧动能转换战略，我们持续在焊接工艺上研究和创新，始终致力于为行业提供绿色、高效、智能的高端焊接装备，近两年，我们逐步建立起的智能化焊接生态系统，在推动国家制造业转型升级方面做出贡献。',
  
  news_title_20230625: '【埃森展·亮点之智能焊接云系统】奥太智能焊接云系统——助力企业实现"智慧焊接工厂"转型升级',
  news_centent_20230625: '【埃森展·亮点之智能焊接云系统】奥太智能焊接云系统——助力企业实现"智慧焊接工厂"转型升级',
  
  news_title_20221121: "奥太电气上榜2022年度工业互联网平台！",
  news_centent_20221121: "奥太电气上榜2022年度工业互联网平台！",
  
  news_title_20220701: '奥太上榜"2022年济南市工业互联网APP优秀解决方案项目名单"！',
  news_centent_20220701: '奥太上榜"2022年济南市工业互联网APP优秀解决方案项目名单"！',
  
  news_title_20211221: '奥太上榜"2021年山东知名品牌认定名单"和"2021年度山东优质品牌产品名单"！',
  news_centent_20211221: '双喜临门——奥太上榜"2021年山东知名品牌认定名单"和"2021年度山东优质品牌产品名单"！',
  
  news_title_20211101: "奥太入选2021年度山东省科技领军企业！",
  news_centent_20211101: "奥太入选2021年度山东省科技领军企业！",
  
  news_title_20211012: '奥太荣登"2021年新一代信息技术与制造业融合发展试点示范名单"！',
  news_centent_20211012: '奥太荣登"2021年新一代信息技术与制造业融合发展试点示范名单"！',
  
  news_title_20210517: '奥太成功入选"2021年度山东省高端品牌培育企业"！',
  news_centent_20210517: '奥太成功入选"2021年度山东省高端品牌培育企业"！',
  
  news_title_20201221: "奥太电气三大榜单均榜上有名！",
  news_centent_20201221: "奥太电气三大榜单均榜上有名！",
  
  news_title_20200420: '奥太再上榜山东省第二批"现代优势产业集群+人工智能"试点示范企业及项目名单 《基于激光视觉及云技术的智能焊接系统及应用》！',
  news_centent_20200420: '奥太再上榜山东省第二批"现代优势产业集群+人工智能"试点示范企业及项目名单 《基于激光视觉及云技术的智能焊接系统及应用》！',
  
  news_title_20200416: '奥太成功入围济南市"5G+工业互联网"应用试点项目"《专用汽车制造焊接工艺高速数据监控管理系统》',
  news_centent_20200416: '奥太成功入围济南市"5G+工业互联网"应用试点项目"《专用汽车制造焊接工艺高速数据监控管理系统》',
  
  news_title_20190527: '奥太上榜山东省首批"现代优势产业集群+人工智能"试点示范企业',
  news_centent_20190527: '奥太上榜山东省首批"现代优势产业集群+人工智能"试点示范企业',

  // ==================== 新闻详情内容 ====================
  // 20250617 详情
  news_content_20250617_1: '6月17-20日，奥太亮相在上海新国际博览中心举行的全球焊割盛会——"第28届北京•埃森焊接与切割博览会"，展会期间，奥太展位人气爆棚，始终被参观者的热情包裹，再一次印证了奥太国内焊割行业领先者的地位，也向世界展示了奥太智能化焊接的新风貌。',
  news_content_20250617_2: "奥太展区主要分为工业机器人焊接展区、协作机器人智能弧焊系统、坡口切割行业工艺展区、钢结构行业工艺展区、压力容器行业工艺展区、智能焊接云系统体验区、手工焊接展区和静态焊机展区。",
  news_content_20250617_3: '智能焊接云系统平台，由山东奥太电气有限公司结合国家标准及企业焊接现场实际生产管理与控制现状自主研发的综合化服务平台，平台深入分析"人机料法环测"全面质量管理理论中的影响产品质量的主要因素， 借助工业互联网平台，运用物联网、云计算、边缘计算、智能检测控制等技术，实现从企业资源计划承接分配到车间的生产订单，焊前准备、焊接过程管理及控制、焊后质量检测并形成完整的产品完工资料。',
  news_content_20250617_4: "全方位解决企业现存焊接生产问题--智能焊接云系统应用价值",
  news_content_20250617_5: "该平台已广泛应用于船舶、压力容器、钢结构、汽车制造、船舶、航空航天等行业，针对焊接工艺要求严格， 焊接工艺规程设计复杂，焊接记录单人工记录纸质流转，焊接任务人工分配效率低的问题，采用智能焊接云系统对内能有效地缩短产品制造周期， 未关机设备提醒减少人工巡查，智能维保提醒延长设备使用寿命，更好的为企业配置、整合、优化生产要素，提高生产力，焊接工艺精细控制，提高产品质量，提升产品核心竞争力， 同时对外借助工业互联网平台，更好的提高企业科技水平，进而聚合优质资源助力企业快速发展。",

  // 20230703 详情
  news_content_20230703_1: '奥太作为国家制造业单项冠军和两次国家科技进步二等奖获奖企业，始终坚定落实国家"双碳"和新旧动能转换战略，我们持续在焊接工艺上研究和创新，始终致力于为行业提供绿色、高效、智能的高端焊接装备，近两年，我们逐步建立起的智能化焊接生态系统，在推动国家制造业转型升级方面做出贡献。',

  // 20230625 详情
  news_content_20230625_1: "全新技术平台--智能焊接云系统平台",
  news_content_20230625_2: "奥太自主研发的智能焊接云系统，可实现从企业资源计划承接分配到车间的生产订单，焊前准备、焊接过程管理及控制、焊后质量检测并形成完整的产品完工资料，与企业的MES、ERP等系统实现数据交互，完善企业生产环节信息化建设。",
  news_content_20230625_3: " 车间设备：支持车间内奥太焊机集中化管理及控制，针对焊工可配备车间终端或者手持终端设备；显示方面可采用车间看板方式；",
  news_content_20230625_4: " 通讯网络：根据车间网络实际情况，用户可选择焊机、车间终端设备采用以太网/WIFI/4G/5G/方式；",
  news_content_20230625_5: " 系统应用：奥太智能焊接云系统具备基础功能模块供用户免费使用，也可根据用户需求进行定制化开发；",
  news_content_20230625_6: '系统集成：与MES、ERP等系统互联互通，实现数据共享，为实现基于工业4.0的"智慧焊接工厂"夯实基础。',
  news_content_20230625_7: "全覆盖设备入网方案--奥太所有型号焊机",
  news_content_20230625_8: "2022年已完成奥太在售所有型号焊机的入网，2023年推出最新平台的PLUS、Pro系列、机器人配套电源以及奥太模拟焊机NBC系列等。NBC、PLUS、Pro等系列设备均以焊机内置群控主板的方式，接入奥太智能焊接云系统，其中机器人配套电源以群控集成至网关通讯盒实现群控系统各功能模块。",
  news_content_20230625_9: "全方位解决企业现存焊接生产问题--智能焊接云系统应用价值",
  news_content_20230625_10: "设备展板：实时监测每台设备状态，掌握每台设备工作详情，以及掌控整体车间设备使用详情，利用人工干预，减少资源浪费。",
  news_content_20230625_11: "成本统计：通过焊接数据的采集以及统计，可生成资源一览表进行数据分析。统计每台设备工作时长、焊丝消耗量、气体消耗量，进行数据对比，达到了降本增效的目的。",
  news_content_20230625_12: "视频监控：可接入车间或工位视频，实现操作详情监控。",
  news_content_20230625_13: "设备利用率：可以以车间为单位或者以焊机、焊工为单位统计某一时间的设备利用率。",
  news_content_20230625_14: "环境监测：实监测车间环境温度、湿度等信息。",
  news_content_20230625_15: "产品监控：整体把控车间生产详情，把握生产进度查询。实时监测焊接规范，实际焊接电流、电压超不出工艺卡预设范围。同时焊接过程电流、电压信息数据库为工程技术人员后续分析研究提供可供追溯的数据。",
  news_content_20230625_16: "提高产品合格率：在焊接过程中控制焊接参数的输出，严格按照产品WPS要求进行焊接，提高产品焊接质量的同时也提高整体产品合格率。",
  news_content_20230625_17: "广泛应用案例--各焊接行业",

  // 20190527 详情
  news_content_20190527_1: '23日举行的山东省政府新闻发布会上，由山东省工业和信息化厅牵头启动的"现代优势产业集群+人工智能"试点示范企业及项目名单正式出炉，山东奥太电气有限公司"基于云数据的智能焊接机器人"项目成功上榜。',
  news_content_20190527_2: ' 此次发布的名单分为"人工智能产业"和"融合发展"两个方向，共计150个企业和项目，其中包括奥太在内的30个企业和项目入选"人工智能产业"方向，成为名单里的重中之重，也是山东省将着重在智能产品、核心基础、关键技术装备等领域培育的一批优秀产品和解决方案。',
  news_content_20190527_3: '"现代优势产业集群+人工智能"试点示范企业及项目在报名后经专家评审论证、网上公示等程序遴选，旨在选出一批可以最大程度发挥示范带动作用的，能够与国内外人工智能领军企业进行优势对接与供需对接的企业和项目，以推动新一代人工智能科技革命的发展。奥太成功入选"现代优势产业集群+人工智能"试点示范企业，将激励我们继续发挥企业优势，在包括人工智能在内的多个领域建立更加完善的研发、生产、销售链条，加大力度为推动产业智能化发展贡献力量。',
},

resource: {
  // ==================== 资料下载 - Banner ====================
  resource_download_banner_title: "资料下载",
  resource_download_banner_subtitle: "奥太电气智能制造产品与方案助力企业加速数字化转型升级",
  
  // ==================== 行业标准 - Banner ====================
  resource_standard_banner_title: "行业标准",
  resource_standard_banner_subtitle: "全球重要的焊接标准认证",
  
  // ==================== 视频资料 - Banner ====================
  resource_video_banner_title: "视频资料",
  resource_video_banner_subtitle: "奥太电气视频资源",
  
  // ==================== 焊工小知识 - Banner ====================
  resource_weldKnowledge_banner_title: "焊工知多少？",
  resource_weldKnowledge_banner_text: "从焊工证了解特征作业证、职业资格证、特种设备设备焊工证的区别",
  
  // ==================== 面包屑 ====================
  resource_breadcrumb_home: "首页",
  resource_breadcrumb_resourceCenter: "资料中心",
  resource_breadcrumb_download: "资料下载",
  resource_breadcrumb_standard: "行业标准",
  resource_breadcrumb_video: "视频资料",
  resource_breadcrumb_weldKnowledge: "焊工小知识",
  
  // ==================== 分类标签 ====================
  resource_type_illustrate: "说明书",
  resource_type_material: "样本资料",
  resource_type_video: "视频资料",
  resource_type_program: "应用程序",
  
  // ==================== 行业标准 ====================
  resource_standard_title: "行业标准",
  resource_standard_pressureVessel: "压力容器行业标准",
  resource_standard_steelStructure: "钢结构行业标准",
  resource_standard_ship: "造船行业标准",
  resource_standard_machinery: "机械制造行业标准",
  resource_standard_nuclear: "核电行业标准",
  resource_standard_piping: "管道行业标准",
  
  // ==================== 使用说明书 ====================
  resource_illustrate_1_name: "掌上群控使用说明书",
  resource_illustrate_2_name: "掌上运维使用说明书",
  resource_illustrate_3_name: "智能焊接云系统使用说明书",
  
  // ==================== 宣传资料 ====================
  resource_material_1_name: "奥太智能焊接系统宣传样本",
  resource_material_2_name: "压力容器焊接管理系统宣传样本",
  resource_material_3_name: "智慧焊培管理系统宣传样本",
  resource_material_4_name: "钢结构焊接管理系统宣传样本",
  
  // ==================== 视频资料 ====================
  resource_video_1_name: "奥太智能焊接云系统",
  resource_video_2_name: '[山东新闻联播]数字强省看山东 | 焊接上"云" 手工艺实现智能化',
  
  // ==================== APP下载 ====================
  resource_program_1_name: "掌上群控APP",
  resource_program_2_name: "掌上运维APP",
  
  // ==================== 焊工小知识 - 内容 ====================
  resource_weldKnowledge_content_1: "很多人知道焊工证，但是并不一定完全不了解焊工证；比如焊工证证书是什么样的呢? 焊工证由什么部门颁发? 焊工证是怎么考的？ 接下来为大家来介绍下焊工证。",
  
  resource_weldKnowledge_title_1: "一、应急管理厅特种操作证",
  resource_weldKnowledge_content_2: "焊工证，也被称为焊工上岗证或熔化焊接与热切割作业证，是由应急管理部（原安监局）颁发的像身份证一样大小，是IC卡形式的。这是焊工从事相关作业时必须持有的证件，具有极强的法律效应。也就是说，如果焊工在某个单位任职，如果遇到相关部门进行安全检查，一旦查出没有焊工操作证却从事相关工作，不仅会被开除，还要追究单位的责任，尤其是当发生安全事故时，没有证书就会处于劣势。",
  resource_weldKnowledge_content_3: "焊工操作证不分等级，一般只要是从事金属焊接切割作业(电焊、气焊、弧焊、电焊气割)等工作，都是领取同一种焊工操作证，不需要细化，证书带磁卡，全国通用。",
  resource_weldKnowledge_content_4: "IC卡版证书样本",
  resource_weldKnowledge_content_5: "如何查询焊工证的真伪? 电工特种操作证是由应急管理厅颁发，所以在应急管理厅官网即可查明真伪。",
  resource_weldKnowledge_content_6: "证书查询：特种作业操作证查询",
  
  resource_weldKnowledge_title_2: "二、焊工职业资格证",
  resource_weldKnowledge_content_7: '焊工职业资格证书俗称"等级证"共分为五个级别，代表了焊工的不同技术技巧能力,是由当地人社部(全称人力资源与社会保障局(厅))颁发的国家级职业资格证书，要先经过统一组织培训考试，考试合格后才能进行职业资格鉴定并领取证书，焊工职业资格证不是上岗必须要的证件， 主要用于评定焊工的技术等级和工资等级标准。但在任职中对升职、加薪、职称评定有效，而且还可以申请国家补贴，焊工资格证是永久有效的，不需要复审。',
  resource_weldKnowledge_content_8: "焊工资格证样本",
  resource_weldKnowledge_content_9: "如何查询焊工证的真伪? 焊工职业资格证是由人力资源和社会保障部颁发的",
  resource_weldKnowledge_content_10: "证书查询:",
  
  resource_weldKnowledge_title_3: "三、特种设备作业焊工证",
  resource_weldKnowledge_content_11: "特种设备作业焊工证，也被称为压力容器焊工证，主要针对压力容器的焊接人员。由质监局颁发，是从事压力容器焊接必备的一个从业证书。因为承压类和管道焊接对焊接技术的要求是比较高的，第一是要确保安全，第二就是要确保焊接的质量合格，这时候就需要我们持有焊工的特种设备作业证了。",
  resource_weldKnowledge_content_12: "特种设备作业焊工证样本",
  resource_weldKnowledge_content_13: "如何查询焊工证的真伪? 　特种设备焊接证，也称压力容器焊工证，由质监局颁发",
  resource_weldKnowledge_content_14: "查询网址: ",
  
  resource_weldKnowledge_title_4: "四、建筑焊工证",
  resource_weldKnowledge_content_15: "建设厅的焊工证只使用于建筑行业使用、全称建筑施工特种作业操作资格证、证书每2年进行一次复审。因为现在焊工证还不是统一发放的，它的管辖部门是建设厅，发证单位是直辖市的为当地建交委，省级单位是当地城乡建设厅。而且焊工从事的行业也比较纷杂，建设厅颁发的证件主要是针对建筑行业。",
  resource_weldKnowledge_content_16: "建筑焊工证样本",
  resource_weldKnowledge_content_17: "如何查询焊工证的真伪? 建筑焊工是由建设部门颁发，登录发证地建设厅官网进行查明真伪。",
  resource_weldKnowledge_content_18: "综上所述，应急管理厅特种操作证、焊工职业资格证、特种设备作业焊工证以及建筑焊工证在颁发机构、目的、适用范围和重要性等方面都存在差异。每种证书都有其特定的应用领域和价值，焊工可以根据自身的工作需求和发展方向选择合适的证书进行考取。",
  
  resource_weldKnowledge_title_5: "焊工证报考条件及资料",
  resource_weldKnowledge_content_19: "1、年满18周岁-60周岁之间",
  resource_weldKnowledge_content_20: "2、具有相应的操作能力，身体无重大疾病",
  resource_weldKnowledge_content_21: "3、身份证复印件",
  resource_weldKnowledge_content_22: "4、本人蓝底寸照",
  resource_weldKnowledge_content_23: "5、本人初中及以上学历证明",
},

about: {
  // ==================== Banner ====================
  about_banner_title: "联系我们",
  about_banner_subtitle: "坚持自主创新，赋能中国工业创新发展",
  
  // ==================== 面包屑 ====================
  about_breadcrumb_home: "首页",
  about_breadcrumb_contact: "联系我们",
  
  // ==================== 行业业绩数据 ====================
  about_counter_industry: "合作行业",
  about_counter_industry_en: "INDUSTRY",
  about_counter_client: "合作客户",
  about_counter_client_en: "CLIENT",
  about_counter_equipment: "入网设备",
  about_counter_equipment_en: "EQUIPMENT",
  about_counter_employee: "核心研发",
  about_counter_employee_en: "EMPLOYEE",
  
  // ==================== 联系我们 ====================
  about_contact_tagline: "Contact with us",
  about_contact_title: "联系我们",
  about_contact_text: "我们基于创造性的思想与先进的技术，创新和运营高客户价值的产品与服务，帮助客户实现发展目标，进而推动智能制造进步。",
  
  // 地址
  about_contact_address_label: "总部地址",
  about_contact_address_value: "济南市高新开发区伯乐路282号",
  
  // 销售热线
  about_contact_phone_label: "销售热线",
  about_contact_phone_manager_wang: "王经理",
  about_contact_phone_manager_xu: "许经理",
  
  // 邮箱
  about_contact_email_label: "E-mail",

  company_address: "公司地址",
  about_ten: "万",
},

experience: {
  // ==================== 产品卡片 ====================
  experience_weldCloud_title: "智能焊接云系统",
  experience_weldCloud_text: "智能焊接云平台是由山东奥太电气有限公司结合国家标准及企业焊接现场实际生产管理与控制现状自主研发的综合化服务平台",
  
  experience_pressureVessel_title: "压力容器焊接管理系统",
  experience_pressureVessel_text: "压力容器焊接管理系统是在奥太智能焊接云系统的基础上进行行业方向特殊化的改进，是由智能研发中心针对压力容器行业客户的焊接现场需求自主研发的信息化系统。它实时响应客户需求、不断的改进及优化，以求更好地助力企业发展。",
  
  experience_steelStructure_title: "钢结构焊接管理系统",
  experience_steelStructure_text: "钢结构焊接管理系统是一套综合性的管理系统，旨在提高钢结构焊接的效率和质量。该系统通过集成多种先进技术，如智能数据采集设备、物联网、大数据分析等，对钢结构焊接的全过程进行监控和管理。",
  
  experience_weldTraining_title: "智慧焊培管理管理系统",
  experience_weldTraining_text: "智慧焊培管理系统实现焊工资质信息全面数字化管理，优化焊工考试和培训流程，提升操作效率。并通过可视化管理，使焊培中心的运营更加透明和可监控。整合各标准体系，全面管理焊工培训考试流程。",
  
  experience_robotSystem_title: "智能焊接机器人系统",
  experience_robotSystem_text: "智能焊接机器人系统（iCloudRobot）是面向焊接机器人设备使用者、焊接设备厂商打造的以焊接系统为中心的网络化、信息化、自动化、智能化服务系统平台。",
  
  experience_weldSeamTracking_title: "智能焊缝跟踪系统",
  experience_weldSeamTracking_text: "智能焊缝跟踪系统是一个专门用于管理焊缝跟踪数据与工艺文件的系统。这个系统主要用于处理和存储来自焊缝跟踪设备的数据，并提供数据分析和可视化工具，帮助用户更好地理解和控制焊接过程，提高焊接质量和效率。",
  
  experience_weldCloudV2_title: "智能焊接云系统V2.0",
  experience_weldCloudV2_text: "智能焊接云系统V2.0 是由山东奥太电气有限公司以精准赋能焊接全过程，不断提高焊接管理精细化水平而自主研发的焊接管控信息化系统。借助于工业物联网平台，运用边缘计算、智能检测控制等技术，旨在为行业用户提高焊接生产过程感知、预测决策和智能执行的能力，进一步降低企业焊接成本的综合管理系统。",
  
  experience_weldCode_title: "焊码系统",
  experience_weldCode_text: "焊码系统包含了设备资料管理以及设备远程升级支持，旨在降低设备使用成本、提高设备使用效率。",
  
  experience_database_title: "奥太资料库",
  experience_database_text: "该系统提供了说明书、宣传资料、宣传视频等产品使用相关电子文档管理，旨在节省材料打印纸张、通过信息化手段推广产品以及快速迭代产品资料。",
},

seek: {
  // ==================== 弹窗标题 ====================
  seek_dialog_title: "联系我们",
  seek_dialog_title_resource: "查看资料",
  // ==================== 提示文案 ====================
  seek_dialog_tip: "请提供下列信息以便于我们把您的请求转给相应人员，使您能够尽早得到答复。",
  seek_dialog_tip_resource: "请填写手机号和其他信息，即可查看资料。",

  // ==================== 表单标签 ====================
  seek_form_telPhone: "你的手机号",
  seek_form_name: "你的姓名",
  seek_form_productName: "产品名称",
  seek_form_company: "企业名称",
  seek_form_email: "你的邮箱",
  seek_form_Industry: "行业名称",
  
  // ==================== 表单校验 ====================
  seek_form_telPhone_required: "请输入手机号码",
  seek_form_telPhone_pattern: "请输入正确的手机号",
  
  // ==================== 按钮 ====================
  seek_btn_cancel: "取 消",
  seek_btn_submit: "立即预约",
  seek_btn_view: "立即查看",
  // ==================== 提交成功 ====================
  seek_submit_success: "提交成功，将在一到三个工作日内与您取得联系！",
  
  // ==================== OA消息模板 ====================
  seek_oa_title: "申请体验------ ",
  seek_oa_phone: "电话：",
  seek_oa_name: "姓名：",
  seek_oa_productName: "产品名字：",
  seek_oa_company: "企业名称：",
  seek_oa_email: "邮箱：",
  seek_oa_domain: "请求域名：",
  seek_oa_notFilled: "未填",

  seek_btn: "申请体验",

}

}